import * as fr from "react/jsx-runtime";
import { jsx as E, jsxs as be, Fragment as Er } from "react/jsx-runtime";
import * as Oe from "react";
import hn, { useCallback as ye, createContext as pn, useContext as ii, useRef as Qt, useState as we, useEffect as tr, version as Aa, cloneElement as Fn, forwardRef as ni, Children as Be, Component as ae, Fragment as Kr, useMemo as zn, useId as Ia } from "react";
import { IconXSolid as Oa, IconWarningSolid as Ba, IconStopLine as Pa, IconArrowEndLine as Da, IconDocumentLine as Ma, IconExternalLinkLine as Fa, IconQuizLine as za, IconDiscussionLine as Ta, IconAssignmentLine as La, IconLikeSolid as Tn, IconLikeLine as Ln, IconWarningBorderlessSolid as Ha, IconCheckMarkSolid as Na, IconInfoBorderlessSolid as Wa, IconNoSolid as Ga, IconArrowOpenLeftLine as Va, IconArrowOpenRightLine as ja, IconCheckMarkLine as Ua, IconCompleteLine as qa, IconNoLine as Ya } from "@instructure/ui-icons";
import Is from "react-dom";
let Rr;
const Xa = new Uint8Array(16);
function Ka() {
  if (!Rr && (Rr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Rr))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Rr(Xa);
}
const _e = [];
for (let e = 0; e < 256; ++e)
  _e.push((e + 256).toString(16).slice(1));
function Qa(e, t = 0) {
  return _e[e[t + 0]] + _e[e[t + 1]] + _e[e[t + 2]] + _e[e[t + 3]] + "-" + _e[e[t + 4]] + _e[e[t + 5]] + "-" + _e[e[t + 6]] + _e[e[t + 7]] + "-" + _e[e[t + 8]] + _e[e[t + 9]] + "-" + _e[e[t + 10]] + _e[e[t + 11]] + _e[e[t + 12]] + _e[e[t + 13]] + _e[e[t + 14]] + _e[e[t + 15]];
}
const Za = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hn = {
  randomUUID: Za
};
function Qr(e, t, r) {
  if (Hn.randomUUID && !e)
    return Hn.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || Ka)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Qa(i);
}
const Os = {
  correctAnswer: () => "Correct answer",
  incorrectAnswer: (e, t) => `Incorrect answer. The correct answer is ${(t == null ? void 0 : t.correctLabel) ?? ""}`,
  questionRegenerated: () => "Question regenerated",
  checkAnswer: () => "Check Answer",
  regenerate: () => "Regenerate",
  loading: () => "Loading",
  failedToLoadQuiz: () => "Failed to load quiz. Please try again.",
  previousCard: () => "Previous Card",
  nextCard: () => "Next Card",
  clickToFlip: () => "Click to flip",
  tapToFlip: () => "Tap to flip",
  question: () => "Question",
  answer: () => "Answer",
  flashcardsRegenerated: (e, t) => `${(t == null ? void 0 : t.count) ?? ""} flashcards regenerated`,
  failedToLoadFlashcards: () => "Failed to load flashcards. Please try again.",
  regenerateFlashcards: () => "Regenerate Flashcards",
  goodResponse: () => "Good response",
  badResponse: () => "Bad response",
  chatHistory: () => "Chat history",
  askAQuestion: () => "Ask a question",
  stop: () => "Stop",
  sendMessage: () => "Send message"
}, Nn = "study-assist-sr-region";
function Ja() {
  return ye((e) => {
    if (!e) return;
    let t = document.getElementById(Nn);
    t || (t = document.createElement("div"), t.id = Nn, t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-atomic", "true"), Object.assign(t.style, {
      position: "absolute",
      width: "1px",
      height: "1px",
      margin: "-1px",
      padding: "0",
      overflow: "hidden",
      clipPath: "inset(50%)",
      whiteSpace: "nowrap",
      border: "0"
    }), document.body.appendChild(t)), t.textContent = e;
  }, []);
}
const Bs = pn(Os), Wt = () => ii(Bs);
var He = /* @__PURE__ */ ((e) => (e.Assistant = "Assistant", e.User = "User", e))(He || {}), Ps = /* @__PURE__ */ ((e) => (e.Chat = "Chat", e.Summary = "Summary", e.Quiz = "Quiz", e.Flashcard = "Flashcard", e))(Ps || {});
const el = (e, t, r) => {
  switch (t) {
    case "Page":
      return `/courses/${e}/pages/${r}`;
    case "Assignment":
      return `/courses/${e}/assignments/${r}`;
    case "Syllabus":
      return `/courses/${e}/assignments/syllabus`;
    default:
      return;
  }
}, Ds = pn(void 0), tl = () => {
  const e = ii(Ds);
  if (e === void 0)
    throw new Error("useAssistContext must be used within an AssistProvider");
  return e;
}, hp = ({
  children: e,
  fetchAssistResponse: t,
  courseId: r,
  pageId: i,
  fileId: n,
  translations: o,
  featureSlug: a
}) => {
  const s = Ja(), c = Qt(0), u = Qt(!1), p = Qt(null), [v, d] = we(!1), [g, f] = we([]), [h, y] = we({
    courseID: r,
    pageID: i,
    fileID: n
  }), [k, A] = we([]), [x, w] = we([]), [b, C] = we([]), [S, Y] = we(!1), _ = ye(
    (V) => {
      var I, G, W, T;
      if (!V) return;
      if (V.state && y(V.state), V.error) {
        const L = {
          id: (Date.now() + 1).toString(),
          actor: He.Assistant,
          message: V.error,
          citations: []
        };
        f([]), w([]), A((z) => [...z, L]), s(V.error);
        return;
      }
      const R = ((I = V.chips) == null ? void 0 : I.map(
        (L) => ({
          id: Qr(),
          longMessage: L.prompt ?? L.chip,
          shortMessage: L.chip,
          type: Ps.Chat,
          agentPrompt: L.prompt
        })
      )) ?? [];
      if (f(R), (G = V.quizItems) != null && G.length)
        C(V.quizItems), s(`Quiz generated with ${V.quizItems.length} questions`);
      else if ((W = V.flashCards) != null && W.length)
        w(V.flashCards), s(`${V.flashCards.length} flashcards generated`);
      else if (V.response) {
        const L = (T = V.citations) == null ? void 0 : T.map(
          (P) => ({
            objectName: P.title,
            objectType: P.sourceType,
            objectId: P.sourceID,
            link: r && P.sourceType && P.sourceID ? el(r, P.sourceType, P.sourceID) : void 0
          })
        ), z = {
          id: (Date.now() + 1).toString(),
          actor: He.Assistant,
          message: V.response,
          citations: L ?? []
        };
        w([]), A((P) => [...P, z]);
        let N = V.response;
        R.length > 0 && (N += ` Suggested prompts: ${R.map((P) => P.shortMessage).join(", ")}.`), L && L.length > 0 && (N += ` ${L.length} citations available.`), s(N);
      }
    },
    [s, r]
  ), D = ye(
    (V = {}) => {
      const { prompt: R, skipHistory: I = !1, state: G, history: W } = V, T = G ?? h, L = W ?? k;
      R && R.length > 0 && !I && A((P) => [
        ...P,
        {
          id: Qr(),
          actor: He.User,
          message: R
        }
      ]), f([]);
      const z = ++c.current;
      d(!0);
      const N = {
        prompt: R,
        state: T,
        history: L.map((P) => ({
          text: P.message,
          role: P.actor
        })),
        featureSlug: a
      };
      t(N).then(
        (P) => {
          z === c.current && (_(P), d(!1));
        },
        (P) => {
          z === c.current && (console.error("Study assist error:", P), d(!1));
        }
      );
    },
    [h, k, t, _, a]
  ), F = ye(
    (V) => {
      u.current = !0, y(V), A([]), C([]), w([]), f([]), p.current = V, D({ state: V, history: [] });
    },
    [D]
  ), H = ye(() => {
    F({
      courseID: r,
      pageID: i,
      fileID: n
    });
  }, [r, i, n, F]), me = ye(() => {
    D({ prompt: "Generate flashcards", skipHistory: !0 });
  }, [D]), oe = ye(() => {
    D({ prompt: "Generate quiz", skipHistory: !0 });
  }, [D]), he = ye(
    (V) => {
      D({ prompt: V.longMessage });
    },
    [D]
  ), le = ye(
    (V) => {
      D({ prompt: V });
    },
    [D]
  ), pe = ye(() => {
    if (!u.current && k.length === 0) {
      u.current = !0;
      const V = {
        courseID: r,
        pageID: i,
        fileID: n
      };
      (!p.current || p.current.courseID !== V.courseID || p.current.pageID !== V.pageID || p.current.fileID !== V.fileID || k.length === 0) && F(V);
    }
    return () => {
    };
  }, [k.length, r, i, n, F]);
  tr(() => {
    Y(k.length > 1), k.length > 0 && (u.current = !1);
  }, [k.length]);
  const $e = {
    chats: k,
    quiz: b,
    flashCards: x,
    isLoading: v,
    assistPrompts: g,
    showBackButton: S,
    announce: s,
    resetChat: H,
    getFlashCards: me,
    getQuiz: oe,
    handlePromptInteraction: he,
    handleSubmitInteraction: le,
    submitRequest: D,
    activateAssist: pe,
    updateAssistState: F
  };
  return /* @__PURE__ */ E(Bs.Provider, { value: o ?? Os, children: /* @__PURE__ */ E(Ds.Provider, { value: $e, children: e }) });
};
function Jt(e, t = {}) {
  return typeof e == "function" ? e.prototype && e.prototype.isReactComponent ? /* @__PURE__ */ hn.createElement(e, t) : e(t) : e;
}
function rr(e) {
  return (...t) => (r) => {
    if (typeof e == "function") {
      const i = r.displayName || r.name, n = e(r, ...t);
      return n.displayName = i, n;
    } else
      return r;
  };
}
let Wn = !1;
function rl() {
  let e = "";
  try {
    e = hn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactDebugCurrentFrame.getStackAddendum();
  } catch {
  }
  return e;
}
function Zr(e, t, r, i, ...n) {
  if (process.env.NODE_ENV !== "production" && !r)
    if (typeof console[e] == "function") {
      const o = t ? rl() : "";
      console[e](`Warning: ${i}`, ...n, o);
    } else
      throw new Error(`'${e}' is not a valid console method!`);
}
function il(e, t, ...r) {
  let i = !1;
  try {
    var n, o;
    i = !((n = process) !== null && n !== void 0 && (o = n.env) !== null && o !== void 0 && o.OMIT_INSTUI_DEPRECATION_WARNINGS);
  } catch (a) {
    if (a instanceof ReferenceError)
      i = !0;
    else
      throw a;
  }
  i ? Zr("warn", !0, e, t, ...r) : !e && !Wn && (Wn = !0, Zr("warn", !1, e, ["There are Instructure UI deprecation warnings that are being hidden because the `OMIT_INSTUI_DEPRECATION_WARNINGS` environment variable is set. Remove or unset this variable to see the full list of warnings in your console.", "These warnings will give you advance notice of breaking changes and upgrade guidance to keep your code up to date with the latest Instructure UI versions."].join(`

`)));
}
const Xe = (e, t, ...r) => Zr("error", !0, e, t, ...r), ct = (e, t, ...r) => Zr("warn", !0, e, t, ...r), vi = (e, t, ...r) => il(e, t, ...r), nl = (() => {
  if (process.env.NODE_ENV === "production") {
    const i = function() {
      return (n) => n;
    };
    return i.deprecatePropValues = () => () => null, i.warnDeprecatedProps = () => {
    }, i.warnDeprecatedComponent = () => {
    }, i.changedPackageWarning = () => "", i;
  }
  const e = rr((i, n, o, a = "") => {
    class s extends i {
    }
    return s.prototype.componentDidMount = function() {
      o ? t(i.name, n, this.props, o, a) : r(n, i.name, a), i.prototype.componentDidMount && i.prototype.componentDidMount.call(this);
    }, s.prototype.componentDidUpdate = function(c, u, p) {
      o ? t(i.name, n, this.props, o, a) : r(n, i.name, a), i.prototype.componentDidUpdate && i.prototype.componentDidUpdate.call(this, c, u, p);
    }, s;
  });
  e.deprecatePropValues = (i, n = [], o) => (a, s, c, ...u) => {
    const p = n.includes(a[s]), v = o && typeof o == "function" ? o({
      props: a,
      propName: s,
      propValue: a[s]
    }) : `The '${a[s]}' value for the \`${s}\` prop is deprecated. ${o || ""}`;
    return vi(!p, `[${c}] ${v}`), p ? null : i(a, s, c, ...u);
  };
  function t(i, n, o, a, s = "") {
    Object.keys(a).forEach((c) => {
      if (typeof o[c] < "u") {
        const u = typeof a[c] == "string" ? a[c] : null, p = u ? `. Use \`${u}\` instead` : "";
        vi(!1, `[${i}] \`${c}\` is deprecated and will be removed in version ${n}${p}. ${s}`);
      }
    });
  }
  e.warnDeprecatedProps = t;
  function r(i, n, o) {
    vi(!1, `[${n}] is deprecated and will be removed in version ${i}. ${o || ""}`);
  }
  return e.warnDeprecatedComponent = r, e.changedPackageWarning = (i, n) => `It has been moved from @instructure/${i} to @instructure/${n}.`, e;
})();
function ur(e) {
  if (Array.isArray(e)) {
    const t = e.slice(0);
    for (let r = 0; r < t.length; r++)
      t[r] = ur(t[r]);
    return t;
  } else
    return e;
}
function ol(...e) {
  return e.filter((t, r) => {
    if (t == null)
      return !1;
    const i = sl(e, t);
    return i.length === 1 || r === i[0];
  }).reduce((t, r) => {
    if (typeof r != "function")
      throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
    return t === null ? r : function(...n) {
      t.apply(this, n), r.apply(this, n);
    };
  }, null);
}
function sl(e, t) {
  const r = [];
  return e.forEach((i, n) => {
    i === t && r.push(n);
  }), r;
}
function ir(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yi, Gn;
function al() {
  return Gn || (Gn = 1, yi = function e(t, r) {
    if (t === r) return !0;
    if (t && r && typeof t == "object" && typeof r == "object") {
      if (t.constructor !== r.constructor) return !1;
      var i, n, o;
      if (Array.isArray(t)) {
        if (i = t.length, i != r.length) return !1;
        for (n = i; n-- !== 0; )
          if (!e(t[n], r[n])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
      if (o = Object.keys(t), i = o.length, i !== Object.keys(r).length) return !1;
      for (n = i; n-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(r, o[n])) return !1;
      for (n = i; n-- !== 0; ) {
        var a = o[n];
        if (!e(t[a], r[a])) return !1;
      }
      return !0;
    }
    return t !== t && r !== r;
  }), yi;
}
var ll = al();
const dl = /* @__PURE__ */ ir(ll), cl = (e, t) => (t.has(e) ? t.set(e, t.get(e) + 1) : t.set(e, 0), `${e}___${t.get(e)}`), ul = Object.prototype.hasOwnProperty;
function Ms(e) {
  if (typeof e != "object") return !0;
  for (const t in e)
    if (ul.call(e, t)) return !1;
  return !0;
}
function fl(...e) {
  let t = {};
  return e.forEach((r) => {
    t = Fs(t, r);
  }), t;
}
function Fs(e, t) {
  if (bi(t)) {
    const r = [...Object.keys(t), ...Object.getOwnPropertySymbols(t)], i = {
      ...e
    };
    return r.forEach((n) => {
      bi(e[n]) && bi(t[n]) ? i[n] = Fs(e[n], t[n]) : mi(t[n]) && mi(e[n]) ? i[n] = [.../* @__PURE__ */ new Set([...e[n], ...t[n]])] : mi(e[n]) ? i[n] = [.../* @__PURE__ */ new Set([...e[n], t[n]])] : i[n] = t[n];
    }), i;
  } else
    return {
      ...e
    };
}
function bi(e) {
  return e && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
function mi(e) {
  return Array.isArray(e);
}
function hl(e) {
  if (Array.isArray(e)) return e;
}
function pl(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, n, o, a, s = [], c = !0, u = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (i = o.call(r)).done) && (s.push(i.value), s.length !== t); c = !0) ;
    } catch (p) {
      u = !0, n = p;
    } finally {
      try {
        if (!c && r.return != null && (a = r.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw n;
      }
    }
    return s;
  }
}
function Vn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, i = Array(t); r < t; r++) i[r] = e[r];
  return i;
}
function gl(e, t) {
  if (e) {
    if (typeof e == "string") return Vn(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Vn(e, t) : void 0;
  }
}
function vl() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gn(e, t) {
  return hl(e) || pl(e, t) || gl(e, t) || vl();
}
function zs(e) {
  const t = `${e}`, r = t.match(/[\d.\-\+]*\s*(.*)/);
  return [parseFloat(t), r && r.length > 0 ? r[1] : ""];
}
function yl(e) {
  if (!e || typeof e == "number")
    return e;
  const t = zs(e), r = gn(t, 2), i = r[0], n = r[1];
  return n === "ms" ? i : n === "s" ? i * 1e3 : i;
}
const bl = (e) => !!e && e.ref !== void 0, ml = (e) => !!e && e.current !== void 0;
function Pe(e) {
  const t = typeof e == "function" ? e() : e;
  if (t && t === document)
    return document.documentElement;
  if (t instanceof Element || t === window || t && typeof t.nodeType < "u")
    return t;
  if (t) {
    const r = t;
    if (bl(r)) {
      const i = ml(r.ref) ? r.ref.current : r.ref;
      return i instanceof HTMLElement ? i : Pe(i);
    } else
      return r.constructor.componentId ? r.constructor.componentId : r.constructor.name, Is.findDOMNode(t);
  }
}
function wl(e, t, r, i) {
  const n = e === window || e === document ? e : Pe(e);
  return n == null || n.addEventListener(t, r, i), {
    remove() {
      n == null || n.removeEventListener(t, r, i);
    }
  };
}
const rt = !!(typeof window < "u" && window.document && window.document.createElement);
function xl(e, t) {
  const r = e && Pe(e), i = t && Pe(t);
  return !r || !i ? !1 : !(r instanceof Window) && !(i instanceof Window) ? r.contains(i) : Ts(r, i);
}
function Ts(e, t) {
  let r = t;
  for (; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
const Sl = rt ? xl : Ts;
function vn(e) {
  const t = e && Pe(e);
  let r;
  t && "ownerDocument" in t && (r = t.ownerDocument);
  const i = rt ? window.document : void 0;
  return r || i;
}
function hr(e) {
  const t = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: 0,
    width: 0
  };
  if (!rt)
    return t;
  const r = e && Pe(e);
  if (!r)
    return t;
  if (r === window)
    return {
      left: window.pageXOffset,
      top: window.pageYOffset,
      width: window.innerWidth,
      height: window.innerHeight,
      right: window.innerWidth + window.pageXOffset,
      bottom: window.innerHeight + window.pageYOffset
    };
  const i = e === document ? document : vn(r), n = i && i.documentElement;
  if (!n || !Sl(n, r))
    return t;
  const o = r.getBoundingClientRect();
  let a;
  for (a in t)
    t[a] = o[a];
  if (i !== document && i.defaultView) {
    const s = i.defaultView.frameElement;
    if (s) {
      const c = hr(s);
      t.top += c.top, t.bottom += c.top, t.left += c.left, t.right += c.left;
    }
  }
  return {
    top: t.top + (window.pageYOffset || n.scrollTop) - (n.clientTop || 0),
    left: t.left + (window.pageXOffset || n.scrollLeft) - (n.clientLeft || 0),
    // TODO: find out when width and height can be null, might be an old IE hack
    width: (t.width == null ? r.offsetWidth : t.width) || 0,
    height: (t.height == null ? r.offsetHeight : t.height) || 0,
    right: i.body.clientWidth - t.width - t.left,
    bottom: i.body.clientHeight - t.height - t.top
  };
}
const kl = function() {
  let e;
  if (rt && window.requestAnimationFrame && window.cancelAnimationFrame)
    e = (t) => {
      const r = window.requestAnimationFrame(t);
      return {
        cancel: () => window.cancelAnimationFrame(r)
      };
    };
  else {
    let t = (/* @__PURE__ */ new Date()).getTime();
    e = (r) => {
      const i = (/* @__PURE__ */ new Date()).getTime(), n = Math.max(0, 16 - (i - t)), o = setTimeout(r, n);
      return t = i, {
        cancel: () => clearTimeout(o)
      };
    };
  }
  return e;
}();
function _l(e) {
  return !!(e.tagName.includes("-") && customElements.get(e.tagName.toLowerCase()));
}
function Cl(e) {
  const t = document.activeElement;
  return t && _l(t) ? t.shadowRoot.activeElement : t;
}
const $l = ["a[href]", "frame", "iframe", "object", "input:not([type=hidden])", "select", "textarea", "button", "*[tabindex]", '[contenteditable="true"]'].join(",");
function El(e) {
  return !(!e || typeof e.querySelectorAll != "function");
}
function Rl(e, t, r) {
  const i = e && Pe(e);
  return El(i) ? Array.from(i.querySelectorAll($l)).filter((o) => Bl(o)) : [];
}
function Al(e) {
  return yt(e).display === "none";
}
function Il(e) {
  var t, r;
  const i = ["fixed", "absolute"];
  return !!(i.includes((t = e.style.position) === null || t === void 0 ? void 0 : t.toLowerCase()) || i.includes((r = yt(e).getPropertyValue("position")) === null || r === void 0 ? void 0 : r.toLowerCase()));
}
function Ol(e) {
  let t = e;
  for (; t && !(t === document.body || t instanceof ShadowRoot); ) {
    if (Al(t)) return !1;
    if (Il(t)) break;
    t = t.parentNode;
  }
  return !0;
}
function Bl(e) {
  return !e.disabled && Ol(e);
}
const Pl = {
  toArray: () => [],
  contains: () => !1,
  add: () => {
  },
  remove: () => {
  }
};
function jn(e) {
  const t = Pe(e);
  if (!t) return Pl;
  const r = {
    toArray() {
      return [...t.classList];
    },
    contains: () => !1,
    add: () => {
    },
    remove: () => {
    }
  };
  return r.add = (i) => t.classList.add(i), r.remove = (i) => t.classList.remove(i), r.contains = (i) => t.classList.contains(i), r;
}
function Dl(e) {
  const t = e && Pe(e), r = vn(t);
  return r && r.defaultView;
}
function yt(e, t) {
  let r = {};
  if (rt) {
    const i = e && Pe(e);
    if (i) {
      const n = Dl(e);
      r = n ? n.getComputedStyle(i, t) : {};
    }
  }
  return r;
}
const Un = /* @__PURE__ */ new WeakMap();
function qn(e, t = !1) {
  var r;
  if (!rt)
    return 16;
  const i = e || ((r = vn(e)) === null || r === void 0 ? void 0 : r.documentElement), n = Un.get(i);
  if (!t && n)
    return n;
  const o = parseInt(yt(i).getPropertyValue("font-size"));
  return Un.set(i, o), o;
}
function yn(e) {
  const t = e && Pe(e);
  return t ? Cl() === t : !1;
}
function Zi(e, t = !0) {
  const r = e && Pe(e);
  if (r === window || r === document || r === document.body)
    return !0;
  const i = r.parentNode;
  if (r.nodeType === 3)
    return Zi(i, t);
  const n = r ? yt(r) : {};
  if (n.display === "none" || n.visibility === "hidden" || n.opacity === "0")
    return !1;
  if (n.overflow === "hidden" && n.position === "absolute" && n.clip !== "auto") {
    const o = n.clip.substring(5).slice(0, -1).split(", ");
    let a = !0;
    if (o.forEach((s) => {
      s !== "0px" && (a = !1);
    }), a)
      return !1;
  }
  return t && i ? Zi(i) : !0;
}
function wi(e, t) {
  if (!e || typeof e == "number")
    return e;
  const r = zs(e), i = gn(r, 2), n = i[0], o = i[1];
  if (o === "rem")
    return n * qn();
  if (o === "em") {
    const a = rt ? document.body : null;
    return n * qn(t || a);
  } else
    return n;
}
function Ls(e) {
  return e.replace(/-([a-z])/g, (t) => t[1].toUpperCase());
}
const Ml = ["borders", "breakpoints", "colors", "forms", "media", "shadows", "spacing", "stacking", "transitions", "typography"], Fl = (e) => {
  if (Array.isArray(e) || typeof e == "function")
    throw new Error();
  try {
    return "key" in e && Ml.every((t) => t in e);
  } catch {
    throw new Error();
  }
};
var lr = { exports: {} }, zl = lr.exports, Yn;
function Tl() {
  return Yn || (Yn = 1, function(e, t) {
    (function(r, i) {
      var n = "1.0.41", o = "", a = "?", s = "function", c = "undefined", u = "object", p = "string", v = "major", d = "model", g = "name", f = "type", h = "vendor", y = "version", k = "architecture", A = "console", x = "mobile", w = "tablet", b = "smarttv", C = "wearable", S = "embedded", Y = 500, _ = "Amazon", D = "Apple", F = "ASUS", H = "BlackBerry", me = "Browser", oe = "Chrome", he = "Edge", le = "Firefox", pe = "Google", $e = "Honor", V = "Huawei", R = "Lenovo", I = "LG", G = "Microsoft", W = "Motorola", T = "Nvidia", L = "OnePlus", z = "Opera", N = "OPPO", P = "Samsung", K = "Sharp", U = "Sony", ge = "Xiaomi", O = "Zebra", ke = "Facebook", We = "Chromium OS", nt = "Mac OS", jt = " Browser", or = function(Q, Z) {
        var q = {};
        for (var se in Q)
          Z[se] && Z[se].length % 2 === 0 ? q[se] = Z[se].concat(Q[se]) : q[se] = Q[se];
        return q;
      }, ht = function(Q) {
        for (var Z = {}, q = 0; q < Q.length; q++)
          Z[Q[q].toUpperCase()] = Q[q];
        return Z;
      }, ze = function(Q, Z) {
        return typeof Q === p ? m(Z).indexOf(m(Q)) !== -1 : !1;
      }, m = function(Q) {
        return Q.toLowerCase();
      }, Ge = function(Q) {
        return typeof Q === p ? Q.replace(/[^\d\.]/g, o).split(".")[0] : i;
      }, Ie = function(Q, Z) {
        if (typeof Q === p)
          return Q = Q.replace(/^\s\s*/, o), typeof Z === c ? Q : Q.substring(0, Y);
      }, de = function(Q, Z) {
        for (var q = 0, se, ot, Ke, re, j, Qe; q < Z.length && !j; ) {
          var gi = Z[q], Mn = Z[q + 1];
          for (se = ot = 0; se < gi.length && !j && gi[se]; )
            if (j = gi[se++].exec(Q), j)
              for (Ke = 0; Ke < Mn.length; Ke++)
                Qe = j[++ot], re = Mn[Ke], typeof re === u && re.length > 0 ? re.length === 2 ? typeof re[1] == s ? this[re[0]] = re[1].call(this, Qe) : this[re[0]] = re[1] : re.length === 3 ? typeof re[1] === s && !(re[1].exec && re[1].test) ? this[re[0]] = Qe ? re[1].call(this, Qe, re[2]) : i : this[re[0]] = Qe ? Qe.replace(re[1], re[2]) : i : re.length === 4 && (this[re[0]] = Qe ? re[3].call(this, Qe.replace(re[1], re[2])) : i) : this[re] = Qe || i;
          q += 2;
        }
      }, mt = function(Q, Z) {
        for (var q in Z)
          if (typeof Z[q] === u && Z[q].length > 0) {
            for (var se = 0; se < Z[q].length; se++)
              if (ze(Z[q][se], Q))
                return q === a ? i : q;
          } else if (ze(Z[q], Q))
            return q === a ? i : q;
        return Z.hasOwnProperty("*") ? Z["*"] : Q;
      }, hi = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, pi = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, Dn = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [y, [g, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [y, [g, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [g, y],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [y, [g, z + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [y, [g, z + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [y, [g, z]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [y, [g, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [y, [g, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [g, y],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [y, [g, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [y, [g, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [y, [g, "UC" + me]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [y, [g, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [y, [g, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [y, [g, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [y, [g, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [y, [g, "Smart Lenovo " + me]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[g, /(.+)/, "$1 Secure " + me], y],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [y, [g, le + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [y, [g, z + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [y, [g, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [y, [g, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [y, [g, z + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [y, [g, "MIUI" + jt]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [y, [g, le]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [y, [g, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[g, /(.+)/, "$1Browser"], y],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[g, /(.+)/, "$1" + jt], y],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [y, [g, P + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [y, [g, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[g, "Sogou Mobile"], y],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [g, y],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [g],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [y, g],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[g, ke], y],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [g, y],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [y, [g, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [y, [g, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [y, [g, oe + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[g, oe + " WebView"], y],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [y, [g, "Android " + me]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [g, y],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [y, [g, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [y, g],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [g, [y, mt, hi]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [g, y],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[g, "Netscape"], y],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [g, y],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [y, [g, le + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [g, [y, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [g, [y, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[k, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[k, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[k, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[k, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[k, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[k, /ower/, o, m]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[k, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[k, m]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [d, [h, P], [f, w]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [d, [h, P], [f, x]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [d, [h, D], [f, x]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [d, [h, D], [f, w]],
          [
            /(macintosh);/i
          ],
          [d, [h, D]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [d, [h, K], [f, x]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [d, [h, $e], [f, w]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [d, [h, $e], [f, x]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [d, [h, V], [f, w]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [d, [h, V], [f, x]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[d, /_/g, " "], [h, ge], [f, w]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[d, /_/g, " "], [h, ge], [f, x]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [d, [h, N], [f, x]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [d, [h, mt, { OnePlus: ["304", "403", "203"], "*": N }], [f, w]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [d, [h, "Vivo"], [f, x]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [d, [h, "Realme"], [f, x]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [d, [h, W], [f, x]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [d, [h, W], [f, w]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [d, [h, I], [f, w]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [d, [h, I], [f, x]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [d, [h, R], [f, w]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [h, d, [f, w]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[d, /_/g, " "], [f, x], [h, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [d, [h, pe], [f, w]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [d, [h, pe], [f, x]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [d, [h, U], [f, x]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[d, "Xperia Tablet"], [h, U], [f, w]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [d, [h, L], [f, x]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [d, [h, _], [f, w]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[d, /(.+)/g, "Fire Phone $1"], [h, _], [f, x]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [d, h, [f, w]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [d, [h, H], [f, x]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [d, [h, F], [f, w]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [d, [h, F], [f, x]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [d, [h, "HTC"], [f, w]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [h, [d, /_/g, " "], [f, x]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [d, [h, "TCL"], [f, w]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[h, m], d, [f, mt, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [d, [h, "Acer"], [f, w]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [d, [h, "Meizu"], [f, x]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [d, [h, "Ulefone"], [f, x]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [d, [h, "Energizer"], [f, x]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [d, [h, "Cat"], [f, x]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [d, [h, "Smartfren"], [f, x]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [d, [h, "Nothing"], [f, x]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [d, [h, "Archos"], [f, w]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [d, [h, "Archos"], [f, x]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [h, d, [f, w]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [h, d, [f, x]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [h, d, [f, w]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [d, [h, G], [f, w]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [d, [h, "Fairphone"], [f, x]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [d, [h, "AT&T"], [f, x]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [d, [h, "Siemens"], [f, x]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [d, [h, "RCA"], [f, w]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [d, [h, "Dell"], [f, w]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [d, [h, "Verizon"], [f, w]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [d, [h, "Barnes & Noble"], [f, w]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [d, [h, "NuVision"], [f, w]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [d, [h, "ZTE"], [f, w]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [d, [h, "ZTE"], [f, x]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [d, [h, "Swiss"], [f, x]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [d, [h, "Swiss"], [f, w]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [d, [h, "Zeki"], [f, w]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[h, "Dragon Touch"], d, [f, w]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [d, [h, "Insignia"], [f, w]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [d, [h, "NextBook"], [f, w]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[h, "Voice"], d, [f, x]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[h, "LvTel"], d, [f, x]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [d, [h, "Essential"], [f, x]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [d, [h, "Envizen"], [f, w]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [d, [h, "MachSpeed"], [f, w]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [d, [h, "Rotor"], [f, w]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [d, [h, T], [f, w]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [h, d, [f, x]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[d, /\./g, " "], [h, G], [f, x]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [d, [h, O], [f, w]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [d, [h, O], [f, x]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [h, [f, b]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[d, /^/, "SmartTV"], [h, P], [f, b]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[h, I], [f, b]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [h, [d, D + " TV"], [f, b]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[d, oe + "cast"], [h, pe], [f, b]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [d, [h, _], [f, b]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [d, [h, T], [f, b]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [d, [h, K], [f, b]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [d, [h, U], [f, b]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [d, [h, ge], [f, b]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [h, d, [f, b]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[h, Ie], [d, Ie], [f, b]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [d, [f, b]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[f, b]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [h, d, [f, A]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [d, [h, T], [f, A]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [d, [h, U], [f, A]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [d, [h, G], [f, A]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [d, [h, P], [f, C]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [h, d, [f, C]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [d, [h, N], [f, C]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [d, [h, D], [f, C]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [d, [h, L], [f, C]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [d, [h, W], [f, C]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [d, [h, U], [f, C]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [d, [h, I], [f, C]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [d, [h, O], [f, C]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [d, [h, pe], [f, C]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [h, d, [f, C]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [d, [h, ke], [f, C]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [h, [f, S]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [d, [h, _], [f, S]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [d, [h, D], [f, S]],
          [
            /windows iot/i
          ],
          [[f, S]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [d, [f, x]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [d, [f, w]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[f, w]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[f, x]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [d, [h, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [y, [g, he + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [g, y],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [y, [g, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [g, y],
          [
            /ladybird\//i
          ],
          [[g, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [y, g]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [g, y],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [g, [y, mt, pi]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[y, mt, pi], [g, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[y, /_/g, "."], [g, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[g, nt], [y, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [y, g],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[g, /(.+)/, "$1 Touch"], y],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [g, y],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [y, [g, H]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [y, [g, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [y, [g, le + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [y, [g, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [y, [g, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [y, [g, oe + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[g, We], y],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [g, y],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[g, "Solaris"], y],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [g, y]
        ]
      }, Ve = function(Q, Z) {
        if (typeof Q === u && (Z = Q, Q = i), !(this instanceof Ve))
          return new Ve(Q, Z).getResult();
        var q = typeof r !== c && r.navigator ? r.navigator : i, se = Q || (q && q.userAgent ? q.userAgent : o), ot = q && q.userAgentData ? q.userAgentData : i, Ke = Z ? or(Dn, Z) : Dn, re = q && q.userAgent == se;
        return this.getBrowser = function() {
          var j = {};
          return j[g] = i, j[y] = i, de.call(j, se, Ke.browser), j[v] = Ge(j[y]), re && q && q.brave && typeof q.brave.isBrave == s && (j[g] = "Brave"), j;
        }, this.getCPU = function() {
          var j = {};
          return j[k] = i, de.call(j, se, Ke.cpu), j;
        }, this.getDevice = function() {
          var j = {};
          return j[h] = i, j[d] = i, j[f] = i, de.call(j, se, Ke.device), re && !j[f] && ot && ot.mobile && (j[f] = x), re && j[d] == "Macintosh" && q && typeof q.standalone !== c && q.maxTouchPoints && q.maxTouchPoints > 2 && (j[d] = "iPad", j[f] = w), j;
        }, this.getEngine = function() {
          var j = {};
          return j[g] = i, j[y] = i, de.call(j, se, Ke.engine), j;
        }, this.getOS = function() {
          var j = {};
          return j[g] = i, j[y] = i, de.call(j, se, Ke.os), re && !j[g] && ot && ot.platform && ot.platform != "Unknown" && (j[g] = ot.platform.replace(/chrome os/i, We).replace(/macos/i, nt)), j;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return se;
        }, this.setUA = function(j) {
          return se = typeof j === p && j.length > Y ? Ie(j, Y) : j, this;
        }, this.setUA(se), this;
      };
      Ve.VERSION = n, Ve.BROWSER = ht([g, y, v]), Ve.CPU = ht([k]), Ve.DEVICE = ht([d, h, f, A, x, b, w, C, S]), Ve.ENGINE = Ve.OS = ht([g, y]), e.exports && (t = e.exports = Ve), t.UAParser = Ve;
      var Ut = typeof r !== c && (r.jQuery || r.Zepto);
      if (Ut && !Ut.ua) {
        var $r = new Ve();
        Ut.ua = $r.getResult(), Ut.ua.get = function() {
          return $r.getUA();
        }, Ut.ua.set = function(Q) {
          $r.setUA(Q);
          var Z = $r.getResult();
          for (var q in Z)
            Ut.ua[q] = Z[q];
        };
      }
    })(typeof window == "object" ? window : zl);
  }(lr, lr.exports)), lr.exports;
}
var Ll = Tl();
const Hl = /* @__PURE__ */ ir(Ll), Nl = () => new Hl().getResult().browser, Wl = () => Nl().name === "Safari";
function Ht(e, t, ...r) {
  const i = t.ref;
  let n = !0;
  const o = Aa.split(".", 1);
  o.length > 0 && parseInt(o[0], 10) < 19 && (n = !1);
  const a = n ? e.props.ref : e.ref, s = typeof a == "function", c = typeof i == "function", u = {
    ...t
  };
  return e.props.style && t.style && (u.style = {
    ...e.props.style,
    ...t.style
  }), u.key = e.key || t.key, Object.keys(t).forEach((p) => {
    p.indexOf("on") === 0 && (typeof t[p] == "function" || typeof e.props[p] == "function") && (u[p] = ol(e.props[p], t[p]));
  }), a == null || i == null ? /* @__PURE__ */ Fn(e, u, ...r) : (ct(s, `Cloning an element with a ref that will be overwritten because the ref is not a function. Use a composable callback-style ref instead. Ignoring ref: ${a}`), /* @__PURE__ */ Fn(e, {
    ...u,
    ref(p) {
      c ? i(p) : i.current = p, s && a(p);
    }
  }, ...r));
}
function Gl(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Vl(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var jl = /* @__PURE__ */ function() {
  function e(r) {
    var i = this;
    this._insertTag = function(n) {
      var o;
      i.tags.length === 0 ? i.insertionPoint ? o = i.insertionPoint.nextSibling : i.prepend ? o = i.container.firstChild : o = i.before : o = i.tags[i.tags.length - 1].nextSibling, i.container.insertBefore(n, o), i.tags.push(n);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(i) {
    i.forEach(this._insertTag);
  }, t.insert = function(i) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Vl(this));
    var n = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = Gl(n);
      try {
        o.insertRule(i, o.cssRules.length);
      } catch {
      }
    } else
      n.appendChild(document.createTextNode(i));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(i) {
      var n;
      return (n = i.parentNode) == null ? void 0 : n.removeChild(i);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Ee = "-ms-", Jr = "-moz-", ee = "-webkit-", Hs = "comm", bn = "rule", mn = "decl", Ul = "@import", Ns = "@keyframes", ql = "@layer", Yl = Math.abs, oi = String.fromCharCode, Xl = Object.assign;
function Kl(e, t) {
  return Ce(e, 0) ^ 45 ? (((t << 2 ^ Ce(e, 0)) << 2 ^ Ce(e, 1)) << 2 ^ Ce(e, 2)) << 2 ^ Ce(e, 3) : 0;
}
function Ws(e) {
  return e.trim();
}
function Ql(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function te(e, t, r) {
  return e.replace(t, r);
}
function Ji(e, t) {
  return e.indexOf(t);
}
function Ce(e, t) {
  return e.charCodeAt(t) | 0;
}
function pr(e, t, r) {
  return e.slice(t, r);
}
function Je(e) {
  return e.length;
}
function wn(e) {
  return e.length;
}
function Ar(e, t) {
  return t.push(e), e;
}
function Zl(e, t) {
  return e.map(t).join("");
}
var si = 1, er = 1, Gs = 0, De = 0, xe = 0, nr = "";
function ai(e, t, r, i, n, o, a) {
  return { value: e, root: t, parent: r, type: i, props: n, children: o, line: si, column: er, length: a, return: "" };
}
function sr(e, t) {
  return Xl(ai("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Jl() {
  return xe;
}
function ed() {
  return xe = De > 0 ? Ce(nr, --De) : 0, er--, xe === 10 && (er = 1, si--), xe;
}
function Fe() {
  return xe = De < Gs ? Ce(nr, De++) : 0, er++, xe === 10 && (er = 1, si++), xe;
}
function tt() {
  return Ce(nr, De);
}
function jr() {
  return De;
}
function wr(e, t) {
  return pr(nr, e, t);
}
function gr(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Vs(e) {
  return si = er = 1, Gs = Je(nr = e), De = 0, [];
}
function js(e) {
  return nr = "", e;
}
function Ur(e) {
  return Ws(wr(De - 1, en(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function td(e) {
  for (; (xe = tt()) && xe < 33; )
    Fe();
  return gr(e) > 2 || gr(xe) > 3 ? "" : " ";
}
function rd(e, t) {
  for (; --t && Fe() && !(xe < 48 || xe > 102 || xe > 57 && xe < 65 || xe > 70 && xe < 97); )
    ;
  return wr(e, jr() + (t < 6 && tt() == 32 && Fe() == 32));
}
function en(e) {
  for (; Fe(); )
    switch (xe) {
      case e:
        return De;
      case 34:
      case 39:
        e !== 34 && e !== 39 && en(xe);
        break;
      case 40:
        e === 41 && en(e);
        break;
      case 92:
        Fe();
        break;
    }
  return De;
}
function id(e, t) {
  for (; Fe() && e + xe !== 57; )
    if (e + xe === 84 && tt() === 47)
      break;
  return "/*" + wr(t, De - 1) + "*" + oi(e === 47 ? e : Fe());
}
function nd(e) {
  for (; !gr(tt()); )
    Fe();
  return wr(e, De);
}
function od(e) {
  return js(qr("", null, null, null, [""], e = Vs(e), 0, [0], e));
}
function qr(e, t, r, i, n, o, a, s, c) {
  for (var u = 0, p = 0, v = a, d = 0, g = 0, f = 0, h = 1, y = 1, k = 1, A = 0, x = "", w = n, b = o, C = i, S = x; y; )
    switch (f = A, A = Fe()) {
      case 40:
        if (f != 108 && Ce(S, v - 1) == 58) {
          Ji(S += te(Ur(A), "&", "&\f"), "&\f") != -1 && (k = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        S += Ur(A);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        S += td(f);
        break;
      case 92:
        S += rd(jr() - 1, 7);
        continue;
      case 47:
        switch (tt()) {
          case 42:
          case 47:
            Ar(sd(id(Fe(), jr()), t, r), c);
            break;
          default:
            S += "/";
        }
        break;
      case 123 * h:
        s[u++] = Je(S) * k;
      case 125 * h:
      case 59:
      case 0:
        switch (A) {
          case 0:
          case 125:
            y = 0;
          case 59 + p:
            k == -1 && (S = te(S, /\f/g, "")), g > 0 && Je(S) - v && Ar(g > 32 ? Kn(S + ";", i, r, v - 1) : Kn(te(S, " ", "") + ";", i, r, v - 2), c);
            break;
          case 59:
            S += ";";
          default:
            if (Ar(C = Xn(S, t, r, u, p, n, s, x, w = [], b = [], v), o), A === 123)
              if (p === 0)
                qr(S, t, C, C, w, o, v, s, b);
              else
                switch (d === 99 && Ce(S, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    qr(e, C, C, i && Ar(Xn(e, C, C, 0, 0, n, s, x, n, w = [], v), b), n, b, v, s, i ? w : b);
                    break;
                  default:
                    qr(S, C, C, C, [""], b, 0, s, b);
                }
        }
        u = p = g = 0, h = k = 1, x = S = "", v = a;
        break;
      case 58:
        v = 1 + Je(S), g = f;
      default:
        if (h < 1) {
          if (A == 123)
            --h;
          else if (A == 125 && h++ == 0 && ed() == 125)
            continue;
        }
        switch (S += oi(A), A * h) {
          case 38:
            k = p > 0 ? 1 : (S += "\f", -1);
            break;
          case 44:
            s[u++] = (Je(S) - 1) * k, k = 1;
            break;
          case 64:
            tt() === 45 && (S += Ur(Fe())), d = tt(), p = v = Je(x = S += nd(jr())), A++;
            break;
          case 45:
            f === 45 && Je(S) == 2 && (h = 0);
        }
    }
  return o;
}
function Xn(e, t, r, i, n, o, a, s, c, u, p) {
  for (var v = n - 1, d = n === 0 ? o : [""], g = wn(d), f = 0, h = 0, y = 0; f < i; ++f)
    for (var k = 0, A = pr(e, v + 1, v = Yl(h = a[f])), x = e; k < g; ++k)
      (x = Ws(h > 0 ? d[k] + " " + A : te(A, /&\f/g, d[k]))) && (c[y++] = x);
  return ai(e, t, r, n === 0 ? bn : s, c, u, p);
}
function sd(e, t, r) {
  return ai(e, t, r, Hs, oi(Jl()), pr(e, 2, -2), 0);
}
function Kn(e, t, r, i) {
  return ai(e, t, r, mn, pr(e, 0, i), pr(e, i + 1, -1), i);
}
function Zt(e, t) {
  for (var r = "", i = wn(e), n = 0; n < i; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function ad(e, t, r, i) {
  switch (e.type) {
    case ql:
      if (e.children.length) break;
    case Ul:
    case mn:
      return e.return = e.return || e.value;
    case Hs:
      return "";
    case Ns:
      return e.return = e.value + "{" + Zt(e.children, i) + "}";
    case bn:
      e.value = e.props.join(",");
  }
  return Je(r = Zt(e.children, i)) ? e.return = e.value + "{" + r + "}" : "";
}
function ld(e) {
  var t = wn(e);
  return function(r, i, n, o) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](r, i, n, o) || "";
    return a;
  };
}
function dd(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Us(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var cd = function(t, r, i) {
  for (var n = 0, o = 0; n = o, o = tt(), n === 38 && o === 12 && (r[i] = 1), !gr(o); )
    Fe();
  return wr(t, De);
}, ud = function(t, r) {
  var i = -1, n = 44;
  do
    switch (gr(n)) {
      case 0:
        n === 38 && tt() === 12 && (r[i] = 1), t[i] += cd(De - 1, r, i);
        break;
      case 2:
        t[i] += Ur(n);
        break;
      case 4:
        if (n === 44) {
          t[++i] = tt() === 58 ? "&\f" : "", r[i] = t[i].length;
          break;
        }
      default:
        t[i] += oi(n);
    }
  while (n = Fe());
  return t;
}, fd = function(t, r) {
  return js(ud(Vs(t), r));
}, Qn = /* @__PURE__ */ new WeakMap(), hd = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, i = t.parent, n = t.column === i.column && t.line === i.line; i.type !== "rule"; )
      if (i = i.parent, !i) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Qn.get(i)) && !n) {
      Qn.set(t, !0);
      for (var o = [], a = fd(r, o), s = i.props, c = 0, u = 0; c < a.length; c++)
        for (var p = 0; p < s.length; p++, u++)
          t.props[u] = o[c] ? a[c].replace(/&\f/g, s[p]) : s[p] + " " + a[c];
    }
  }
}, pd = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function qs(e, t) {
  switch (Kl(e, t)) {
    case 5103:
      return ee + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ee + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ee + e + Jr + e + Ee + e + e;
    case 6828:
    case 4268:
      return ee + e + Ee + e + e;
    case 6165:
      return ee + e + Ee + "flex-" + e + e;
    case 5187:
      return ee + e + te(e, /(\w+).+(:[^]+)/, ee + "box-$1$2" + Ee + "flex-$1$2") + e;
    case 5443:
      return ee + e + Ee + "flex-item-" + te(e, /flex-|-self/, "") + e;
    case 4675:
      return ee + e + Ee + "flex-line-pack" + te(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return ee + e + Ee + te(e, "shrink", "negative") + e;
    case 5292:
      return ee + e + Ee + te(e, "basis", "preferred-size") + e;
    case 6060:
      return ee + "box-" + te(e, "-grow", "") + ee + e + Ee + te(e, "grow", "positive") + e;
    case 4554:
      return ee + te(e, /([^-])(transform)/g, "$1" + ee + "$2") + e;
    case 6187:
      return te(te(te(e, /(zoom-|grab)/, ee + "$1"), /(image-set)/, ee + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return te(e, /(image-set\([^]*)/, ee + "$1$`$1");
    case 4968:
      return te(te(e, /(.+:)(flex-)?(.*)/, ee + "box-pack:$3" + Ee + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ee + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return te(e, /(.+)-inline(.+)/, ee + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Je(e) - 1 - t > 6) switch (Ce(e, t + 1)) {
        case 109:
          if (Ce(e, t + 4) !== 45) break;
        case 102:
          return te(e, /(.+:)(.+)-([^]+)/, "$1" + ee + "$2-$3$1" + Jr + (Ce(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Ji(e, "stretch") ? qs(te(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Ce(e, t + 1) !== 115) break;
    case 6444:
      switch (Ce(e, Je(e) - 3 - (~Ji(e, "!important") && 10))) {
        case 107:
          return te(e, ":", ":" + ee) + e;
        case 101:
          return te(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ee + (Ce(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ee + "$2$3$1" + Ee + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Ce(e, t + 11)) {
        case 114:
          return ee + e + Ee + te(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ee + e + Ee + te(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ee + e + Ee + te(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return ee + e + Ee + e + e;
  }
  return e;
}
var gd = function(t, r, i, n) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case mn:
      t.return = qs(t.value, t.length);
      break;
    case Ns:
      return Zt([sr(t, {
        value: te(t.value, "@", "@" + ee)
      })], n);
    case bn:
      if (t.length) return Zl(t.props, function(o) {
        switch (Ql(o, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Zt([sr(t, {
              props: [te(o, /:(read-\w+)/, ":" + Jr + "$1")]
            })], n);
          case "::placeholder":
            return Zt([sr(t, {
              props: [te(o, /:(plac\w+)/, ":" + ee + "input-$1")]
            }), sr(t, {
              props: [te(o, /:(plac\w+)/, ":" + Jr + "$1")]
            }), sr(t, {
              props: [te(o, /:(plac\w+)/, Ee + "input-$1")]
            })], n);
        }
        return "";
      });
  }
}, vd = [gd], yd = function(t) {
  var r = t.key;
  if (r === "css") {
    var i = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(i, function(h) {
      var y = h.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var n = t.stylisPlugins || vd, o = {}, a, s = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(h) {
      for (var y = h.getAttribute("data-emotion").split(" "), k = 1; k < y.length; k++)
        o[y[k]] = !0;
      s.push(h);
    }
  );
  var c, u = [hd, pd];
  {
    var p, v = [ad, dd(function(h) {
      p.insert(h);
    })], d = ld(u.concat(n, v)), g = function(y) {
      return Zt(od(y), d);
    };
    c = function(y, k, A, x) {
      p = A, g(y ? y + "{" + k.styles + "}" : k.styles), x && (f.inserted[k.name] = !0);
    };
  }
  var f = {
    key: r,
    sheet: new jl({
      key: r,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: c
  };
  return f.sheet.hydrate(s), f;
}, Ir = { exports: {} }, ie = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zn;
function bd() {
  if (Zn) return ie;
  Zn = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
  function x(b) {
    if (typeof b == "object" && b !== null) {
      var C = b.$$typeof;
      switch (C) {
        case t:
          switch (b = b.type, b) {
            case c:
            case u:
            case i:
            case o:
            case n:
            case v:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case p:
                case f:
                case g:
                case a:
                  return b;
                default:
                  return C;
              }
          }
        case r:
          return C;
      }
    }
  }
  function w(b) {
    return x(b) === u;
  }
  return ie.AsyncMode = c, ie.ConcurrentMode = u, ie.ContextConsumer = s, ie.ContextProvider = a, ie.Element = t, ie.ForwardRef = p, ie.Fragment = i, ie.Lazy = f, ie.Memo = g, ie.Portal = r, ie.Profiler = o, ie.StrictMode = n, ie.Suspense = v, ie.isAsyncMode = function(b) {
    return w(b) || x(b) === c;
  }, ie.isConcurrentMode = w, ie.isContextConsumer = function(b) {
    return x(b) === s;
  }, ie.isContextProvider = function(b) {
    return x(b) === a;
  }, ie.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, ie.isForwardRef = function(b) {
    return x(b) === p;
  }, ie.isFragment = function(b) {
    return x(b) === i;
  }, ie.isLazy = function(b) {
    return x(b) === f;
  }, ie.isMemo = function(b) {
    return x(b) === g;
  }, ie.isPortal = function(b) {
    return x(b) === r;
  }, ie.isProfiler = function(b) {
    return x(b) === o;
  }, ie.isStrictMode = function(b) {
    return x(b) === n;
  }, ie.isSuspense = function(b) {
    return x(b) === v;
  }, ie.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === i || b === u || b === o || b === n || b === v || b === d || typeof b == "object" && b !== null && (b.$$typeof === f || b.$$typeof === g || b.$$typeof === a || b.$$typeof === s || b.$$typeof === p || b.$$typeof === y || b.$$typeof === k || b.$$typeof === A || b.$$typeof === h);
  }, ie.typeOf = x, ie;
}
var ne = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jn;
function md() {
  return Jn || (Jn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
    function x(O) {
      return typeof O == "string" || typeof O == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      O === i || O === u || O === o || O === n || O === v || O === d || typeof O == "object" && O !== null && (O.$$typeof === f || O.$$typeof === g || O.$$typeof === a || O.$$typeof === s || O.$$typeof === p || O.$$typeof === y || O.$$typeof === k || O.$$typeof === A || O.$$typeof === h);
    }
    function w(O) {
      if (typeof O == "object" && O !== null) {
        var ke = O.$$typeof;
        switch (ke) {
          case t:
            var We = O.type;
            switch (We) {
              case c:
              case u:
              case i:
              case o:
              case n:
              case v:
                return We;
              default:
                var nt = We && We.$$typeof;
                switch (nt) {
                  case s:
                  case p:
                  case f:
                  case g:
                  case a:
                    return nt;
                  default:
                    return ke;
                }
            }
          case r:
            return ke;
        }
      }
    }
    var b = c, C = u, S = s, Y = a, _ = t, D = p, F = i, H = f, me = g, oe = r, he = o, le = n, pe = v, $e = !1;
    function V(O) {
      return $e || ($e = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(O) || w(O) === c;
    }
    function R(O) {
      return w(O) === u;
    }
    function I(O) {
      return w(O) === s;
    }
    function G(O) {
      return w(O) === a;
    }
    function W(O) {
      return typeof O == "object" && O !== null && O.$$typeof === t;
    }
    function T(O) {
      return w(O) === p;
    }
    function L(O) {
      return w(O) === i;
    }
    function z(O) {
      return w(O) === f;
    }
    function N(O) {
      return w(O) === g;
    }
    function P(O) {
      return w(O) === r;
    }
    function K(O) {
      return w(O) === o;
    }
    function U(O) {
      return w(O) === n;
    }
    function ge(O) {
      return w(O) === v;
    }
    ne.AsyncMode = b, ne.ConcurrentMode = C, ne.ContextConsumer = S, ne.ContextProvider = Y, ne.Element = _, ne.ForwardRef = D, ne.Fragment = F, ne.Lazy = H, ne.Memo = me, ne.Portal = oe, ne.Profiler = he, ne.StrictMode = le, ne.Suspense = pe, ne.isAsyncMode = V, ne.isConcurrentMode = R, ne.isContextConsumer = I, ne.isContextProvider = G, ne.isElement = W, ne.isForwardRef = T, ne.isFragment = L, ne.isLazy = z, ne.isMemo = N, ne.isPortal = P, ne.isProfiler = K, ne.isStrictMode = U, ne.isSuspense = ge, ne.isValidElementType = x, ne.typeOf = w;
  }()), ne;
}
var eo;
function xn() {
  return eo || (eo = 1, process.env.NODE_ENV === "production" ? Ir.exports = bd() : Ir.exports = md()), Ir.exports;
}
var xi, to;
function wd() {
  if (to) return xi;
  to = 1;
  var e = xn(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, i = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, n = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = i, o[e.Memo] = n;
  function a(f) {
    return e.isMemo(f) ? n : o[f.$$typeof] || t;
  }
  var s = Object.defineProperty, c = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, v = Object.getPrototypeOf, d = Object.prototype;
  function g(f, h, y) {
    if (typeof h != "string") {
      if (d) {
        var k = v(h);
        k && k !== d && g(f, k, y);
      }
      var A = c(h);
      u && (A = A.concat(u(h)));
      for (var x = a(f), w = a(h), b = 0; b < A.length; ++b) {
        var C = A[b];
        if (!r[C] && !(y && y[C]) && !(w && w[C]) && !(x && x[C])) {
          var S = p(h, C);
          try {
            s(f, C, S);
          } catch {
          }
        }
      }
    }
    return f;
  }
  return xi = g, xi;
}
var xd = wd();
const Sn = /* @__PURE__ */ ir(xd);
var Sd = !0;
function kd(e, t, r) {
  var i = "";
  return r.split(" ").forEach(function(n) {
    e[n] !== void 0 ? t.push(e[n] + ";") : n && (i += n + " ");
  }), i;
}
var Ys = function(t, r, i) {
  var n = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (i === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Sd === !1) && t.registered[n] === void 0 && (t.registered[n] = r.styles);
}, Xs = function(t, r, i) {
  Ys(t, r, i);
  var n = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var o = r;
    do
      t.insert(r === o ? "." + n : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function _d(e) {
  for (var t = 0, r, i = 0, n = e.length; n >= 4; ++i, n -= 4)
    r = e.charCodeAt(i) & 255 | (e.charCodeAt(++i) & 255) << 8 | (e.charCodeAt(++i) & 255) << 16 | (e.charCodeAt(++i) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (n) {
    case 3:
      t ^= (e.charCodeAt(i + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(i + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(i) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Cd = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, $d = /[A-Z]|^ms/g, Ed = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ks = function(t) {
  return t.charCodeAt(1) === 45;
}, ro = function(t) {
  return t != null && typeof t != "boolean";
}, Si = /* @__PURE__ */ Us(function(e) {
  return Ks(e) ? e : e.replace($d, "-$&").toLowerCase();
}), io = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(Ed, function(i, n, o) {
          return et = {
            name: n,
            styles: o,
            next: et
          }, n;
        });
  }
  return Cd[t] !== 1 && !Ks(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function vr(e, t, r) {
  if (r == null)
    return "";
  var i = r;
  if (i.__emotion_styles !== void 0)
    return i;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var n = r;
      if (n.anim === 1)
        return et = {
          name: n.name,
          styles: n.styles,
          next: et
        }, n.name;
      var o = r;
      if (o.styles !== void 0) {
        var a = o.next;
        if (a !== void 0)
          for (; a !== void 0; )
            et = {
              name: a.name,
              styles: a.styles,
              next: et
            }, a = a.next;
        var s = o.styles + ";";
        return s;
      }
      return Rd(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var c = et, u = r(e);
        return et = c, vr(e, t, u);
      }
      break;
    }
  }
  var p = r;
  return p;
}
function Rd(e, t, r) {
  var i = "";
  if (Array.isArray(r))
    for (var n = 0; n < r.length; n++)
      i += vr(e, t, r[n]) + ";";
  else
    for (var o in r) {
      var a = r[o];
      if (typeof a != "object") {
        var s = a;
        ro(s) && (i += Si(o) + ":" + io(o, s) + ";");
      } else if (Array.isArray(a) && typeof a[0] == "string" && t == null)
        for (var c = 0; c < a.length; c++)
          ro(a[c]) && (i += Si(o) + ":" + io(o, a[c]) + ";");
      else {
        var u = vr(e, t, a);
        switch (o) {
          case "animation":
          case "animationName": {
            i += Si(o) + ":" + u + ";";
            break;
          }
          default:
            i += o + "{" + u + "}";
        }
      }
    }
  return i;
}
var no = /label:\s*([^\s;{]+)\s*(;|$)/g, et;
function kn(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var i = !0, n = "";
  et = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    i = !1, n += vr(r, t, o);
  else {
    var a = o;
    n += a[0];
  }
  for (var s = 1; s < e.length; s++)
    if (n += vr(r, t, e[s]), i) {
      var c = o;
      n += c[s];
    }
  no.lastIndex = 0;
  for (var u = "", p; (p = no.exec(n)) !== null; )
    u += "-" + p[1];
  var v = _d(n) + u;
  return {
    name: v,
    styles: n,
    next: et
  };
}
var Ad = function(t) {
  return t();
}, Qs = Oe.useInsertionEffect ? Oe.useInsertionEffect : !1, Id = Qs || Ad, oo = Qs || Oe.useLayoutEffect, Zs = /* @__PURE__ */ Oe.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ yd({
    key: "css"
  }) : null
);
Zs.Provider;
var Js = function(t) {
  return /* @__PURE__ */ ni(function(r, i) {
    var n = ii(Zs);
    return t(r, n, i);
  });
}, _n = /* @__PURE__ */ Oe.createContext({}), Od = function() {
  return Oe.useContext(_n);
}, xr = {}.hasOwnProperty, tn = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Cn = function(t, r) {
  var i = {};
  for (var n in r)
    xr.call(r, n) && (i[n] = r[n]);
  return i[tn] = t, i;
}, Bd = function(t) {
  var r = t.cache, i = t.serialized, n = t.isStringTag;
  return Ys(r, i, n), Id(function() {
    return Xs(r, i, n);
  }), null;
}, Pd = /* @__PURE__ */ Js(function(e, t, r) {
  var i = e.css;
  typeof i == "string" && t.registered[i] !== void 0 && (i = t.registered[i]);
  var n = e[tn], o = [i], a = "";
  typeof e.className == "string" ? a = kd(t.registered, o, e.className) : e.className != null && (a = e.className + " ");
  var s = kn(o, void 0, Oe.useContext(_n));
  a += t.key + "-" + s.name;
  var c = {};
  for (var u in e)
    xr.call(e, u) && u !== "css" && u !== tn && (c[u] = e[u]);
  return c.className = a, r && (c.ref = r), /* @__PURE__ */ Oe.createElement(Oe.Fragment, null, /* @__PURE__ */ Oe.createElement(Bd, {
    cache: t,
    serialized: s,
    isStringTag: typeof n == "string"
  }), /* @__PURE__ */ Oe.createElement(n, c));
}), $n = Pd, Dd = fr.Fragment, B = function(t, r, i) {
  return xr.call(r, "css") ? fr.jsx($n, Cn(t, r), i) : fr.jsx(t, r, i);
}, Re = function(t, r, i) {
  return xr.call(r, "css") ? fr.jsxs($n, Cn(t, r), i) : fr.jsxs(t, r, i);
};
function dr(e, t = {}) {
  const r = Be.count(e);
  return r === 0 ? null : typeof e == "string" && e.length > 0 || r > 1 ? B("span", {
    ...t,
    children: e
  }) : Ht(Array.isArray(e) ? e[0] : e, t);
}
const Md = process.env.NODE_ENV == "production" ? () => (e) => e : rr((e, t, r) => class extends e {
  componentDidMount() {
    t && so(e.name, this.props, t, r), super.componentDidMount && super.componentDidMount();
  }
  componentDidUpdate(n, o, a) {
    t && so(e.name, this.props, t, r), super.componentDidUpdate && super.componentDidUpdate(n, o, a);
  }
});
function so(e, t, r, i = "") {
  r.forEach((n) => {
    ct(typeof t[n] > "u", `[${e}] The \`${n}\` prop is a temporary hack and will be removed in a future release. ${i}`);
  });
}
function ao(e) {
  return typeof e == "string" ? e : e.displayName || e.name;
}
function Gt(e, t, r) {
  var i, n;
  return t.as && t.as !== ((i = e.defaultProps) === null || i === void 0 ? void 0 : i.as) ? t.as : t.href ? "a" : t.to ? (ct(
    // if to prop is used without as
    !t.as,
    `[${e.displayName}] \`as\` prop should be provided when using \`to\``
  ), "a") : typeof t.onClick == "function" ? "button" : ((n = e.defaultProps) === null || n === void 0 ? void 0 : n.as) || "span";
}
function li({
  props: e = {},
  interactionTypes: t = ["disabled", "readonly"]
} = {}) {
  const r = e.interaction, i = e.disabled, n = e.readOnly;
  return r || (t.includes("disabled") && i ? "disabled" : t.includes("readonly") && n ? "readonly" : "enabled");
}
function Sr(e, t = []) {
  return e && e.type ? t.map((i) => ao(i)).indexOf(ao(e.type)) >= 0 : !1;
}
function Ne(e, t, r) {
  const n = Array.isArray(t) ? t : Object.keys(t || {});
  return zd(e, n);
}
const Fd = Object.prototype.hasOwnProperty, zd = (e, t) => {
  const r = {};
  for (const i in e)
    i === "theme" || i === "children" || i === "className" || i === "style" || i === "styles" || i === "makeStyles" || i === "themeOverride" || i === "deterministicId" || t.includes(i) || !Fd.call(e, i) || (r[i] = e[i]);
  return r;
};
var Td = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ld = /* @__PURE__ */ Us(
  function(e) {
    return Td.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function it(e) {
  const t = {};
  return Object.keys(e).filter((r) => Ld(r) && r !== "style" && r !== "className" && r !== "children" && r !== "styles" && r !== "makeStyles" && r !== "deterministicId").forEach((r) => {
    t[r] = e[r];
  }), t;
}
function Vt(e, t, r) {
  const i = Array.isArray(t) ? t : Object.keys(t || {}), n = r ? i.concat(r) : i;
  return Hd(e, n);
}
function Hd(e, t) {
  const r = {}, i = t.length;
  let n = -1, o;
  for (; ++n < i; )
    o = t[n], o in e && (r[o] = e[o]);
  return r;
}
const ki = "__INSTUI_GLOBAL_INSTANCE_COUNTER__";
function Nd() {
  if (globalThis[ki])
    return globalThis[ki];
  const e = /* @__PURE__ */ new Map();
  return globalThis[ki] = e, e;
}
const Wd = Nd(), Gd = /* @__PURE__ */ hn.createContext(Wd), di = rr((e) => {
  const t = /* @__PURE__ */ ni((r, i) => {
    const n = e.componentId || e.displayName || e.name, o = ii(Gd), a = (s = n) => cl(s, o);
    return r.deterministicId && ct(!1, `Manually passing the "deterministicId" property is not allowed on the ${n} component.
`, r.deterministicId), B(e, {
      ref: i,
      deterministicId: a,
      ...r
    });
  });
  return Sn(t, e), t.propTypes = e.propTypes, t.defaultProps = e.defaultProps, t.allowedProps = e.allowedProps, t.originalType = e.originalType || e, process.env.NODE_ENV !== "production" && (t.displayName = `WithDeterministicId(${e.displayName})`), t;
});
var lo = function(t, r) {
  var i = arguments;
  if (r == null || !xr.call(r, "css"))
    return Oe.createElement.apply(void 0, i);
  var n = i.length, o = new Array(n);
  o[0] = $n, o[1] = Cn(t, r);
  for (var a = 2; a < n; a++)
    o[a] = i[a];
  return Oe.createElement.apply(null, o);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(lo || (lo = {}));
var Vd = /* @__PURE__ */ Js(function(e, t) {
  var r = e.styles, i = kn([r], void 0, Oe.useContext(_n)), n = Oe.useRef();
  return oo(function() {
    var o = t.key + "-global", a = new t.sheet.constructor({
      key: o,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), s = !1, c = document.querySelector('style[data-emotion="' + o + " " + i.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), c !== null && (s = !0, c.setAttribute("data-emotion", o), a.hydrate([c])), n.current = [a, s], function() {
      a.flush();
    };
  }, [t]), oo(function() {
    var o = n.current, a = o[0], s = o[1];
    if (s) {
      o[1] = !1;
      return;
    }
    if (i.next !== void 0 && Xs(t, i.next, !0), a.tags.length) {
      var c = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = c, a.flush();
    }
    t.insert("", i, a, !1);
  }, [t, i.name]), null;
});
function jd() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return kn(t);
}
function ea() {
  var e = jd.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var Or = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var _i, co;
function Ud() {
  if (co) return _i;
  co = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(p) {
        return a[p];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        u[p] = p;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return _i = n() ? Object.assign : function(o, a) {
    for (var s, c = i(o), u, p = 1; p < arguments.length; p++) {
      s = Object(arguments[p]);
      for (var v in s)
        t.call(s, v) && (c[v] = s[v]);
      if (e) {
        u = e(s);
        for (var d = 0; d < u.length; d++)
          r.call(s, u[d]) && (c[u[d]] = s[u[d]]);
      }
    }
    return c;
  }, _i;
}
var Ci, uo;
function En() {
  if (uo) return Ci;
  uo = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ci = e, Ci;
}
var $i, fo;
function ta() {
  return fo || (fo = 1, $i = Function.call.bind(Object.prototype.hasOwnProperty)), $i;
}
var Ei, ho;
function qd() {
  if (ho) return Ei;
  ho = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ En(), r = {}, i = /* @__PURE__ */ ta();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function n(o, a, s, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in o)
        if (i(o, p)) {
          var v;
          try {
            if (typeof o[p] != "function") {
              var d = Error(
                (c || "React class") + ": " + s + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            v = o[p](a, p, c, s, null, t);
          } catch (f) {
            v = f;
          }
          if (v && !(v instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in r)) {
            r[v.message] = !0;
            var g = u ? u() : "";
            e(
              "Failed " + s + " type: " + v.message + (g ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Ei = n, Ei;
}
var Ri, po;
function Yd() {
  if (po) return Ri;
  po = 1;
  var e = xn(), t = Ud(), r = /* @__PURE__ */ En(), i = /* @__PURE__ */ ta(), n = /* @__PURE__ */ qd(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Ri = function(s, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function v(R) {
      var I = R && (u && R[u] || R[p]);
      if (typeof I == "function")
        return I;
    }
    var d = "<<anonymous>>", g = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: A(),
      arrayOf: x,
      element: w(),
      elementType: b(),
      instanceOf: C,
      node: D(),
      objectOf: Y,
      oneOf: S,
      oneOfType: _,
      shape: H,
      exact: me
    };
    function f(R, I) {
      return R === I ? R !== 0 || 1 / R === 1 / I : R !== R && I !== I;
    }
    function h(R, I) {
      this.message = R, this.data = I && typeof I == "object" ? I : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function y(R) {
      if (process.env.NODE_ENV !== "production")
        var I = {}, G = 0;
      function W(L, z, N, P, K, U, ge) {
        if (P = P || d, U = U || N, ge !== r) {
          if (c) {
            var O = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw O.name = "Invariant Violation", O;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ke = P + ":" + N;
            !I[ke] && // Avoid spamming the console because they are often not actionable except for lib authors
            G < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + P + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), I[ke] = !0, G++);
          }
        }
        return z[N] == null ? L ? z[N] === null ? new h("The " + K + " `" + U + "` is marked as required " + ("in `" + P + "`, but its value is `null`.")) : new h("The " + K + " `" + U + "` is marked as required in " + ("`" + P + "`, but its value is `undefined`.")) : null : R(z, N, P, K, U);
      }
      var T = W.bind(null, !1);
      return T.isRequired = W.bind(null, !0), T;
    }
    function k(R) {
      function I(G, W, T, L, z, N) {
        var P = G[W], K = le(P);
        if (K !== R) {
          var U = pe(P);
          return new h(
            "Invalid " + L + " `" + z + "` of type " + ("`" + U + "` supplied to `" + T + "`, expected ") + ("`" + R + "`."),
            { expectedType: R }
          );
        }
        return null;
      }
      return y(I);
    }
    function A() {
      return y(a);
    }
    function x(R) {
      function I(G, W, T, L, z) {
        if (typeof R != "function")
          return new h("Property `" + z + "` of component `" + T + "` has invalid PropType notation inside arrayOf.");
        var N = G[W];
        if (!Array.isArray(N)) {
          var P = le(N);
          return new h("Invalid " + L + " `" + z + "` of type " + ("`" + P + "` supplied to `" + T + "`, expected an array."));
        }
        for (var K = 0; K < N.length; K++) {
          var U = R(N, K, T, L, z + "[" + K + "]", r);
          if (U instanceof Error)
            return U;
        }
        return null;
      }
      return y(I);
    }
    function w() {
      function R(I, G, W, T, L) {
        var z = I[G];
        if (!s(z)) {
          var N = le(z);
          return new h("Invalid " + T + " `" + L + "` of type " + ("`" + N + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(R);
    }
    function b() {
      function R(I, G, W, T, L) {
        var z = I[G];
        if (!e.isValidElementType(z)) {
          var N = le(z);
          return new h("Invalid " + T + " `" + L + "` of type " + ("`" + N + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(R);
    }
    function C(R) {
      function I(G, W, T, L, z) {
        if (!(G[W] instanceof R)) {
          var N = R.name || d, P = V(G[W]);
          return new h("Invalid " + L + " `" + z + "` of type " + ("`" + P + "` supplied to `" + T + "`, expected ") + ("instance of `" + N + "`."));
        }
        return null;
      }
      return y(I);
    }
    function S(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function I(G, W, T, L, z) {
        for (var N = G[W], P = 0; P < R.length; P++)
          if (f(N, R[P]))
            return null;
        var K = JSON.stringify(R, function(ge, O) {
          var ke = pe(O);
          return ke === "symbol" ? String(O) : O;
        });
        return new h("Invalid " + L + " `" + z + "` of value `" + String(N) + "` " + ("supplied to `" + T + "`, expected one of " + K + "."));
      }
      return y(I);
    }
    function Y(R) {
      function I(G, W, T, L, z) {
        if (typeof R != "function")
          return new h("Property `" + z + "` of component `" + T + "` has invalid PropType notation inside objectOf.");
        var N = G[W], P = le(N);
        if (P !== "object")
          return new h("Invalid " + L + " `" + z + "` of type " + ("`" + P + "` supplied to `" + T + "`, expected an object."));
        for (var K in N)
          if (i(N, K)) {
            var U = R(N, K, T, L, z + "." + K, r);
            if (U instanceof Error)
              return U;
          }
        return null;
      }
      return y(I);
    }
    function _(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var I = 0; I < R.length; I++) {
        var G = R[I];
        if (typeof G != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $e(G) + " at index " + I + "."
          ), a;
      }
      function W(T, L, z, N, P) {
        for (var K = [], U = 0; U < R.length; U++) {
          var ge = R[U], O = ge(T, L, z, N, P, r);
          if (O == null)
            return null;
          O.data && i(O.data, "expectedType") && K.push(O.data.expectedType);
        }
        var ke = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new h("Invalid " + N + " `" + P + "` supplied to " + ("`" + z + "`" + ke + "."));
      }
      return y(W);
    }
    function D() {
      function R(I, G, W, T, L) {
        return oe(I[G]) ? null : new h("Invalid " + T + " `" + L + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return y(R);
    }
    function F(R, I, G, W, T) {
      return new h(
        (R || "React class") + ": " + I + " type `" + G + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + T + "`."
      );
    }
    function H(R) {
      function I(G, W, T, L, z) {
        var N = G[W], P = le(N);
        if (P !== "object")
          return new h("Invalid " + L + " `" + z + "` of type `" + P + "` " + ("supplied to `" + T + "`, expected `object`."));
        for (var K in R) {
          var U = R[K];
          if (typeof U != "function")
            return F(T, L, z, K, pe(U));
          var ge = U(N, K, T, L, z + "." + K, r);
          if (ge)
            return ge;
        }
        return null;
      }
      return y(I);
    }
    function me(R) {
      function I(G, W, T, L, z) {
        var N = G[W], P = le(N);
        if (P !== "object")
          return new h("Invalid " + L + " `" + z + "` of type `" + P + "` " + ("supplied to `" + T + "`, expected `object`."));
        var K = t({}, G[W], R);
        for (var U in K) {
          var ge = R[U];
          if (i(R, U) && typeof ge != "function")
            return F(T, L, z, U, pe(ge));
          if (!ge)
            return new h(
              "Invalid " + L + " `" + z + "` key `" + U + "` supplied to `" + T + "`.\nBad object: " + JSON.stringify(G[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(R), null, "  ")
            );
          var O = ge(N, U, T, L, z + "." + U, r);
          if (O)
            return O;
        }
        return null;
      }
      return y(I);
    }
    function oe(R) {
      switch (typeof R) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !R;
        case "object":
          if (Array.isArray(R))
            return R.every(oe);
          if (R === null || s(R))
            return !0;
          var I = v(R);
          if (I) {
            var G = I.call(R), W;
            if (I !== R.entries) {
              for (; !(W = G.next()).done; )
                if (!oe(W.value))
                  return !1;
            } else
              for (; !(W = G.next()).done; ) {
                var T = W.value;
                if (T && !oe(T[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function he(R, I) {
      return R === "symbol" ? !0 : I ? I["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && I instanceof Symbol : !1;
    }
    function le(R) {
      var I = typeof R;
      return Array.isArray(R) ? "array" : R instanceof RegExp ? "object" : he(I, R) ? "symbol" : I;
    }
    function pe(R) {
      if (typeof R > "u" || R === null)
        return "" + R;
      var I = le(R);
      if (I === "object") {
        if (R instanceof Date)
          return "date";
        if (R instanceof RegExp)
          return "regexp";
      }
      return I;
    }
    function $e(R) {
      var I = pe(R);
      switch (I) {
        case "array":
        case "object":
          return "an " + I;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + I;
        default:
          return I;
      }
    }
    function V(R) {
      return !R.constructor || !R.constructor.name ? d : R.constructor.name;
    }
    return g.checkPropTypes = n, g.resetWarningCache = n.resetWarningCache, g.PropTypes = g, g;
  }, Ri;
}
var Ai, go;
function Xd() {
  if (go) return Ai;
  go = 1;
  var e = /* @__PURE__ */ En();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Ai = function() {
    function i(a, s, c, u, p, v) {
      if (v !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    i.isRequired = i;
    function n() {
      return i;
    }
    var o = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: n,
      element: i,
      elementType: i,
      instanceOf: n,
      node: i,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Ai;
}
var vo;
function Kd() {
  if (vo) return Or.exports;
  if (vo = 1, process.env.NODE_ENV !== "production") {
    var e = xn(), t = !0;
    Or.exports = /* @__PURE__ */ Yd()(e.isElement, t);
  } else
    Or.exports = /* @__PURE__ */ Xd()();
  return Or.exports;
}
var Qd = /* @__PURE__ */ Kd();
const l = /* @__PURE__ */ ir(Qd);
function Zd(e, t) {
  if (e == null) return {};
  var r = {};
  for (var i in e) if ({}.hasOwnProperty.call(e, i)) {
    if (t.indexOf(i) !== -1) continue;
    r[i] = e[i];
  }
  return r;
}
function Se(e, t) {
  if (e == null) return {};
  var r, i, n = Zd(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++) r = o[i], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
let ar, Br, Ii;
const Jd = () => {
  if (ar)
    return ar;
  if (rt) {
    const e = document.documentElement;
    return Br = e.getAttribute("dir"), ar = Br || yt(e).direction, Ii || (Ii = new MutationObserver(() => {
      const t = e.getAttribute("dir");
      t && t !== Br && (Br = ar = t);
    }), Ii.observe(e, {
      attributes: !0
    })), ar;
  }
};
function ec(e) {
  if (rt)
    return Jd();
}
const tc = /* @__PURE__ */ pn(ec() || "ltr"), ci = {
  ltr: "ltr",
  rtl: "rtl"
}, rc = ["forwardedRef"], Rn = rr((e) => {
  class t extends ae {
    render() {
      const n = this.props, o = n.forwardedRef, a = Se(n, rc);
      return B(tc.Consumer, {
        children: (s) => (process.env.NODE_ENV, B(e, {
          ref: o,
          dir: s,
          ...a
        }))
      });
    }
  }
  t.displayName = "TextDirectionContextConsumerComponent";
  const r = /* @__PURE__ */ ni((i, n) => B(t, {
    ...i,
    forwardedRef: n
  }));
  if (process.env.NODE_ENV !== "production") {
    const i = e.displayName || e.name;
    r.displayName = `TextDirectionContextConsumerForwardingRef(${i})`;
  }
  return Sn(r, e), r.defaultProps = e.defaultProps, r.propTypes = // eslint-disable-next-line react/forbid-foreign-prop-types
  e.propTypes, r.allowedProps = // @ts-expect-error These static fields exist on InstUI components
  e.allowedProps, r.originalType = e.originalType || e, r;
});
Rn.DIRECTION = ci;
function yo(e) {
  return function(t, r, i, n = "", o = "") {
    const a = t[r];
    return a === null || typeof a > "u" ? new Error(`The prop \`${r}\` is marked as required in \`${i}\`, but its value is \`${a}\``) : e(t, r, i, n, o);
  };
}
const ra = {
  /**
   * Validate that the children of a component are one of the specified types.
   *
   * ```js
   *  import { Children } from '@instructure/ui-prop-types'
   *
   *  class Example extends Component {
   *    static propTypes = {
   *      children: Children.oneOf([Foo, Bar, Baz])
   *    }
   *
   *    render () {
   *      return <div>{this.props.children}</div>
   *    }
   *  }
   * ```
   *
   * This will allow children such as:
   *
   * ```jsx
   *  <Example>
   *    <Foo />
   *  </Example>
   * ```
   *
   *  OR
   *
   * ```jsx
   *  <Example>
   *    <Bar />
   *    <Foo />
   *  </Example>
   * ```
   *
   * But will fail on something like:
   *
   * ```jsx
   *  <Example>
   *    <h1>Example</h1>
   *    <Foo />
   *  </Example>
   * ```
   * @returns {function} A validator function that returns Error if validation failed
   */
  oneOf(e) {
    function t(r, i, n) {
      const o = Be.toArray(r[i]), a = e.map((s) => s && wt(s));
      for (let s = 0; s < o.length; s++) {
        const c = o[s];
        if (c && c.type) {
          const u = wt(c.type);
          if (a.indexOf(u) < 0)
            return new Error(`Expected one of ${a.join(", ")} in ${n} but found '${u}'`);
        } else if (c)
          return new Error(`Expected one of ${a.join(", ")} in ${n} but found an element with unknown type: ${c}`);
      }
      return null;
    }
    return t.isRequired = yo(t), t;
  },
  /**
   * Ensures that there is exactly one of each specified child
   *
   * ```js
   *  import { Children } from '@instructure/ui-prop-types'
   *
   *  class Example extends Component {
   *    static propTypes = {
   *      children: Children.oneOfEach([Foo, Bar, Baz])
   *    }
   *
   *    render () {
   *      return <div>{this.props.children}</div>
   *    }
   *  }
   * ```
   *
   * This will enforce the following:
   *
   * ```jsx
   *  <Example>
   *    <Foo />
   *    <Bar />
   *    <Baz />
   *  </Example>
   * ```
   * An error will be thrown
   *  - If any of the children are not provided (ex. Foo, Bar, but missing Baz)
   *  - If multiple children of the same type are provided (ex. Foo, Foo, Bar, and Baz)
   *
   * @param {Array} validTypes - Array of child types
   * @returns {function} A validator function that returns error if validation
   * failed, null otherwise
   */
  oneOfEach(e) {
    return function(t, r, i) {
      const n = Be.toArray(t[r]), o = {}, a = e.map((c) => {
        const u = wt(c);
        return o[u] = 0, u;
      });
      for (let c = 0; c < n.length; c++) {
        const u = n[c];
        if (u && u.type) {
          const p = wt(u.type);
          if (a.indexOf(p) < 0)
            return new Error(`Expected one of ${a.join(", ")} in ${i} but found '${p}'`);
          o[p] = (o[p] || 0) + 1;
        } else if (u)
          return new Error(`Expected one of ${a.join(", ")} in ${i} but found an element of unknown type: ${u}`);
      }
      const s = [];
      return Object.keys(o).forEach((c) => {
        o[c] > 1 && s.push(`${o[c]} children of type ${c}`), o[c] === 0 && s.push(`0 children of type ${c}`);
      }), s.length > 0 ? new Error(`Expected exactly one of each ${a.join(", ")} in ${i} but found:${s.join(`
`)}`) : null;
    };
  },
  /**
   * Validate the type and order of children for a component.
   *
   * ```js
   *  import { Children } from '@instructure/ui-prop-types'
   *
   *  class Example extends Component {
   *    static propTypes = {
   *      children: Children.enforceOrder([Foo, Bar, Baz])
   *    }
   *
   *    render () {
   *      return <div>{this.props.children}</div>
   *    }
   *  }
   * ```
   *
   * This will enforce the following:
   *
   * ```jsx
   *  <Example>
   *    <Foo />
   *    <Bar />
   *    <Baz />
   *  </Example>
   * ```
   *
   * This validator will also allow various permutations of the order.
   *
   * ```js
   *  import { Children } from '@instructure/ui-prop-types'
   *
   *  class Example extends Component {
   *    static propTypes = {
   *      children: Children.enforceOrder(
   *        [Foo, Bar, Baz],
   *        [Foo, Bar],
   *        [Bar, Baz],
   *      )
   *    }
   *
   *    render () {
   *      return <div>{this.props.children}</div>
   *    }
   *  }
   * ```
   *
   * This will enforce one of the following:
   *
   * ```jsx
   *  <Example>
   *    <Foo />
   *    <Bar />
   *    <Baz />
   *  </Example>
   * ```
   *
   *  OR
   *
   * ```jsx
   *  <Example>
   *    <Foo />
   *    <Bar />
   *  </Example>
   * ```
   *
   *  OR
   *
   * ```jsx
   *  <Example>
   *    <Bar />
   *    <Baz />
   *  </Example>
   * ```
   *
   * @param {...Array} validTypeGroups One or more Arrays of valid types
   * @returns {function} A validator function that returns error if validation
   * failed, null otherwise
   */
  enforceOrder(...e) {
    function t(o, a) {
      for (let s = 0; s < o.length; s++)
        if (o[s] !== a[s])
          return !1;
      return !0;
    }
    function r(o, a) {
      return a.map((s) => i(o, s)).join(`

`);
    }
    function i(o, a) {
      const s = a.map((c) => c ? wt(c) : "??").map((c) => `  <${c} />`).join(`
`);
      return `<${o}>
${s}
</${o}>`;
    }
    function n(o, a, s) {
      const c = Be.toArray(o[a]).map((u) => {
        if (u && u.type)
          return wt(u.type);
        if (u)
          return null;
      });
      for (let u = 0; u < e.length; u++) {
        const p = e[u].map((v) => v ? wt(v) : "??");
        if (t(c, p))
          return null;
      }
      return new Error(`Expected children of ${s} in one of the following formats:
  ${r(s, e)}


  Instead of:
  ${i(s, c)}`);
    }
    return n.isRequired = yo(n), n;
  }
}, wt = (e) => typeof e == "string" ? e : e.displayName || e.name;
function ic(e, t = "onChange", r = "defaultValue") {
  return function(i, n, o) {
    const a = e(i, n, o, "prop", n, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
    return a || (i[n] && typeof i[t] != "function" ? new Error([`You provided a '${n}' prop without an '${t}' handler on '${o}'. This will render a controlled component. If the component should be uncontrolled and manage its own state, use '${r}'. Otherwise, set '${t}'.`].join("")) : null);
  };
}
const nc = l.oneOf(["auto", "default", "none", "context-menu", "help", "pointer", "progress", "wait", "cell", "crosshair", "text", "vertical-text", "alias", "copy", "move", "no-drop", "not-allowed", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out"]), oc = Object.freeze({
  radiusSmall: "0.125rem",
  // 2px
  radiusMedium: "0.25rem",
  // 4px
  radiusLarge: "0.5rem",
  // 8px
  widthSmall: "0.0625rem",
  // 1px
  widthMedium: "0.125rem",
  // 2px
  widthLarge: "0.25rem",
  // 4px
  style: "solid"
}), sc = Object.freeze({
  duration: "300ms",
  timing: "ease-in-out"
}), ac = Object.freeze({
  fontFamily: 'LatoWeb, Lato, "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontFamilyMonospace: 'Menlo, Consolas, Monaco, "Andale Mono", monospace',
  letterSpacingNormal: 0,
  letterSpacingCondensed: "-0.0625rem",
  letterSpacingExpanded: "0.0625rem",
  // deprecated values
  fontSizeXSmall: "0.75rem",
  // 12px
  fontSizeSmall: "0.875rem",
  // 14px
  fontSizeMedium: "1rem",
  // 16px
  fontSizeLarge: "1.375rem",
  // 22px
  fontSizeXLarge: "1.75rem",
  // 28px
  fontSizeXXLarge: "2.375rem",
  // 38px
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightBold: 700,
  lineHeight: 1.5,
  // 24px
  lineHeightFit: 1.125,
  lineHeightCondensed: 1.25,
  lineHeightDouble: 2,
  // new values
  titlePageDesktop: "2.25rem",
  titlePageMobile: "2rem",
  titleSection: "1.75rem",
  titleModule: "1.5rem",
  titleCardLarge: "1.5rem",
  titleCardRegular: "1.25rem",
  titleCardMini: "1rem",
  descriptionPage: "1.25rem",
  descriptionSection: "1rem",
  label: "1rem",
  content: "1rem",
  contentSmall: "0.875rem",
  legend: "0.75rem",
  lineHeight100: 1,
  lineHeight125: 1.25,
  lineHeight150: 1.5,
  weightRegular: 400,
  weightImportant: 700
}), lc = Object.freeze({
  // legacy spacing tokens:
  xxxSmall: "0.125rem",
  // 2px
  xxSmall: "0.375rem",
  // 6px
  xSmall: "0.5rem",
  // 8px
  small: "0.75rem",
  // 12px
  mediumSmall: "1rem",
  // 16px
  medium: "1.5rem",
  // 24px
  large: "2.25rem",
  // 36px
  xLarge: "3rem",
  // 48px
  xxLarge: "3.75rem",
  // 60px
  // new spacing tokens:
  space0: "0rem",
  // 0px
  space2: "0.125rem",
  // 2px
  space4: "0.25rem",
  // 4px
  space8: "0.5rem",
  // 8px
  space12: "0.75rem",
  // 12px
  space16: "1rem",
  // 16px
  space24: "1.5rem",
  // 24px
  space36: "2.25rem",
  // 36px
  space48: "3rem",
  // 48px
  space60: "3.75rem",
  // 60px
  sections: "2.25rem",
  // 36px
  sectionElements: "1.5em",
  // 24px
  trayElements: "1.5em",
  // 24px
  modalElements: "1.5em",
  // 24px
  moduleElements: "1em",
  // 16px
  paddingCardLarge: "1.5rem",
  // 24px
  paddingCardMedium: "1rem",
  // 16px
  paddingCardSmall: "0.75rem",
  // 12px
  selects: "1rem",
  // 16px
  textareas: "1rem",
  // 16px
  inputFields: "1rem",
  // 16px
  checkboxes: "1rem",
  // 16px
  radios: "1rem",
  // 16px
  toggles: "1rem",
  // 16px
  buttons: "0.75rem",
  // 12px
  tags: "0.75rem",
  // 12px
  statusIndicators: "0.75rem",
  // 12px
  dataPoints: "0.75rem"
  // 12px
}), dc = Object.freeze({
  inputHeightSmall: "1.75rem",
  inputHeightMedium: "2.375rem",
  inputHeightLarge: "3rem"
}), cc = 0.0625, st = {
  xxSmall: 8,
  // 128px
  xSmall: 16,
  // 256px
  small: 30,
  // 480px
  medium: 48,
  // 768px
  tablet: 48,
  // 768px
  large: 62,
  // 992px
  desktop: 64,
  // 1024px
  xLarge: 75
  // 1200px
}, Yr = Object.freeze({
  xxSmall: `${st.xxSmall}em`,
  xSmall: `${st.xSmall}em`,
  small: `${st.small}em`,
  medium: `${st.medium}em`,
  tablet: `${st.tablet}em`,
  large: `${st.large}em`,
  desktop: `${st.desktop}em`,
  xLarge: `${st.xLarge}em`,
  maxWidth: `${st.large - cc}em`
}), uc = Object.freeze({
  mediumMin: `min-width: ${Yr.medium}`,
  largeMin: `min-width: ${Yr.large}`,
  xLargeMin: `min-width: ${Yr.xLarge}`
}), pt = ["0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.1)", "0 0.1875rem 0.375rem rgba(0, 0, 0, 0.1), 0 0.1875rem 0.375rem rgba(0, 0, 0, 0.15)", "0 0.375rem 0.4375rem rgba(0, 0, 0, 0.1), 0 0.625rem 1.75rem rgba(0, 0, 0, 0.25)"], fc = Object.freeze({
  depth1: pt[0],
  depth2: pt[1],
  depth3: pt[2],
  resting: pt[0],
  above: pt[1],
  topmost: pt[2],
  card: pt[0],
  cardHover: pt[2]
}), hc = Object.freeze({
  topmost: 9999,
  above: 1,
  below: -1,
  deepest: -9999
}), pc = {
  borders: oc,
  transitions: sc,
  typography: ac,
  spacing: lc,
  forms: dc,
  media: uc,
  breakpoints: Yr,
  shadows: fc,
  stacking: hc
}, gc = ["key", "description"], vc = ["key", "description", "use"], yc = "@@themeRegistryDefaultTheme", ei = "__GLOBAL_THEME_REGISTRY__";
globalThis[ei] ? An(bc(globalThis[ei])) : na();
function ia() {
  return {
    currentThemeKey: null,
    themes: {},
    registered: []
    // the theme keys in the order they are registered,
  };
}
function bc(e) {
  const t = ia();
  if (typeof e > "u")
    return t;
  let r = !0;
  return Object.keys(t).forEach((i) => {
    typeof e[i] > "u" && (r = !1);
  }), Xe(r, "[theme-registry] Invalid global theme registry!"), e;
}
function ui() {
  return globalThis[ei];
}
function An(e) {
  globalThis[ei] = e;
}
function na() {
  An(ia());
}
function mc() {
  const e = ui(), t = e.currentThemeKey;
  if (t)
    return e.themes[t];
}
function wc(e, t) {
  const r = ui(), i = r.themes[e];
  i || e !== yc && Xe(i, `[theme-registry] Could not find theme: '${e}' in the registry.`), r.currentThemeKey = e;
  const n = fl(i, t);
  return r.themes[e] = n, n;
}
function xc(e) {
  const t = e.key, r = e.description, i = Se(e, gc), n = {
    key: t,
    description: r,
    ...i,
    /**
     * Activate a global theme with the given overrides.
     * @deprecated since version 10
     * @param arg
     */
    use(o) {
      wc(t, (o == null ? void 0 : o.overrides) || {});
    }
  };
  return new Proxy(n, {
    get(o, a) {
      o.key, o.description, o.use;
      const s = Se(o, vc);
      return a === "variables" ? s : Reflect.get(o, a);
    }
  });
}
function Sc(e) {
  const t = ui();
  if (e.key && t.themes[e.key])
    return t.themes[e.key];
  {
    if (!Fl(e))
      throw Xe(!1, `[theme-registry] The theme provided to 'registerTheme' is not a valid theme object!
For it to be valid some properties have to be present, check out https://instructure.design/#canvas as a reference.`), new Error();
    const r = xc(e);
    return t.themes[r.key] = r, t.registered.push(r.key), r;
  }
}
const oa = {
  getRegistry: ui,
  clearRegistry: na,
  setRegistry: An,
  registerTheme: Sc,
  getCurrentTheme: mc
}, J = {
  white: "#FFFFFF",
  white10op75: "#FFFFFFBF",
  grey11: "#F2F4F4",
  grey12: "#E8EAEC",
  grey14: "#D7DADE",
  grey24: "#9EA6AD",
  grey30: "#8D959F",
  grey45: "#6A7883",
  grey57: "#586874",
  grey70: "#4A5B68",
  grey82: "#3F515E",
  grey100: "#334451",
  grey100op75: "#334451BF",
  grey125: "#273540",
  blue12: "#E0EBF5",
  blue45: "#2B7ABC",
  blue57: "#0E68B3",
  blue70: "#0A5A9E",
  blue82: "#09508C",
  green12: "#DCEEE4",
  green45: "#03893D",
  green57: "#027634",
  green70: "#02672D",
  green82: "#015B28",
  orange12: "#FCE5D9",
  orange30: "#F06E26",
  orange45: "#CF4A00",
  orange57: "#B34000",
  orange70: "#9C3800",
  orange82: "#8B3200",
  red12: "#FCE4E5",
  red45: "#E62429",
  red57: "#C71F23",
  red70: "#AE1B1F",
  red82: "#9B181C",
  sea12: "#DAEEEF",
  sea30: "#37A1AA",
  sea35: "#1E95A0",
  sea40: "#0A8C97",
  sea45: "#00828E",
  sea50: "#007B86",
  sea57: "#00717B",
  sea70: "#00626B",
  sea90: "#005158",
  sea110: "#004349",
  violet12: "#F1E6F5",
  violet30: "#B57FCC",
  violet35: "#AC6FC6",
  violet40: "#A564C2",
  violet45: "#9E58BD",
  violet50: "#994FB9",
  violet57: "#9242B4",
  violet70: "#7F399E",
  violet90: "#682F82",
  violet110: "#56276B"
}, $ = {
  rose12: "#FEE4E4",
  rose30: "#FB5D5D",
  rose35: "#FA3F3F",
  rose40: "#FA1A1A",
  rose45: "#ED0000",
  rose50: "#E00000",
  rose57: "#CE0000",
  rose70: "#B50000",
  rose90: "#970000",
  rose110: "#7F0000",
  copper12: "#FFE5D3",
  copper30: "#EE6D15",
  copper35: "#DB6414",
  copper40: "#CD5E12",
  copper45: "#BF5811",
  copper50: "#B45310",
  copper57: "#A54C0F",
  copper70: "#90420D",
  copper90: "#77360B",
  copper110: "#622D09",
  honey12: "#F5E9CA",
  honey30: "#C08A00",
  honey35: "#A57600",
  honey40: "#B07E00",
  honey45: "#996E00",
  honey50: "#916800",
  honey57: "#856000",
  honey70: "#745300",
  honey90: "#5F4400",
  honey110: "#4E3800",
  forest12: "#DFEEE0",
  forest30: "#55A459",
  forest35: "#409945",
  forest40: "#319135",
  forest45: "#27872B",
  forest50: "#248029",
  forest57: "#217526",
  forest70: "#1D6621",
  forest90: "#18541B",
  forest110: "#144516",
  aurora12: "#DAEEE8",
  aurora30: "#38A585",
  aurora35: "#1E9975",
  aurora40: "#0B9069",
  aurora45: "#048660",
  aurora50: "#047F5B",
  aurora57: "#037453",
  aurora70: "#036549",
  aurora90: "#02533C",
  aurora110: "#024531",
  sea12: "#DAEEEF",
  sea30: "#37A1AA",
  sea35: "#1E95A0",
  sea40: "#0A8C97",
  sea45: "#00828E",
  sea50: "#007B86",
  sea57: "#00717B",
  sea70: "#00626B",
  sea90: "#005158",
  sea110: "#004349",
  sky12: "#DDECF3",
  sky30: "#4E9CC0",
  sky35: "#3890B8",
  sky40: "#2887B2",
  sky45: "#197EAB",
  sky50: "#1777A2",
  sky57: "#156D94",
  sky70: "#135F81",
  sky90: "#0F4E6A",
  sky110: "#0D4058",
  ocean12: "#DFEBFB",
  ocean30: "#5694EB",
  ocean35: "#4187E8",
  ocean40: "#317DE6",
  ocean45: "#2573DF",
  ocean50: "#236DD3",
  ocean57: "#2063C1",
  ocean70: "#1C57A8",
  ocean90: "#17478B",
  ocean110: "#133B72",
  violet12: "#F1E6F5",
  violet30: "#B57FCC",
  violet35: "#AC6FC6",
  violet40: "#A564C2",
  violet45: "#9E58BD",
  violet50: "#994FB9",
  violet57: "#9242B4",
  violet70: "#7F399E",
  violet90: "#682F82",
  violet110: "#56276B",
  plum12: "#F7E5F0",
  plum30: "#D473B1",
  plum35: "#CE60A7",
  plum40: "#CA529F",
  plum45: "#C54396",
  plum50: "#C1368F",
  plum57: "#BA2083",
  plum70: "#A31C73",
  plum90: "#87175F",
  plum110: "#70134F",
  stone12: "#EAEAEA",
  stone30: "#939393",
  stone35: "#878787",
  stone40: "#7F7F7F",
  stone45: "#767676",
  stone50: "#6F6F6F",
  stone57: "#666666",
  stone70: "#585858",
  stone90: "#494949",
  stone110: "#3C3C3C"
}, kc = {
  rose12Primary: $.rose12,
  rose30Primary: $.rose30,
  rose45Primary: $.rose45,
  rose70Primary: $.rose70,
  rose110Primary: $.rose110,
  rose35Secondary: $.rose35,
  rose40Secondary: $.rose40,
  rose50Secondary: $.rose50,
  rose57Secondary: $.rose57,
  rose90Secondary: $.rose90,
  copper12Primary: $.copper12,
  copper30Primary: $.copper30,
  copper45Primary: $.copper45,
  copper70Primary: $.copper70,
  copper110Primary: $.copper110,
  copper35Secondary: $.copper35,
  copper40Secondary: $.copper40,
  copper50Secondary: $.copper50,
  copper57Secondary: $.copper57,
  copper90Secondary: $.copper90,
  honey12Primary: $.honey12,
  honey30Primary: $.honey30,
  honey45Primary: $.honey45,
  honey70Primary: $.honey70,
  honey110Primary: $.honey110,
  honey35Secondary: $.honey35,
  honey40Secondary: $.honey40,
  honey50Secondary: $.honey50,
  honey57Secondary: $.honey57,
  honey90Secondary: $.honey90,
  forest12Primary: $.forest12,
  forest30Primary: $.forest30,
  forest45Primary: $.forest45,
  forest70Primary: $.forest70,
  forest110Primary: $.forest110,
  forest35Secondary: $.forest35,
  forest40Secondary: $.forest40,
  forest50Secondary: $.forest50,
  forest57Secondary: $.forest57,
  forest90Secondary: $.forest90,
  aurora12Primary: $.aurora12,
  aurora30Primary: $.aurora30,
  aurora45Primary: $.aurora45,
  aurora70Primary: $.aurora70,
  aurora110Primary: $.aurora110,
  aurora35Secondary: $.aurora35,
  aurora40Secondary: $.aurora40,
  aurora50Secondary: $.aurora50,
  aurora57Secondary: $.aurora57,
  aurora90Secondary: $.aurora90,
  sea12Primary: $.sea12,
  sea30Primary: $.sea30,
  sea45Primary: $.sea45,
  sea70Primary: $.sea70,
  sea110Primary: $.sea110,
  sea35Secondary: $.sea35,
  sea40Secondary: $.sea40,
  sea50Secondary: $.sea50,
  sea57Secondary: $.sea57,
  sea90Secondary: $.sea90,
  sky12Primary: $.sky12,
  sky30Primary: $.sky30,
  sky45Primary: $.sky45,
  sky70Primary: $.sky70,
  sky110Primary: $.sky110,
  sky35Secondary: $.sky35,
  sky40Secondary: $.sky40,
  sky50Secondary: $.sky50,
  sky57Secondary: $.sky57,
  sky90Secondary: $.sky90,
  ocean12Primary: $.ocean12,
  ocean30Primary: $.ocean30,
  ocean45Primary: $.ocean45,
  ocean70Primary: $.ocean70,
  ocean110Primary: $.ocean110,
  ocean35Secondary: $.ocean35,
  ocean40Secondary: $.ocean40,
  ocean50Secondary: $.ocean50,
  ocean57Secondary: $.ocean57,
  ocean90Secondary: $.ocean90,
  violet12Primary: $.violet12,
  violet30Primary: $.violet30,
  violet45Primary: $.violet45,
  violet70Primary: $.violet70,
  violet110Primary: $.violet110,
  violet35Secondary: $.violet35,
  violet40Secondary: $.violet40,
  violet50Secondary: $.violet50,
  violet57Secondary: $.violet57,
  violet90Secondary: $.violet90,
  plum12Primary: $.plum12,
  plum30Primary: $.plum30,
  plum45Primary: $.plum45,
  plum70Primary: $.plum70,
  plum110Primary: $.plum110,
  plum35Secondary: $.plum35,
  plum40Secondary: $.plum40,
  plum50Secondary: $.plum50,
  plum57Secondary: $.plum57,
  plum90Secondary: $.plum90,
  stone12Primary: $.stone12,
  stone30Primary: $.stone30,
  stone45Primary: $.stone45,
  stone70Primary: $.stone70,
  stone110Primary: $.stone110,
  stone35Secondary: $.stone35,
  stone40Secondary: $.stone40,
  stone50Secondary: $.stone50,
  stone57Secondary: $.stone57,
  stone90Secondary: $.stone90
}, _c = (e) => ({
  surfacePagePrimary: e == null ? void 0 : e.white1010,
  surfacePageSecondary: e == null ? void 0 : e.grey1111,
  surfaceCardPrimary: e == null ? void 0 : e.white1010,
  surfaceCardSecondary: e == null ? void 0 : e.grey1111,
  surfaceDark: e == null ? void 0 : e.grey100100,
  textTitle: e == null ? void 0 : e.grey125125,
  textDescription: e == null ? void 0 : e.grey125125,
  textBody: e == null ? void 0 : e.grey125125,
  textTimestamp: e == null ? void 0 : e.grey5782,
  textAuthor: e == null ? void 0 : e.grey5782,
  textDatapoint: e == null ? void 0 : e.grey5782,
  textLink: e == null ? void 0 : e.blue5782,
  textPlaceholder: e == null ? void 0 : e.grey2424,
  textSuccess: e == null ? void 0 : e.green5782,
  textWarning: e == null ? void 0 : e.orange5782,
  textError: e == null ? void 0 : e.red5782,
  lineStroke: e == null ? void 0 : e.grey1424,
  lineDivider: e == null ? void 0 : e.grey1214,
  surfaceOverlayGrey: e == null ? void 0 : e.grey100100op75,
  surfaceOverlayWhite: e == null ? void 0 : e.white1010op75,
  surfaceAttention: e == null ? void 0 : e.blue4570,
  surfaceSuccess: e == null ? void 0 : e.green4570,
  surfaceWarning: e == null ? void 0 : e.orange4570,
  surfaceError: e == null ? void 0 : e.red4570,
  surfaceDivider: e == null ? void 0 : e.grey1214,
  textSurfaceColored: e == null ? void 0 : e.white1010,
  iconDefault: e == null ? void 0 : e.grey125125,
  iconSuccess: e == null ? void 0 : e.green4570,
  iconWarning: e == null ? void 0 : e.orange4570,
  iconError: e == null ? void 0 : e.red4570,
  iconSurfaceColored: e == null ? void 0 : e.white1010,
  lineConnector: e == null ? void 0 : e.grey1424
}), sa = {
  white1010: J.white,
  white1010op75: J.white10op75,
  grey1111: J.grey11,
  grey1214: J.grey12,
  grey1424: J.grey14,
  grey2424: J.grey24,
  grey3045: J.grey30,
  grey4570: J.grey45,
  grey5782: J.grey57,
  grey100100: J.grey100,
  grey100100op75: J.grey100op75,
  grey125125: J.grey125,
  blue1212: J.blue12,
  blue4570: J.blue45,
  blue5782: J.blue57,
  green1212: J.green12,
  green4570: J.green45,
  green5782: J.green57,
  orange1212: J.orange12,
  orange3045: J.orange30,
  orange4570: J.orange45,
  orange5782: J.orange57,
  red1212: J.red12,
  red4570: J.red45,
  red5782: J.red57,
  violet1212: J.violet12,
  violet4570: J.violet45,
  violet5790: J.violet57,
  sea4570: J.sea45,
  sea5790: J.sea57
}, Cc = _c(sa), X = {
  primitives: J,
  additionalPrimitives: $,
  contrasts: sa,
  ui: Cc,
  dataVisualization: kc
};
var Oi, Bi, Pi, Di, Mi, Fi, zi, Ti, Li, Hi, Ni, Wi, Gi;
const $c = "canvas", Ec = {
  /* Defaults for Canvas account branding variables: */
  // used for border/background/shadow colors in many places
  "ic-brand-primary": X == null || (Oi = X.contrasts) === null || Oi === void 0 ? void 0 : Oi.blue4570,
  // used in lots of places for text color
  "ic-brand-font-color-dark": X == null || (Bi = X.contrasts) === null || Bi === void 0 ? void 0 : Bi.grey125125,
  // used by Link and links in Billboard
  "ic-link-color": X == null || (Pi = X.contrasts) === null || Pi === void 0 ? void 0 : Pi.blue5782,
  "ic-link-decoration": "none",
  // Used by BaseButton and its subcomponents
  "ic-brand-button--primary-bgd": X == null || (Di = X.contrasts) === null || Di === void 0 ? void 0 : Di.blue4570,
  "ic-brand-button--primary-text": X == null || (Mi = X.contrasts) === null || Mi === void 0 ? void 0 : Mi.white1010,
  "ic-brand-button--secondary-bgd": X == null || (Fi = X.contrasts) === null || Fi === void 0 ? void 0 : Fi.grey125125,
  // unused!
  "ic-brand-button--secondary-text": X == null || (zi = X.contrasts) === null || zi === void 0 ? void 0 : zi.white1010,
  // unused!
  // these are used only by SideNavBar
  "ic-brand-global-nav-bgd": X == null || (Ti = X.contrasts) === null || Ti === void 0 ? void 0 : Ti.grey100100,
  "ic-global-nav-link-hover": X == null || (Li = X.contrasts) === null || Li === void 0 ? void 0 : Li.grey125125,
  "ic-brand-global-nav-ic-icon-svg-fill": X == null || (Hi = X.contrasts) === null || Hi === void 0 ? void 0 : Hi.white1010,
  "ic-brand-global-nav-ic-icon-svg-fill--active": X == null || (Ni = X.contrasts) === null || Ni === void 0 ? void 0 : Ni.blue4570,
  "ic-brand-global-nav-menu-item__text-color": X == null || (Wi = X.contrasts) === null || Wi === void 0 ? void 0 : Wi.white1010,
  "ic-brand-global-nav-menu-item__text-color--active": X == null || (Gi = X.contrasts) === null || Gi === void 0 ? void 0 : Gi.blue4570
}, Rc = {
  key: $c,
  description: "This theme meets WCAG 2.1 AA rules for color contrast.",
  ...pc,
  colors: X,
  ...Ec
}, Ac = oa.registerTheme(Rc), Ic = (e, t, r, i, n) => {
  const o = t, a = r, s = i ? i.themeOverride : void 0, c = e, u = c.componentOverrides;
  let p = {}, v = {};
  return u && (p = o && u[o] || a && u[a] || {}), s && (typeof s == "function" ? v = s(
    n || {},
    // the `theme` technically could be a partial theme / override object too,
    // but we want to display all possible options
    e
  ) : v = s), {
    ...p,
    ...v
  };
}, Oc = () => {
  let e = Od();
  if (Ms(e)) {
    const t = oa.getCurrentTheme();
    if (t)
      return t;
    process.env.NODE_ENV, e = Ac;
  }
  return e;
}, Vi = {
  styles: {},
  makeStyles: () => {
  }
}, fe = rr((e, t, r) => {
  const i = e.displayName || e.name, n = /* @__PURE__ */ ni((o, a) => {
    const s = Oc();
    o.styles && ct(!1, `Manually passing the "styles" property is not allowed on the ${i} component. Using the default styles calculated by the @withStyle decorator instead.
`, o.styles), o.makeStyles && ct(!1, `Manually passing the "makeStyles" property is not allowed on the ${i} component. Styles are calculated by the @withStyle decorator.`);
    const c = {
      ...e.defaultProps,
      ...o,
      ...Vi
    };
    let u = typeof r == "function" ? r(s) : {};
    const p = Ic(s, i, e.componentId, c, u);
    u = {
      ...u,
      ...p
    };
    const v = we(t ? t(u, c, {}) : {}), d = gn(v, 2), g = d[0], f = d[1];
    return B(e, {
      ref: a,
      ...o,
      makeStyles: (y) => {
        const k = t(u, c, y);
        dl(k, g) || f(k);
      },
      styles: g,
      themeOverride: p
    });
  });
  return Sn(n, e), n.originalType = e.originalType || e, n.propTypes = e.propTypes, n.defaultProps = e.defaultProps, n.allowedProps = e.allowedProps, n.generateComponentTheme = r, e.defaultProps = {
    ...e.defaultProps,
    makeStyles: Vi.makeStyles,
    styles: Vi.styles
  }, process.env.NODE_ENV !== "production" && (n.displayName = `WithStyle(${i})`), n;
}), kr = {
  SHADOW_TYPES: {
    resting: "resting",
    above: "above",
    topmost: "topmost",
    none: "none"
  },
  STACKING_TYPES: {
    deepest: "deepest",
    below: "below",
    resting: "resting",
    above: "above",
    topmost: "topmost"
  },
  BORDER_WIDTHS: {
    0: "0",
    none: "none",
    small: "small",
    medium: "medium",
    large: "large"
  },
  BACKGROUNDS: {
    default: "default",
    inverse: "inverse",
    transparent: "transparent"
  },
  SIZES: {
    xSmall: "x-small",
    small: "small",
    medium: "medium",
    large: "large",
    xLarge: "x-large"
  }
}, Bc = kr.SHADOW_TYPES, Pc = kr.STACKING_TYPES, Dc = kr.BORDER_WIDTHS, Mc = kr.BACKGROUNDS, Fc = kr.SIZES, ji = {
  shadow: l.oneOf(Object.values(Bc)),
  stacking: l.oneOf(Object.values(Pc)),
  borderWidth: zc(Object.values(Dc)),
  background: l.oneOf(Object.values(Mc)),
  size: l.oneOf(Object.values(Fc))
};
function zc(e) {
  return function(t, r, i, n) {
    const o = t[r];
    if (typeof o > "u")
      return null;
    if (typeof o != "string")
      return new Error(`Invalid ${n} \`${r}\` of type \`${typeof o}\` supplied to \`${i}\`, expected a string.`);
    const a = o.split(" "), s = a.length;
    if (s > 0 && s < 5) {
      for (let c = 0; c < s; c++)
        if (e.indexOf(a[c]) === -1)
          return new Error(`Invalid ${n} \`${r}\` \`${a[c]}\` supplied to \`${i}\`, expected a one of \`${e.join(", ")}\`.`);
    } else
      return new Error(`Invalid ${n} \`${r}\` \`${o}\` supplied to \`${i}\`, expected between one and four of the following valid values: \`${e.join(", ")}\`.`);
    return null;
  };
}
function Kt(e, t) {
  const r = {};
  return Object.keys(t).forEach((i) => {
    r[Ls(`${e}-${String(i)}`)] = t[i];
  }), r;
}
function yr(e, t, r, i, n = !1) {
  if (!(typeof r != "string" || Ms(t)))
    return r.split(" ").map((o) => {
      if (o === "auto" || o === "0")
        return o;
      if (o === "none")
        return "0";
      if (o === "circle")
        return "100%";
      if (o === "pill")
        return "999em";
      if (n && o.match(/^([+-]?(\d+\.?\d*|\.\d+))([a-zA-Z]+)$/))
        return o;
      const a = Ls(`${i}-${o}`), s = t[a];
      return Xe(typeof s < "u", `[${e}] '${a}' is an invalid '${i}' value.`), s || "0";
    }).join(" ").trim();
}
function rn(e) {
  if (typeof e != "string")
    return;
  const t = e.split(" ");
  if (t.length === 4) {
    var r = [t[3], t[1]];
    t[1] = r[0], t[3] = r[1];
  }
  return t.join(" ");
}
function Tc(e) {
  if (typeof e != "string")
    return;
  const t = e.split(" ");
  if (t.length === 2) {
    var r = [t[1], t[0]];
    t[0] = r[0], t[1] = r[1];
  }
  if (t.length === 3 && t.push(t[1]), t.length === 4) {
    var i = [t[1], t[0], t[3], t[2]];
    t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3];
  }
  return t.join(" ");
}
function Lc(e, t) {
  const r = e == null ? void 0 : e.split(" ");
  return r ? r.map((n) => t[n] || n).join(" ") : "0";
}
function ti(e) {
  "@babel/helpers - typeof";
  return ti = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ti(e);
}
var Hc = /^\s+/, Nc = /\s+$/;
function M(e, t) {
  if (e = e || "", t = t || {}, e instanceof M)
    return e;
  if (!(this instanceof M))
    return new M(e, t);
  var r = Wc(e);
  this._originalInput = e, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || r.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = r.ok;
}
M.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), r, i, n, o, a, s;
    return r = t.r / 255, i = t.g / 255, n = t.b / 255, r <= 0.03928 ? o = r / 12.92 : o = Math.pow((r + 0.055) / 1.055, 2.4), i <= 0.03928 ? a = i / 12.92 : a = Math.pow((i + 0.055) / 1.055, 2.4), n <= 0.03928 ? s = n / 12.92 : s = Math.pow((n + 0.055) / 1.055, 2.4), 0.2126 * o + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = aa(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = mo(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = mo(this._r, this._g, this._b), r = Math.round(t.h * 360), i = Math.round(t.s * 100), n = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + r + ", " + i + "%, " + n + "%)" : "hsva(" + r + ", " + i + "%, " + n + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = bo(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = bo(this._r, this._g, this._b), r = Math.round(t.h * 360), i = Math.round(t.s * 100), n = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + r + ", " + i + "%, " + n + "%)" : "hsla(" + r + ", " + i + "%, " + n + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return wo(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return Uc(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(ce(this._r, 255) * 100) + "%",
      g: Math.round(ce(this._g, 255) * 100) + "%",
      b: Math.round(ce(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(ce(this._r, 255) * 100) + "%, " + Math.round(ce(this._g, 255) * 100) + "%, " + Math.round(ce(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(ce(this._r, 255) * 100) + "%, " + Math.round(ce(this._g, 255) * 100) + "%, " + Math.round(ce(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : nu[wo(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var r = "#" + xo(this._r, this._g, this._b, this._a), i = r, n = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var o = M(t);
      i = "#" + xo(o._r, o._g, o._b, o._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + r + ",endColorstr=" + i + ")";
  },
  toString: function(t) {
    var r = !!t;
    t = t || this._format;
    var i = !1, n = this._a < 1 && this._a >= 0, o = !r && n && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return o ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (i = this.toRgbString()), t === "prgb" && (i = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (i = this.toHexString()), t === "hex3" && (i = this.toHexString(!0)), t === "hex4" && (i = this.toHex8String(!0)), t === "hex8" && (i = this.toHex8String()), t === "name" && (i = this.toName()), t === "hsl" && (i = this.toHslString()), t === "hsv" && (i = this.toHsvString()), i || this.toHexString());
  },
  clone: function() {
    return M(this.toString());
  },
  _applyModification: function(t, r) {
    var i = t.apply(null, [this].concat([].slice.call(r)));
    return this._r = i._r, this._g = i._g, this._b = i._b, this.setAlpha(i._a), this;
  },
  lighten: function() {
    return this._applyModification(Kc, arguments);
  },
  brighten: function() {
    return this._applyModification(Qc, arguments);
  },
  darken: function() {
    return this._applyModification(Zc, arguments);
  },
  desaturate: function() {
    return this._applyModification(qc, arguments);
  },
  saturate: function() {
    return this._applyModification(Yc, arguments);
  },
  greyscale: function() {
    return this._applyModification(Xc, arguments);
  },
  spin: function() {
    return this._applyModification(Jc, arguments);
  },
  _applyCombination: function(t, r) {
    return t.apply(null, [this].concat([].slice.call(r)));
  },
  analogous: function() {
    return this._applyCombination(ru, arguments);
  },
  complement: function() {
    return this._applyCombination(eu, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(iu, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(tu, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(So, [3]);
  },
  tetrad: function() {
    return this._applyCombination(So, [4]);
  }
};
M.fromRatio = function(e, t) {
  if (ti(e) == "object") {
    var r = {};
    for (var i in e)
      e.hasOwnProperty(i) && (i === "a" ? r[i] = e[i] : r[i] = cr(e[i]));
    e = r;
  }
  return M(e, t);
};
function Wc(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, r = 1, i = null, n = null, o = null, a = !1, s = !1;
  return typeof e == "string" && (e = lu(e)), ti(e) == "object" && (at(e.r) && at(e.g) && at(e.b) ? (t = Gc(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : at(e.h) && at(e.s) && at(e.v) ? (i = cr(e.s), n = cr(e.v), t = jc(e.h, i, n), a = !0, s = "hsv") : at(e.h) && at(e.s) && at(e.l) && (i = cr(e.s), o = cr(e.l), t = Vc(e.h, i, o), a = !0, s = "hsl"), e.hasOwnProperty("a") && (r = e.a)), r = aa(r), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: r
  };
}
function Gc(e, t, r) {
  return {
    r: ce(e, 255) * 255,
    g: ce(t, 255) * 255,
    b: ce(r, 255) * 255
  };
}
function bo(e, t, r) {
  e = ce(e, 255), t = ce(t, 255), r = ce(r, 255);
  var i = Math.max(e, t, r), n = Math.min(e, t, r), o, a, s = (i + n) / 2;
  if (i == n)
    o = a = 0;
  else {
    var c = i - n;
    switch (a = s > 0.5 ? c / (2 - i - n) : c / (i + n), i) {
      case e:
        o = (t - r) / c + (t < r ? 6 : 0);
        break;
      case t:
        o = (r - e) / c + 2;
        break;
      case r:
        o = (e - t) / c + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: a,
    l: s
  };
}
function Vc(e, t, r) {
  var i, n, o;
  e = ce(e, 360), t = ce(t, 100), r = ce(r, 100);
  function a(u, p, v) {
    return v < 0 && (v += 1), v > 1 && (v -= 1), v < 1 / 6 ? u + (p - u) * 6 * v : v < 1 / 2 ? p : v < 2 / 3 ? u + (p - u) * (2 / 3 - v) * 6 : u;
  }
  if (t === 0)
    i = n = o = r;
  else {
    var s = r < 0.5 ? r * (1 + t) : r + t - r * t, c = 2 * r - s;
    i = a(c, s, e + 1 / 3), n = a(c, s, e), o = a(c, s, e - 1 / 3);
  }
  return {
    r: i * 255,
    g: n * 255,
    b: o * 255
  };
}
function mo(e, t, r) {
  e = ce(e, 255), t = ce(t, 255), r = ce(r, 255);
  var i = Math.max(e, t, r), n = Math.min(e, t, r), o, a, s = i, c = i - n;
  if (a = i === 0 ? 0 : c / i, i == n)
    o = 0;
  else {
    switch (i) {
      case e:
        o = (t - r) / c + (t < r ? 6 : 0);
        break;
      case t:
        o = (r - e) / c + 2;
        break;
      case r:
        o = (e - t) / c + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: a,
    v: s
  };
}
function jc(e, t, r) {
  e = ce(e, 360) * 6, t = ce(t, 100), r = ce(r, 100);
  var i = Math.floor(e), n = e - i, o = r * (1 - t), a = r * (1 - n * t), s = r * (1 - (1 - n) * t), c = i % 6, u = [r, a, o, o, s, r][c], p = [s, r, r, a, o, o][c], v = [o, o, s, r, r, a][c];
  return {
    r: u * 255,
    g: p * 255,
    b: v * 255
  };
}
function wo(e, t, r, i) {
  var n = [Ye(Math.round(e).toString(16)), Ye(Math.round(t).toString(16)), Ye(Math.round(r).toString(16))];
  return i && n[0].charAt(0) == n[0].charAt(1) && n[1].charAt(0) == n[1].charAt(1) && n[2].charAt(0) == n[2].charAt(1) ? n[0].charAt(0) + n[1].charAt(0) + n[2].charAt(0) : n.join("");
}
function Uc(e, t, r, i, n) {
  var o = [Ye(Math.round(e).toString(16)), Ye(Math.round(t).toString(16)), Ye(Math.round(r).toString(16)), Ye(la(i))];
  return n && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function xo(e, t, r, i) {
  var n = [Ye(la(i)), Ye(Math.round(e).toString(16)), Ye(Math.round(t).toString(16)), Ye(Math.round(r).toString(16))];
  return n.join("");
}
M.equals = function(e, t) {
  return !e || !t ? !1 : M(e).toRgbString() == M(t).toRgbString();
};
M.random = function() {
  return M.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function qc(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = M(e).toHsl();
  return r.s -= t / 100, r.s = fi(r.s), M(r);
}
function Yc(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = M(e).toHsl();
  return r.s += t / 100, r.s = fi(r.s), M(r);
}
function Xc(e) {
  return M(e).desaturate(100);
}
function Kc(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = M(e).toHsl();
  return r.l += t / 100, r.l = fi(r.l), M(r);
}
function Qc(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = M(e).toRgb();
  return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(t / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(t / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(t / 100)))), M(r);
}
function Zc(e, t) {
  t = t === 0 ? 0 : t || 10;
  var r = M(e).toHsl();
  return r.l -= t / 100, r.l = fi(r.l), M(r);
}
function Jc(e, t) {
  var r = M(e).toHsl(), i = (r.h + t) % 360;
  return r.h = i < 0 ? 360 + i : i, M(r);
}
function eu(e) {
  var t = M(e).toHsl();
  return t.h = (t.h + 180) % 360, M(t);
}
function So(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var r = M(e).toHsl(), i = [M(e)], n = 360 / t, o = 1; o < t; o++)
    i.push(M({
      h: (r.h + o * n) % 360,
      s: r.s,
      l: r.l
    }));
  return i;
}
function tu(e) {
  var t = M(e).toHsl(), r = t.h;
  return [M(e), M({
    h: (r + 72) % 360,
    s: t.s,
    l: t.l
  }), M({
    h: (r + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function ru(e, t, r) {
  t = t || 6, r = r || 30;
  var i = M(e).toHsl(), n = 360 / r, o = [M(e)];
  for (i.h = (i.h - (n * t >> 1) + 720) % 360; --t; )
    i.h = (i.h + n) % 360, o.push(M(i));
  return o;
}
function iu(e, t) {
  t = t || 6;
  for (var r = M(e).toHsv(), i = r.h, n = r.s, o = r.v, a = [], s = 1 / t; t--; )
    a.push(M({
      h: i,
      s: n,
      v: o
    })), o = (o + s) % 1;
  return a;
}
M.mix = function(e, t, r) {
  r = r === 0 ? 0 : r || 50;
  var i = M(e).toRgb(), n = M(t).toRgb(), o = r / 100, a = {
    r: (n.r - i.r) * o + i.r,
    g: (n.g - i.g) * o + i.g,
    b: (n.b - i.b) * o + i.b,
    a: (n.a - i.a) * o + i.a
  };
  return M(a);
};
M.readability = function(e, t) {
  var r = M(e), i = M(t);
  return (Math.max(r.getLuminance(), i.getLuminance()) + 0.05) / (Math.min(r.getLuminance(), i.getLuminance()) + 0.05);
};
M.isReadable = function(e, t, r) {
  var i = M.readability(e, t), n, o;
  switch (o = !1, n = du(r), n.level + n.size) {
    case "AAsmall":
    case "AAAlarge":
      o = i >= 4.5;
      break;
    case "AAlarge":
      o = i >= 3;
      break;
    case "AAAsmall":
      o = i >= 7;
      break;
  }
  return o;
};
M.mostReadable = function(e, t, r) {
  var i = null, n = 0, o, a, s, c;
  r = r || {}, a = r.includeFallbackColors, s = r.level, c = r.size;
  for (var u = 0; u < t.length; u++)
    o = M.readability(e, t[u]), o > n && (n = o, i = M(t[u]));
  return M.isReadable(e, i, {
    level: s,
    size: c
  }) || !a ? i : (r.includeFallbackColors = !1, M.mostReadable(e, ["#fff", "#000"], r));
};
var nn = M.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, nu = M.hexNames = ou(nn);
function ou(e) {
  var t = {};
  for (var r in e)
    e.hasOwnProperty(r) && (t[e[r]] = r);
  return t;
}
function aa(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function ce(e, t) {
  su(e) && (e = "100%");
  var r = au(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), r && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function fi(e) {
  return Math.min(1, Math.max(0, e));
}
function Me(e) {
  return parseInt(e, 16);
}
function su(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function au(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Ye(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function cr(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function la(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function ko(e) {
  return Me(e) / 255;
}
var je = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", r = "(?:" + t + ")|(?:" + e + ")", i = "[\\s|\\(]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")\\s*\\)?", n = "[\\s|\\(]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")[,|\\s]+(" + r + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(r),
    rgb: new RegExp("rgb" + i),
    rgba: new RegExp("rgba" + n),
    hsl: new RegExp("hsl" + i),
    hsla: new RegExp("hsla" + n),
    hsv: new RegExp("hsv" + i),
    hsva: new RegExp("hsva" + n),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function at(e) {
  return !!je.CSS_UNIT.exec(e);
}
function lu(e) {
  e = e.replace(Hc, "").replace(Nc, "").toLowerCase();
  var t = !1;
  if (nn[e])
    e = nn[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var r;
  return (r = je.rgb.exec(e)) ? {
    r: r[1],
    g: r[2],
    b: r[3]
  } : (r = je.rgba.exec(e)) ? {
    r: r[1],
    g: r[2],
    b: r[3],
    a: r[4]
  } : (r = je.hsl.exec(e)) ? {
    h: r[1],
    s: r[2],
    l: r[3]
  } : (r = je.hsla.exec(e)) ? {
    h: r[1],
    s: r[2],
    l: r[3],
    a: r[4]
  } : (r = je.hsv.exec(e)) ? {
    h: r[1],
    s: r[2],
    v: r[3]
  } : (r = je.hsva.exec(e)) ? {
    h: r[1],
    s: r[2],
    v: r[3],
    a: r[4]
  } : (r = je.hex8.exec(e)) ? {
    r: Me(r[1]),
    g: Me(r[2]),
    b: Me(r[3]),
    a: ko(r[4]),
    format: t ? "name" : "hex8"
  } : (r = je.hex6.exec(e)) ? {
    r: Me(r[1]),
    g: Me(r[2]),
    b: Me(r[3]),
    format: t ? "name" : "hex"
  } : (r = je.hex4.exec(e)) ? {
    r: Me(r[1] + "" + r[1]),
    g: Me(r[2] + "" + r[2]),
    b: Me(r[3] + "" + r[3]),
    a: ko(r[4] + "" + r[4]),
    format: t ? "name" : "hex8"
  } : (r = je.hex3.exec(e)) ? {
    r: Me(r[1] + "" + r[1]),
    g: Me(r[2] + "" + r[2]),
    b: Me(r[3] + "" + r[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function du(e) {
  var t, r;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), r = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), r !== "small" && r !== "large" && (r = "small"), {
    level: t,
    size: r
  };
}
function Ue(e, t) {
  return M(e).setAlpha(t / 100).toRgbString();
}
function Le(e, t) {
  return M(e).darken(t).toRgbString();
}
function _o(e, t) {
  return M(e).lighten(t).toRgbString();
}
const cu = ({
  borderRadius: e,
  borderWidth: t,
  dir: r,
  theme: i
}) => {
  const n = r === ci.rtl;
  return {
    borderRadius: yr("View", i, n ? Tc(e) : e, "borderRadius", !0),
    borderWidth: yr("View", i, n ? rn(t) : t, "borderWidth")
  };
}, uu = ({
  margin: e,
  padding: t,
  dir: r,
  theme: i
}) => {
  const n = r === ci.rtl;
  return {
    margin: yr("View", i, n ? rn(e) : e, "margin"),
    padding: yr("View", i, n ? rn(t) : t, "padding")
  };
}, fu = ({
  insetBlockStart: e,
  insetBlockEnd: t,
  insetInlineStart: r,
  insetInlineEnd: i,
  dir: n
}) => {
  const o = n === ci.rtl;
  return {
    ...{
      top: e,
      insetBlockStart: e
    },
    ...{
      bottom: t,
      insetBlockEnd: t
    },
    ...{
      left: o ? i : r,
      right: o ? r : i
    }
  };
}, hu = ({
  cursor: e,
  style: t
}) => {
  const r = Vt(t || {}, {}, [
    // Position/calculateElementPosition:
    "top",
    "left",
    "position",
    "display",
    "transform",
    "overflow",
    "minWidth",
    "minHeight",
    // Img:
    "filter",
    // Flex.Item:
    "flexBasis",
    // Avatar:
    "backgroundImage",
    // Popover:
    "pointerEvents"
  ]);
  return e && (r.cursor = e), r;
}, pu = (e) => {
  const t = e.borderWidth;
  return t && t !== "0" && t !== "none";
}, gu = (e, t) => {
  const r = e.focusColor, i = e.focusPosition, n = e.shouldAnimateFocus, o = e.withFocusOutline, a = e.focusWithin, s = i == "offset" || i == "inset" ? i : "offset", c = {
    offset: {
      outlineOffset: `calc(${t.focusOutlineOffset} - ${t.focusOutlineWidth})`
    },
    inset: {
      outlineOffset: `calc(${t.focusOutlineInset} - ${t.focusOutlineWidth})`
    }
  }, u = {
    info: t.focusColorInfo,
    inverse: t.focusColorInverse,
    success: t.focusColorSuccess,
    danger: t.focusColorDanger
  }, p = {
    ...c[s],
    outlineColor: u[r]
  }, v = {
    outlineOffset: "-0.8rem",
    // value when not in focus, its invisible
    outlineColor: Ue(u[r], 0),
    outlineStyle: t.focusOutlineStyle,
    outlineWidth: t.focusOutlineWidth,
    ...o && p
  };
  return {
    ...n && {
      transition: "outline-color 0.2s, outline-offset 0.25s"
    },
    ...v,
    "&:hover, &:active": {
      // apply the same style so it's not overridden by some global style
      ...v
    },
    ...typeof o > "u" && {
      // user focuses the element
      "&:focus": p
    },
    ...a && {
      "&:focus-within": p
    }
  };
}, vu = (e, t) => {
  const r = t.borderRadius, i = t.borderWidth, n = t.margin, o = t.padding, a = t.position, s = t.display, c = t.textAlign, u = t.borderColor, p = t.background, v = t.stacking, d = t.shadow, g = t.overflowY, f = t.overflowX, h = t.overscrollBehavior, y = t.insetBlockEnd, k = t.insetBlockStart, A = t.insetInlineEnd, x = t.insetInlineStart, w = t.width, b = t.height, C = t.minWidth, S = t.minHeight, Y = t.maxWidth, _ = t.maxHeight, D = t.withVisualDebug, F = t.dir, H = cu({
    theme: e,
    borderRadius: r,
    borderWidth: i,
    dir: F
  }), me = uu({
    margin: n,
    padding: o,
    theme: e,
    dir: F
  }), oe = fu({
    dir: F,
    insetBlockEnd: y,
    insetBlockStart: k,
    insetInlineEnd: A,
    insetInlineStart: x
  }), he = {
    inline: {
      label: "view--inline",
      display: "inline"
    },
    block: {
      label: "view--block",
      display: "block"
    },
    "inline-block": {
      label: "view--inlineBlock",
      display: "inline-block",
      verticalAlign: "middle"
    },
    flex: {
      label: "view--flex",
      display: "flex"
    },
    "inline-flex": {
      label: "view--inlineFlex",
      display: "inline-flex",
      verticalAlign: "middle"
    },
    auto: {}
  }, le = {
    start: {
      textAlign: "start"
    },
    center: {
      textAlign: "center"
    },
    end: {
      textAlign: "end"
    }
  }, pe = {
    transparent: {
      borderColor: e.borderColorTransparent
    },
    primary: {
      borderColor: e.borderColorPrimary
    },
    secondary: {
      borderColor: e.borderColorSecondary
    },
    brand: {
      borderColor: e.borderColorBrand
    },
    info: {
      borderColor: e.borderColorInfo
    },
    success: {
      borderColor: e.borderColorSuccess
    },
    warning: {
      borderColor: e.borderColorWarning
    },
    alert: {
      borderColor: e.borderColorAlert
    },
    danger: {
      borderColor: e.borderColorDanger
    }
  }, $e = {
    transparent: {
      color: e.color,
      background: "none"
    },
    primary: {
      color: e.color,
      background: e.backgroundPrimary
    },
    secondary: {
      color: e.color,
      background: e.backgroundSecondary
    },
    "primary-inverse": {
      color: e.colorPrimaryInverse,
      background: e.backgroundPrimaryInverse
    },
    brand: {
      color: e.colorPrimaryInverse,
      background: e.backgroundBrand
    },
    info: {
      color: e.colorPrimaryInverse,
      background: e.backgroundInfo
    },
    alert: {
      color: e.colorPrimaryInverse,
      background: e.backgroundAlert
    },
    success: {
      color: e.colorPrimaryInverse,
      background: e.backgroundSuccess
    },
    danger: {
      color: e.colorPrimaryInverse,
      background: e.backgroundDanger
    },
    warning: {
      color: e.colorPrimaryInverse,
      background: e.backgroundWarning
    }
  }, V = {
    topmost: {
      zIndex: e.stackingTopmost
    },
    above: {
      zIndex: e.stackingAbove
    },
    resting: {},
    below: {
      zIndex: e.stackingBelow
    },
    deepest: {
      zIndex: e.stackingDeepest
    }
  }, R = {
    topmost: {
      boxShadow: e.shadowTopmost
    },
    resting: {
      boxShadow: e.shadowResting
    },
    above: {
      boxShadow: e.shadowAbove
    },
    none: {}
  }, I = gu(t, e);
  return {
    view: {
      label: "view",
      boxSizing: "border-box",
      fontFamily: e.fontFamily,
      maxWidth: "100%",
      overflow: "visible",
      ...he[s],
      ...p && $e[p],
      ...v && V[v],
      ...d && R[d],
      ...c && le[c],
      overflowX: f && f !== "visible" ? f : "",
      overflowY: g && g !== "visible" ? g : "",
      position: a !== "static" ? a : "",
      overscrollBehavior: h || "auto",
      ...D ? {
        boxShadow: `0 0 0 1px ${e.debugOutlineColor}`
      } : {},
      ...pu(t) ? {
        borderStyle: e.borderStyle,
        ...pe[u] || {
          borderColor: u
        }
      } : {},
      ...H
    },
    inlineStyles: {
      //every '&' symbol will add another class to the rule, so it will be stronger
      //making an accidental override less likely
      "&&&&&&&&&&": {
        ...me,
        ...oe,
        ...I,
        width: w,
        height: b,
        minWidth: C,
        minHeight: S,
        maxWidth: Y,
        maxHeight: _,
        ...hu(t)
      }
    }
  };
}, yu = (e) => {
  var t, r, i, n, o, a, s, c, u, p, v, d, g, f, h, y, k, A, x, w, b, C, S, Y;
  const _ = e.colors, D = e.typography, F = e.borders, H = e.breakpoints, me = e.spacing, oe = e.shadows, he = e.stacking, le = e.key, pe = {
    canvas: {
      color: e["ic-brand-font-color-dark"],
      focusColorInfo: e["ic-brand-primary"],
      backgroundBrand: e["ic-brand-primary"],
      backgroundInfo: e["ic-brand-primary"],
      borderColorBrand: e["ic-brand-primary"],
      borderColorInfo: e["ic-brand-primary"]
    }
  };
  return {
    ...{
      fontFamily: D == null ? void 0 : D.fontFamily,
      color: _ == null || (t = _.contrasts) === null || t === void 0 ? void 0 : t.grey125125,
      colorPrimaryInverse: _ == null || (r = _.contrasts) === null || r === void 0 ? void 0 : r.white1010,
      borderColorPrimary: _ == null || (i = _.contrasts) === null || i === void 0 ? void 0 : i.grey1424,
      borderColorSecondary: _ == null || (n = _.contrasts) === null || n === void 0 ? void 0 : n.grey3045,
      borderColorSuccess: _ == null || (o = _.contrasts) === null || o === void 0 ? void 0 : o.green4570,
      borderColorBrand: _ == null || (a = _.contrasts) === null || a === void 0 ? void 0 : a.blue4570,
      borderColorInfo: _ == null || (s = _.contrasts) === null || s === void 0 ? void 0 : s.blue4570,
      borderColorAlert: _ == null || (c = _.contrasts) === null || c === void 0 ? void 0 : c.blue4570,
      borderColorWarning: _ == null || (u = _.contrasts) === null || u === void 0 ? void 0 : u.orange4570,
      borderColorDanger: _ == null || (p = _.contrasts) === null || p === void 0 ? void 0 : p.red4570,
      borderColorTransparent: "transparent",
      debugOutlineColor: _ == null || (v = _.contrasts) === null || v === void 0 ? void 0 : v.red4570,
      backgroundPrimary: _ == null || (d = _.contrasts) === null || d === void 0 ? void 0 : d.white1010,
      backgroundSecondary: _ == null || (g = _.contrasts) === null || g === void 0 ? void 0 : g.grey1111,
      backgroundPrimaryInverse: _ == null || (f = _.contrasts) === null || f === void 0 ? void 0 : f.grey125125,
      backgroundBrand: _ == null || (h = _.contrasts) === null || h === void 0 ? void 0 : h.blue4570,
      backgroundInfo: _ == null || (y = _.contrasts) === null || y === void 0 ? void 0 : y.blue4570,
      backgroundAlert: _ == null || (k = _.contrasts) === null || k === void 0 ? void 0 : k.blue4570,
      backgroundSuccess: _ == null || (A = _.contrasts) === null || A === void 0 ? void 0 : A.green4570,
      backgroundDanger: _ == null || (x = _.contrasts) === null || x === void 0 ? void 0 : x.red4570,
      backgroundWarning: _ == null || (w = _.contrasts) === null || w === void 0 ? void 0 : w.orange4570,
      arrowSize: "0.5rem",
      focusOutlineStyle: F == null ? void 0 : F.style,
      focusOutlineWidth: F == null ? void 0 : F.widthMedium,
      focusOutlineOffset: "0.3125rem",
      focusOutlineInset: "0rem",
      // do not use unitless zero (for CSS calc())
      focusColorInfo: _ == null || (b = _.contrasts) === null || b === void 0 ? void 0 : b.blue4570,
      focusColorDanger: _ == null || (C = _.contrasts) === null || C === void 0 ? void 0 : C.red4570,
      focusColorSuccess: _ == null || (S = _.contrasts) === null || S === void 0 ? void 0 : S.green4570,
      focusColorInverse: _ == null || (Y = _.contrasts) === null || Y === void 0 ? void 0 : Y.white1010,
      xSmallMaxWidth: H == null ? void 0 : H.xSmall,
      smallMaxWidth: H == null ? void 0 : H.small,
      mediumMaxWidth: H == null ? void 0 : H.medium,
      largeMaxWidth: H == null ? void 0 : H.large,
      ...Kt("margin", me),
      ...Kt("padding", me),
      ...Kt("shadow", oe),
      ...Kt("stacking", he),
      ...Kt("border", F)
    },
    ...pe[le]
  };
}, bu = {
  as: l.elementType,
  elementRef: l.func,
  display: l.oneOf(["auto", "inline", "block", "inline-block", "flex", "inline-flex"]),
  overflowX: l.oneOf(["auto", "hidden", "visible"]),
  overflowY: l.oneOf(["auto", "hidden", "visible"]),
  margin: l.string,
  padding: l.string,
  height: l.oneOfType([l.string, l.number]),
  width: l.oneOfType([l.string, l.number]),
  maxHeight: l.oneOfType([l.string, l.number]),
  maxWidth: l.oneOfType([l.string, l.number]),
  minHeight: l.oneOfType([l.string, l.number]),
  minWidth: l.oneOfType([l.string, l.number]),
  children: l.node,
  textAlign: l.oneOf(["start", "center", "end"]),
  borderWidth: ji.borderWidth,
  borderRadius: l.string,
  borderColor: l.string,
  background: l.oneOf(["transparent", "primary", "secondary", "primary-inverse", "brand", "info", "alert", "success", "danger", "warning"]),
  shadow: ji.shadow,
  stacking: ji.stacking,
  cursor: nc,
  position: l.oneOf(["static", "absolute", "relative", "sticky", "fixed"]),
  insetInlineStart: l.string,
  insetInlineEnd: l.string,
  insetBlockStart: l.string,
  insetBlockEnd: l.string,
  withFocusOutline: l.bool,
  focusPosition: l.oneOf(["offset", "inset"]),
  focusColor: l.oneOf(["info", "inverse", "success", "danger"]),
  shouldAnimateFocus: l.bool,
  withVisualDebug: l.bool,
  dir: l.oneOf(Object.values(Rn.DIRECTION)),
  overscrollBehavior: l.oneOf(["auto", "contain", "none"]),
  focusRingBorderRadius: l.string,
  focusWithin: l.bool
}, mu = ["as", "background", "borderColor", "borderRadius", "borderWidth", "children", "cursor", "dir", "display", "elementRef", "focusColor", "focusPosition", "height", "insetBlockEnd", "insetBlockStart", "insetInlineEnd", "insetInlineStart", "margin", "maxHeight", "maxWidth", "minHeight", "minWidth", "overflowX", "overflowY", "overscrollBehavior", "padding", "position", "shadow", "shouldAnimateFocus", "stacking", "textAlign", "width", "withFocusOutline", "withVisualDebug", "focusRingBorderRadius", "focusWithin"], wu = ["children", "textAlign", "background", "display", "withVisualDebug", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "stacking", "shadow", "position", "focusPosition", "focusColor", "shouldAnimateFocus", "borderColor", "className", "overscrollBehavior", "styles", "makeStyles"];
var Co, $o, Pr, lt;
let Ae = (Co = Rn(), $o = fe(vu, yu), Co(Pr = $o(Pr = (lt = class da extends ae {
  get _element() {
    return this.ref;
  }
  constructor(t) {
    super(t), this.spanMarginVerified = void 0, this.ref = null, this.handleElementRef = (r) => {
      typeof this.props.elementRef == "function" && this.props.elementRef(r), this.ref = r;
    }, this.spanMarginVerified = !1;
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r), process.env.NODE_ENV === "development" && !this.spanMarginVerified && (this.spanMarginVerified = !0, Xe(!function(n, o) {
      if (!n || yt(n).display !== "inline")
        return;
      const s = o ? o.split(" ") : null;
      let c = !1;
      return o && (s && s[0] && s[0] !== "none" && s[0] !== "0" && (c = !0), s && s[2] && s[2] !== "none" && s[2] !== "0" && (c = !0)), c;
    }(this.ref, this.props.margin), "[View] display style is set to 'inline' and will allow for horizontal margins only."));
  }
  render() {
    const t = this.props, r = t.children;
    t.textAlign, t.background, t.display, t.withVisualDebug, t.width, t.height, t.minWidth, t.minHeight, t.maxWidth, t.maxHeight, t.overflowX, t.overflowY, t.stacking, t.shadow, t.position, t.focusPosition, t.focusColor, t.shouldAnimateFocus, t.borderColor;
    const i = t.className;
    t.overscrollBehavior;
    const n = t.styles;
    t.makeStyles;
    const o = Se(t, wu), a = Gt(da, this.props);
    return B(a, {
      ...it(o),
      className: i,
      css: [n == null ? void 0 : n.view, n == null ? void 0 : n.inlineStyles],
      ref: this.handleElementRef,
      children: r
    });
  }
}, lt.displayName = "View", lt.componentId = "View", lt.allowedProps = mu, lt.propTypes = bu, lt.defaultProps = {
  display: "auto",
  overflowX: "visible",
  overflowY: "visible",
  withVisualDebug: !1,
  borderColor: "primary",
  position: "static",
  focusPosition: "offset",
  focusColor: "info",
  shouldAnimateFocus: !0,
  overscrollBehavior: "auto"
}, lt.omitViewProps = (e, t) => {
  const r = [...lt.allowedProps, "styles", "makeStyles", "themeOverride"];
  let i = !0;
  try {
    i = process.env.NODE_ENV !== "production";
  } catch (n) {
    if (n instanceof ReferenceError)
      i = !1;
    else
      throw n;
  }
  return i && Object.keys(Vt(e, r)).forEach((n) => {
    Xe(!1, `[${t.name}] prop '${n}' is not allowed.`);
  }), Ne(e, r);
}, lt)) || Pr) || Pr);
function ca(e, t = 0, r = {}) {
  let i, n, o, a, s = 0, c = [];
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  const u = !!r.leading, p = "maxWait" in r, v = "trailing" in r ? !!r.trailing : !0, d = p ? Math.max(+!r.maxWait || 0, t) : 0;
  function g(S) {
    const Y = i, _ = n;
    return i = void 0, n = void 0, s = S, o = e.apply(_, Y), o;
  }
  function f(S) {
    return s = S, c.push(setTimeout(k, t)), u ? g(S) : o;
  }
  function h(S) {
    const Y = S - a, _ = S - s, D = t - Y;
    return p ? Math.min(D, d - _) : D;
  }
  function y(S) {
    if (typeof a > "u")
      return !0;
    const Y = S - a, _ = S - s;
    return Y >= t || Y < 0 || p && _ >= d;
  }
  function k() {
    const S = Date.now();
    y(S) ? A(S) : c.push(setTimeout(k, h(S)));
  }
  function A(S) {
    return b(), v && i ? g(S) : (i = n = void 0, o);
  }
  function x() {
    b(), s = 0, a = 0, i = n = void 0;
  }
  function w() {
    return c.length === 0 ? o : A(Date.now());
  }
  function b() {
    c.forEach((S) => clearTimeout(S)), c = [];
  }
  function C(...S) {
    const Y = Date.now(), _ = y(Y);
    if (i = S, n = this, a = Y, _) {
      if (c.length === 0)
        return f(a);
      if (p)
        return c.push(setTimeout(k, t)), g(a);
    }
    return c.length === 0 && c.push(setTimeout(k, t)), o;
  }
  return C.cancel = x, C.flush = w, C;
}
let on = !0;
try {
  var Ui, qi;
  on = !((Ui = process) !== null && Ui !== void 0 && (qi = Ui.env) !== null && qi !== void 0 && qi.ALWAYS_APPEND_UI_TESTABLE_LOCATORS);
} catch (e) {
  if (e instanceof ReferenceError)
    on = !1;
  else
    throw e;
}
const ft = process.env.NODE_ENV === "production" && // If you would like to the `data-cid` attributes on elements even in your
// production builds (like if you are using them in your e2e builds or
// something), you need to set the environment variable
// ALWAYS_APPEND_UI_TESTABLE_LOCATORS=1
// We do this because adding those `data-cid` locators slows things down.
on ? () => (e) => e : rr((e) => {
  const r = {
    attribute: "data-cid",
    value: e.displayName || e.name
  }, i = `[${r.attribute}~="${r.value}"]`;
  class n extends e {
    constructor(...a) {
      super(...a), this._testableUnmounted = void 0, this._locatorTimeout = void 0;
    }
    componentDidMount() {
      this._testableUnmounted = !1, super.componentDidMount && super.componentDidMount(), this.appendLocatorAttribute();
    }
    componentDidUpdate(a, s, c) {
      super.componentDidUpdate && super.componentDidUpdate(a, s, c), this.appendLocatorAttribute();
    }
    componentWillUnmount() {
      this._testableUnmounted = !0, super.componentWillUnmount && super.componentWillUnmount(), this._locatorTimeout && clearTimeout(this._locatorTimeout);
    }
    appendLocatorAttribute() {
      this._locatorTimeout = setTimeout(() => {
        let a;
        if (!this._testableUnmounted) {
          try {
            a = this.DOMNode || Pe(this);
          } catch {
          }
          if (a) {
            const s = a.getAttribute(r.attribute), c = typeof s == "string" ? s.split(/\s+/) : [];
            c.includes(r.value) || c.push(r.value), a.setAttribute(r.attribute, c.join(" "));
          }
        }
      });
    }
  }
  return n.selector = i, n;
}), xu = (e, t) => {
  const r = t.shouldGrow, i = t.shouldShrink, n = t.align, o = t.size, a = t.order;
  return {
    flexItem: {
      label: "flexItem",
      boxSizing: "border-box",
      minWidth: "0.0625rem",
      flexBasis: o,
      ...a !== void 0 ? {
        order: a
      } : {},
      // initial value is 1, but we want 0 as our default,
      // so users can opt in to shrink like they do grow
      flexShrink: i ? 1 : 0,
      ...r && {
        flexGrow: 1
      },
      ...n && {
        alignSelf: {
          start: "flex-start",
          end: "flex-end",
          center: "center",
          stretch: "stretch"
        }[n]
      }
    }
  };
}, Su = {
  children: l.node,
  as: l.elementType,
  elementRef: l.func,
  margin: l.string,
  padding: l.string,
  align: l.oneOf(["center", "start", "end", "stretch"]),
  direction: l.oneOf(["row", "column"]),
  textAlign: l.oneOf(["start", "center", "end"]),
  overflowX: l.oneOf(["auto", "hidden", "visible"]),
  overflowY: l.oneOf(["auto", "hidden", "visible"]),
  shouldGrow: l.bool,
  shouldShrink: l.bool,
  size: l.string,
  withVisualDebug: l.bool,
  order: l.number
}, ku = ["children", "as", "elementRef", "margin", "padding", "align", "direction", "textAlign", "overflowX", "overflowY", "shouldGrow", "shouldShrink", "size", "withVisualDebug", "order"];
var Eo, Ro, xt;
let _u = (Eo = fe(xu, null), Eo(Ro = (xt = class ua extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  render() {
    const t = Ne(this.props, ua.allowedProps), r = this.props, i = r.as, n = r.children, o = r.withVisualDebug, a = r.textAlign, s = r.size, c = r.direction, u = r.margin, p = r.padding, v = r.overflowX, d = r.overflowY, g = r.styles, f = c === "column", h = c === "row";
    return B(Ae, {
      ...t,
      css: g == null ? void 0 : g.flexItem,
      elementRef: this.handleRef,
      as: i,
      minHeight: f ? s : void 0,
      minWidth: h ? s : void 0,
      textAlign: a,
      margin: u,
      padding: p,
      overflowX: v,
      overflowY: d || (f ? "auto" : "visible"),
      withVisualDebug: o,
      children: n
    });
  }
}, xt.displayName = "Item", xt.componentId = "Flex.Item", xt.propTypes = Su, xt.allowedProps = ku, xt.defaultProps = {
  as: "span",
  shouldGrow: !1,
  shouldShrink: !1
}, xt)) || Ro);
const Cu = (e, t) => {
  const r = t.justifyItems, i = t.wrap, n = t.direction, o = t.gap, a = t.alignItems || (n === "column" || n === "column-reverse" ? "stretch" : "center"), s = {
    center: "center",
    start: "flex-start",
    end: "flex-end",
    stretch: "stretch"
  }, c = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
    "space-around": "space-around",
    "space-between": "space-between"
  }, u = {
    wrap: "wrap",
    "wrap-reverse": "wrap-reverse",
    "no-wrap": void 0
  }, p = {
    column: "column",
    "column-reverse": "column-reverse",
    row: "row",
    "row-reverse": "row-reverse"
  }, v = (d, g) => yr("Flex", g, d, "gap");
  return {
    flex: {
      label: "flex",
      fontFamily: e.fontFamily,
      boxSizing: "border-box",
      alignItems: s[a],
      justifyContent: c[r],
      flexWrap: u[i],
      flexDirection: p[n],
      gap: v(o, e)
    }
  };
}, $u = (e) => {
  const t = e.typography, r = e.spacing;
  return {
    ...{
      fontFamily: t == null ? void 0 : t.fontFamily,
      ...Kt("gap", r)
    }
  };
}, Eu = {
  children: l.oneOfType([l.node, l.func]),
  as: l.elementType,
  elementRef: l.func,
  height: l.oneOfType([l.string, l.number]),
  width: l.oneOfType([l.string, l.number]),
  margin: l.string,
  padding: l.string,
  gap: l.string,
  display: l.oneOf(["flex", "inline-flex"]),
  textAlign: l.oneOf(["start", "center", "end"]),
  direction: l.oneOf(["row", "column", "row-reverse", "column-reverse"]),
  alignItems: l.oneOf(["center", "start", "end", "stretch"]),
  justifyItems: l.oneOf(["center", "start", "end", "space-around", "space-between"]),
  wrap: l.oneOf(["wrap", "no-wrap", "wrap-reverse"]),
  withVisualDebug: l.bool
}, Ru = ["children", "as", "elementRef", "height", "width", "margin", "padding", "display", "textAlign", "direction", "alignItems", "justifyItems", "wrap", "withVisualDebug"];
var Ao, Io, gt;
let ue = (Ao = fe(Cu, $u), Ao(Io = (gt = class extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  renderChildren(t) {
    return Be.map(t, (r) => r ? Sr(r, ["Item"]) ? Ht(r, {
      // child withVisualDebug prop should override parent
      withVisualDebug: this.props.withVisualDebug,
      ...r.props,
      direction: this.props.direction.replace(/-reverse/, "")
    }) : r : null);
  }
  render() {
    const t = this.props, r = t.as, i = t.withVisualDebug, n = t.height, o = t.display, a = t.margin, s = t.padding, c = t.textAlign, u = t.width, p = t.styles, v = t.gap, d = t.wrap, g = Jt(this.props.children);
    return (v == null ? void 0 : v.split(" ")).length > 1, g && Be.count(g) > 0 ? B(Ae, {
      ...it(this.props),
      css: p == null ? void 0 : p.flex,
      elementRef: this.handleRef,
      as: r,
      display: o,
      width: u,
      height: n,
      margin: a,
      padding: s,
      textAlign: c,
      withVisualDebug: i,
      children: this.renderChildren(g)
    }) : null;
  }
}, gt.displayName = "Flex", gt.componentId = "Flex", gt.Item = _u, gt.propTypes = Eu, gt.allowedProps = Ru, gt.defaultProps = {
  as: "span",
  direction: "row",
  justifyItems: "start",
  display: "flex",
  withVisualDebug: !1,
  wrap: "no-wrap",
  gap: "none"
}, gt)) || Io);
const Au = ea`
    to {
      transform: rotate(360deg)
    }`, Iu = ea`
    0% {
      stroke-dashoffset: 190%;
    }

    50% {
      stroke-dashoffset: 50%;
      transform: rotate(90deg);
    }

    100% {
      stroke-dashoffset: 190%;
      transform: rotate(360deg);
    }`, Ou = (e, t) => {
  const r = t.size, i = t.variant, n = {
    "x-small": {
      width: e.xSmallSize,
      height: e.xSmallSize
    },
    small: {
      width: e.smallSize,
      height: e.smallSize
    },
    medium: {
      width: e.mediumSize,
      height: e.mediumSize
    },
    large: {
      width: e.largeSize,
      height: e.largeSize
    }
  }, o = {
    "x-small": {
      width: e.xSmallSize,
      height: e.xSmallSize
    },
    small: {
      width: e.smallSize,
      height: e.smallSize
    },
    medium: {
      width: e.mediumSize,
      height: e.mediumSize
    },
    large: {
      width: e.largeSize,
      height: e.largeSize
    }
  }, a = {
    "x-small": {
      strokeWidth: e.xSmallBorderWidth
    },
    small: {
      strokeWidth: e.smallBorderWidth
    },
    medium: {
      strokeWidth: e.mediumBorderWidth
    },
    large: {
      strokeWidth: e.largeBorderWidth
    }
  }, s = {
    "x-small": {
      strokeWidth: e.xSmallBorderWidth,
      strokeDasharray: "3em",
      transformOrigin: `calc(${e.xSmallSize} / 2) calc(${e.xSmallSize} / 2)`
    },
    small: {
      strokeWidth: e.smallBorderWidth,
      strokeDasharray: "6em",
      transformOrigin: `calc(${e.smallSize} / 2) calc(${e.smallSize} / 2)`
    },
    medium: {
      strokeWidth: e.mediumBorderWidth,
      strokeDasharray: "10.5em",
      transformOrigin: `calc(${e.mediumSize} / 2) calc(${e.mediumSize} / 2)`
    },
    large: {
      strokeWidth: e.largeBorderWidth,
      strokeDasharray: "14em",
      transformOrigin: `calc(${e.largeSize} / 2) calc(${e.largeSize} / 2)`
    }
  }, c = {
    default: {
      stroke: e.color
    },
    inverse: {
      stroke: e.inverseColor
    }
  };
  return {
    spinner: {
      label: "spinner",
      display: "inline-block",
      verticalAlign: "middle",
      position: "relative",
      boxSizing: "border-box",
      overflow: "hidden",
      ...n[r]
    },
    circle: {
      label: "spinner__circle",
      display: "block",
      position: "absolute",
      top: "0",
      left: "0",
      animationName: Au,
      animationDuration: "2.25s",
      animationIterationCount: "infinite",
      animationTimingFunction: "linear",
      ...o[r]
    },
    circleTrack: {
      label: "spinner__circleTrack",
      stroke: e.trackColor,
      fill: "none",
      ...a[r]
    },
    circleSpin: {
      label: "spinner__circleSpin",
      fill: "none",
      strokeLinecap: "round",
      animationName: Iu,
      animationDuration: "1.75s",
      animationIterationCount: "infinite",
      animationTimingFunction: "ease",
      ...s[r],
      ...c[i]
    }
  };
}, Bu = (e) => {
  var t, r, i, n;
  const o = e.colors, a = e.key, s = {
    "canvas-high-contrast": {
      inverseColor: o == null || (t = o.contrasts) === null || t === void 0 ? void 0 : t.white1010
    },
    canvas: {
      color: e["ic-brand-primary"]
    }
  };
  return {
    ...{
      trackColor: o == null || (r = o.contrasts) === null || r === void 0 ? void 0 : r.grey1111,
      color: o == null || (i = o.contrasts) === null || i === void 0 ? void 0 : i.blue4570,
      xSmallSize: "1.5em",
      xSmallBorderWidth: "0.25em",
      smallSize: "3em",
      smallBorderWidth: "0.375em",
      mediumSize: "5em",
      mediumBorderWidth: "0.5em",
      largeSize: "7em",
      largeBorderWidth: "0.75em",
      inverseColor: o == null || (n = o.contrasts) === null || n === void 0 ? void 0 : n.blue4570
    },
    ...s[a]
  };
}, Pu = {
  delay: l.number,
  renderTitle: l.oneOfType([l.func, l.node]),
  size: l.oneOf(["x-small", "small", "medium", "large"]),
  variant: l.oneOf(["default", "inverse"]),
  margin: l.string,
  elementRef: l.func,
  as: l.elementType
}, Du = ["delay", "renderTitle", "size", "variant", "margin", "elementRef", "as"];
var Oo, Bo, Po, qt, St;
let In = (Oo = di(), Bo = fe(Ou, Bu), Po = ft(), Oo(qt = Bo(qt = Po(qt = (St = class sn extends ae {
  constructor(t) {
    super(t), this.ref = null, this.titleId = void 0, this.delayTimeout = void 0, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.titleId = t.deterministicId(), this.state = {
      shouldRender: !t.delay
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
    const i = this.props.delay;
    i && (this.delayTimeout = setTimeout(() => {
      this.setState({
        shouldRender: !0
      });
    }, i));
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentWillUnmount() {
    clearTimeout(this.delayTimeout);
  }
  radius() {
    switch (this.props.size) {
      case "x-small":
        return "0.5em";
      case "small":
        return "1em";
      case "large":
        return "2.25em";
      default:
        return "1.75em";
    }
  }
  renderSpinner() {
    var t, r, i, n;
    const o = Ae.omitViewProps(Ne(this.props, sn.allowedProps), sn), a = this.props.renderTitle;
    return Xe(!!a, "[Spinner] The renderTitle prop is necessary for screen reader support."), B(Ae, {
      ...o,
      as: this.props.as,
      elementRef: this.handleRef,
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.spinner,
      margin: this.props.margin,
      children: Re("svg", {
        css: (r = this.props.styles) === null || r === void 0 ? void 0 : r.circle,
        role: "img",
        "aria-labelledby": this.titleId,
        focusable: "false",
        children: [B("title", {
          id: this.titleId,
          children: Jt(this.props.renderTitle)
        }), Re("g", {
          role: "presentation",
          children: [this.props.variant !== "inverse" && B("circle", {
            css: (i = this.props.styles) === null || i === void 0 ? void 0 : i.circleTrack,
            cx: "50%",
            cy: "50%",
            r: this.radius()
          }), B("circle", {
            css: (n = this.props.styles) === null || n === void 0 ? void 0 : n.circleSpin,
            cx: "50%",
            cy: "50%",
            r: this.radius()
          })]
        })]
      })
    });
  }
  render() {
    return this.state.shouldRender ? this.renderSpinner() : null;
  }
}, St.displayName = "Spinner", St.componentId = "Spinner", St.allowedProps = Du, St.propTypes = Pu, St.defaultProps = {
  as: "div",
  size: "medium",
  variant: "default"
}, St)) || qt) || qt) || qt);
const Mu = () => ({
  screenReaderContent: {
    label: "screenReaderContent",
    width: "0.0625rem !important",
    height: "0.0625rem !important",
    margin: "-0.0625rem !important",
    padding: "0 !important",
    position: "absolute",
    top: 0,
    insetInlineStart: 0,
    whiteSpace: "nowrap",
    overflow: "hidden !important",
    clip: "rect(0 0 0 0) !important",
    border: "0 !important"
  }
}), Fu = {
  as: l.elementType,
  children: l.node,
  elementRef: l.func
}, zu = ["as", "children", "elementRef"], Tu = ["children", "styles"];
var Do, Mo, kt;
let bt = (Do = fe(Mu, null), Do(Mo = (kt = class fa extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  render() {
    const t = this.props, r = t.children, i = t.styles, n = Se(t, Tu), o = Gt(fa, n);
    return B(o, {
      ...it(n),
      css: i == null ? void 0 : i.screenReaderContent,
      ref: this.handleRef,
      children: r
    });
  }
}, kt.displayName = "ScreenReaderContent", kt.componentId = "ScreenReaderContent", kt.propTypes = Fu, kt.allowedProps = zu, kt.defaultProps = {
  as: "span",
  children: null
}, kt)) || Mo);
var Dr = { exports: {} }, Fo;
function Lu() {
  return Fo || (Fo = 1, function(e, t) {
    function r(c) {
      if (c && typeof c == "object") {
        var u = c.which || c.keyCode || c.charCode;
        u && (c = u);
      }
      if (typeof c == "number") return a[c];
      var p = String(c), v = i[p.toLowerCase()];
      if (v) return v;
      var v = n[p.toLowerCase()];
      if (v) return v;
      if (p.length === 1) return p.charCodeAt(0);
    }
    r.isEventKey = function(u, p) {
      if (u && typeof u == "object") {
        var v = u.which || u.keyCode || u.charCode;
        if (v == null)
          return !1;
        if (typeof p == "string") {
          var d = i[p.toLowerCase()];
          if (d)
            return d === v;
          var d = n[p.toLowerCase()];
          if (d)
            return d === v;
        } else if (typeof p == "number")
          return p === v;
        return !1;
      }
    }, t = e.exports = r;
    var i = t.code = t.codes = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      ctrl: 17,
      alt: 18,
      "pause/break": 19,
      "caps lock": 20,
      esc: 27,
      space: 32,
      "page up": 33,
      "page down": 34,
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      insert: 45,
      delete: 46,
      command: 91,
      "left command": 91,
      "right command": 93,
      "numpad *": 106,
      "numpad +": 107,
      "numpad -": 109,
      "numpad .": 110,
      "numpad /": 111,
      "num lock": 144,
      "scroll lock": 145,
      "my computer": 182,
      "my calculator": 183,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    }, n = t.aliases = {
      windows: 91,
      "⇧": 16,
      "⌥": 18,
      "⌃": 17,
      "⌘": 91,
      ctl: 17,
      control: 17,
      option: 18,
      pause: 19,
      break: 19,
      caps: 20,
      return: 13,
      escape: 27,
      spc: 32,
      spacebar: 32,
      pgup: 33,
      pgdn: 34,
      ins: 45,
      del: 46,
      cmd: 91
    };
    /*!
     * Programatically add the following
     */
    for (o = 97; o < 123; o++) i[String.fromCharCode(o)] = o - 32;
    for (var o = 48; o < 58; o++) i[o - 48] = o;
    for (o = 1; o < 13; o++) i["f" + o] = o + 111;
    for (o = 0; o < 10; o++) i["numpad " + o] = o + 96;
    var a = t.names = t.title = {};
    for (o in i) a[i[o]] = o;
    for (var s in n)
      i[s] = n[s];
  }(Dr, Dr.exports)), Dr.exports;
}
var Hu = Lu();
const ha = /* @__PURE__ */ ir(Hu);
function _r(e) {
  let t = !1;
  return Be.forEach(e, (r) => {
    r && !Sr(r, [bt]) && (t = !0);
  }), t;
}
const Nu = (e, t, r) => {
  const i = t.size, n = t.color, o = t.textAlign, a = t.shape, s = t.withBackground, c = t.withBorder, u = t.isCondensed, p = r.isDisabled, v = r.hasOnlyIconVisible, d = r.isEnabled, g = {
    circle: {
      borderRadius: "50%"
    },
    rectangle: {}
  }, f = {
    small: {
      content: {
        fontSize: e.smallFontSize,
        paddingLeft: e.smallPaddingHorizontal,
        paddingRight: e.smallPaddingHorizontal,
        ...v && {
          paddingLeft: 0,
          paddingRight: 0,
          height: e.smallHeight,
          width: e.smallHeight
        }
      },
      children: {
        paddingTop: e.smallPaddingTop,
        paddingBottom: e.smallPaddingBottom
      },
      iconSVG: {
        fontSize: u ? e.smallFontSize : e.iconSizeSmall
      }
    },
    medium: {
      content: {
        fontSize: e.mediumFontSize,
        paddingLeft: e.mediumPaddingHorizontal,
        paddingRight: e.mediumPaddingHorizontal,
        ...v && {
          paddingLeft: 0,
          paddingRight: 0,
          height: e.mediumHeight,
          width: e.mediumHeight
        }
      },
      children: {
        paddingTop: e.mediumPaddingTop,
        paddingBottom: e.mediumPaddingBottom
      },
      iconSVG: {
        fontSize: u ? e.mediumFontSize : e.iconSizeMedium
      }
    },
    large: {
      content: {
        fontSize: e.largeFontSize,
        paddingLeft: e.largePaddingHorizontal,
        paddingRight: e.largePaddingHorizontal,
        ...v && {
          paddingLeft: 0,
          paddingRight: 0,
          height: e.largeHeight,
          width: e.largeHeight
        }
      },
      children: {
        paddingTop: e.largePaddingTop,
        paddingBottom: e.largePaddingBottom
      },
      iconSVG: {
        fontSize: u ? e.largeFontSize : e.iconSizeLarge
      }
    }
  }, h = {
    "ai-primary": {
      default: {
        color: e.primaryColor,
        background: `
        linear-gradient(to bottom,  ${e.aiBackgroundTopGradientColor} 0%, ${e.aiBackgroundBottomGradientColor} 100%) padding-box,
        linear-gradient(to bottom, ${e.aiBorderTopGradientColor} 0%, ${e.aiBorderBottomGradientColor} 100%) border-box`,
        borderStyle: "solid",
        borderColor: "transparent",
        boxShadow: e.primaryBoxShadow
      },
      active: {},
      hover: {
        background: `
          linear-gradient(to bottom, ${Le(e.aiBackgroundTopGradientColor, 10)} 0%, ${Le(e.aiBackgroundBottomGradientColor, 10)} 100%) padding-box,
  linear-gradient(to bottom, ${Le(e.aiBorderTopGradientColor, 10)} 0%, ${Le(e.aiBorderBottomGradientColor, 10)} 100%) border-box`,
        borderStyle: "solid",
        borderColor: "transparent",
        boxShadow: e.primaryHoverBoxShadow
      }
    },
    "ai-secondary": {
      default: {
        boxShadow: e.primaryBoxShadow
      },
      active: {},
      hover: {
        background: `
        linear-gradient(to bottom, ${_o(e.aiBackgroundTopGradientColor, 70)} 0%, ${_o(e.aiBackgroundBottomGradientColor, 70)} 100%)`
      }
    },
    primary: s ? {
      default: {
        color: e.primaryColor,
        background: e.primaryBackground,
        borderColor: e.primaryBorderColor,
        boxShadow: e.primaryBoxShadow
      },
      active: {
        background: e.primaryActiveBackground,
        boxShadow: e.primaryActiveBoxShadow
      },
      hover: {
        background: e.primaryHoverBackground,
        boxShadow: e.primaryHoverBoxShadow
      }
    } : {
      default: {
        color: e.primaryGhostColor,
        borderColor: e.primaryGhostBorderColor,
        background: e.primaryGhostBackground,
        boxShadow: e.primaryBoxShadow
      },
      active: {
        background: e.primaryGhostActiveBackground,
        boxShadow: e.primaryGhostActiveBoxShadow
      },
      hover: {
        background: e.primaryGhostHoverBackground,
        boxShadow: e.primaryHoverBoxShadow
      }
    },
    secondary: s ? {
      default: {
        color: e.secondaryColor,
        background: e.secondaryBackground,
        borderColor: e.secondaryBorderColor,
        boxShadow: e.secondaryBoxShadow
      },
      active: {
        background: e.secondaryActiveBackground,
        boxShadow: e.secondaryActiveBoxShadow
      },
      hover: {
        background: e.secondaryHoverBackground,
        boxShadow: e.secondaryHoverBoxShadow
      }
    } : {
      default: {
        color: e.secondaryGhostColor,
        borderColor: e.secondaryGhostBorderColor,
        background: e.secondaryGhostBackground,
        boxShadow: e.secondaryGhostBoxShadow
      },
      active: {
        background: e.secondaryGhostActiveBackground,
        boxShadow: e.secondaryGhostActiveBoxShadow
      },
      hover: {
        background: e.secondaryGhostHoverBackground,
        boxShadow: e.secondaryGhostHoverBoxShadow
      }
    },
    "primary-inverse": s ? {
      default: {
        color: e.primaryInverseColor,
        background: e.primaryInverseBackground,
        borderColor: e.primaryInverseBorderColor,
        boxShadow: e.primaryInverseBoxShadow
      },
      active: {
        background: e.primaryInverseActiveBackground,
        boxShadow: e.primaryInverseActiveBoxShadow
      },
      hover: {
        background: e.primaryInverseHoverBackground,
        boxShadow: e.primaryInverseHoverBoxShadow
      }
    } : {
      default: {
        color: e.primaryInverseGhostColor,
        borderColor: e.primaryInverseGhostBorderColor,
        background: e.primaryInverseGhostBackground,
        boxShadow: e.primaryInverseGhostBoxShadow
      },
      active: {
        background: e.primaryInverseGhostActiveBackground,
        boxShadow: e.primaryInverseGhostActiveBoxShadow
      },
      hover: {
        background: e.primaryInverseGhostHoverBackground,
        boxShadow: e.primaryInverseGhostHoverBoxShadow
      }
    },
    success: s ? {
      default: {
        color: e.successColor,
        background: e.successBackground,
        borderColor: e.successBorderColor,
        boxShadow: e.successBoxShadow
      },
      active: {
        background: e.successActiveBackground,
        boxShadow: e.successActiveBoxShadow
      },
      hover: {
        background: e.successHoverBackground,
        boxShadow: e.successHoverBoxShadow
      }
    } : {
      default: {
        color: e.successGhostColor,
        borderColor: e.successGhostBorderColor,
        background: e.successGhostBackground,
        boxShadow: e.successGhostBoxShadow
      },
      active: {
        background: e.successGhostActiveBackground,
        boxShadow: e.successGhostActiveBoxShadow
      },
      hover: {
        background: e.successGhostHoverBackground,
        boxShadow: e.successGhostHoverBoxShadow
      }
    },
    danger: s ? {
      default: {
        color: e.dangerColor,
        background: e.dangerBackground,
        borderColor: e.dangerBorderColor,
        boxShadow: e.dangerBoxShadow
      },
      active: {
        background: e.dangerActiveBackground,
        boxShadow: e.dangerActiveBoxShadow
      },
      hover: {
        background: e.dangerHoverBackground,
        boxShadow: e.dangerHoverBoxShadow
      }
    } : {
      default: {
        color: e.dangerGhostColor,
        borderColor: e.dangerGhostBorderColor,
        background: e.dangerGhostBackground,
        boxShadow: e.dangerGhostBoxShadow
      },
      active: {
        background: e.dangerGhostActiveBackground,
        boxShadow: e.dangerGhostActiveBoxShadow
      },
      hover: {
        background: e.dangerGhostHoverBackground,
        boxShadow: e.dangerGhostHoverBoxShadow
      }
    }
  };
  return {
    baseButton: d ? {
      label: "baseButton",
      appearance: "none",
      textDecoration: "none",
      touchAction: "manipulation",
      // This sets the focus ring's border radius displayed by the `View`
      borderRadius: e.borderRadius,
      ...g[a],
      // Prevents vertical stretching in flex parents with fixed height
      // Avoids background/focus ring distortion
      height: "fit-content",
      "&::-moz-focus-inner": {
        border: "0"
        /* removes default dotted focus outline in Firefox */
      },
      "*": {
        pointerEvents: "none"
        /* Ensures that button or link is always the event target */
      },
      "&:focus": {
        textDecoration: "none"
      },
      "&:active > [class$=-baseButton__content]": h[n].active,
      "&:hover > [class$=-baseButton__content]": h[n].hover,
      //TODO not the greatest solution. Must be stronger than the same &&& enforcement of <View>
      ...n === "ai-secondary" ? {
        "&&&&&&&&&&": {
          background: `
               linear-gradient(to bottom, ${e.aiBorderTopGradientColor} 0%, ${e.aiBorderBottomGradientColor} 100%)`,
          padding: e.borderWidth,
          ...a !== "circle" ? {
            borderRadius: `calc(${e.borderRadius} + ${e.borderWidth})`
          } : {
            borderRadius: "50%"
          }
        }
      } : {}
    } : {
      textDecoration: "none",
      label: "baseButton",
      appearance: "none"
    },
    content: {
      label: "baseButton__content",
      boxSizing: "border-box",
      width: "100%",
      display: "block",
      direction: "inherit",
      userSelect: "none",
      transition: "background 0.2s, transform 0.2s",
      transform: e.transform,
      fontFamily: e.fontFamily,
      fontWeight: e.fontWeight,
      textTransform: e.textTransform,
      letterSpacing: e.letterSpacing,
      borderStyle: e.borderStyle,
      borderWidth: e.borderWidth,
      borderRadius: e.borderRadius,
      lineHeight: e.lineHeight,
      textAlign: o,
      "&:hover": {
        transform: e.hoverTransform
      },
      ...n === "ai-secondary" ? {
        border: "none",
        background: "white",
        transition: "none"
      } : {},
      ...f[i].content,
      ...h[n].default,
      ...g[a],
      ...u && {
        paddingLeft: 0,
        paddingRight: 0
      },
      ...p && {
        opacity: 0.5
      },
      ...v && {
        lineHeight: 1
      },
      ...!c && {
        borderStyle: "none"
      }
    },
    children: {
      label: "baseButton__children",
      display: "block",
      ...f[i].children,
      ...u && {
        paddingTop: 0,
        paddingBottom: 0
      },
      ...n === "ai-secondary" ? {
        background: `
        linear-gradient(to bottom, ${e.aiBorderTopGradientColor} 0%, ${e.aiBorderBottomGradientColor} 100%)`,
        backgroundClip: "text",
        color: "transparent"
      } : {}
    },
    iconSVG: {
      label: "baseButton__iconSVG",
      display: "flex",
      alignItems: "center",
      ...f[i].iconSVG
    },
    childrenLayout: {
      label: "baseButton__childrenLayout",
      display: "flex",
      height: "100%",
      width: "100%",
      justifyContent: v || o === "center" ? "center" : "flex-start",
      boxSizing: "border-box",
      alignItems: "center",
      flexDirection: "row",
      maxWidth: "100%",
      overflowX: "visible",
      overflowY: "visible",
      unicodeBidi: "isolate"
    },
    iconOnly: {
      label: "baseButton__iconOnly",
      boxSizing: "border-box",
      minWidth: "0.0625rem",
      flexShrink: 0,
      maxWidth: "100%",
      overflowX: "visible",
      overflowY: "visible",
      unicodeBidi: "isolate"
    },
    iconWrapper: {
      label: "baseButton__iconWrapper",
      boxSizing: "border-box",
      minWidth: "0.0625rem",
      paddingInlineEnd: u ? e.iconTextGapCondensed : e.iconTextGap,
      flexShrink: 0,
      maxWidth: "100%",
      overflowX: "visible",
      overflowY: "visible",
      unicodeBidi: "isolate"
    },
    childrenWrapper: {
      label: "baseButton__childrenWrapper",
      boxSizing: "border-box",
      minWidth: "0.0625rem",
      flexShrink: 1,
      maxWidth: "100%",
      overflowX: "visible",
      overflowY: "visible",
      unicodeBidi: "isolate"
    }
  };
}, Te = "inset 0 0 0.1875rem 0.0625rem", On = (e) => {
  var t, r, i, n, o, a, s, c, u, p, v, d, g, f, h, y, k, A, x, w, b, C, S, Y, _, D, F, H, me, oe, he, le, pe, $e, V, R, I, G, W, T, L, z, N, P, K, U, ge, O, ke, We, nt, jt, or, ht;
  const ze = e.borders, m = e.colors, Ge = e.forms, Ie = e.spacing, de = e.typography, mt = e.key, hi = {
    canvas: {
      primaryColor: e["ic-brand-button--primary-text"],
      primaryBorderColor: Le(e["ic-brand-button--primary-bgd"]),
      primaryBackground: e["ic-brand-button--primary-bgd"],
      primaryHoverBackground: Le(e["ic-brand-button--primary-bgd"]),
      primaryActiveBackground: Le(e["ic-brand-button--primary-bgd"]),
      primaryActiveBoxShadow: `${Te} ${e["ic-brand-button--primary-bgd"]}`,
      primaryGhostColor: Le(e["ic-brand-button--primary-bgd"]),
      primaryGhostBorderColor: Le(e["ic-brand-button--primary-bgd"]),
      primaryGhostBackground: "transparent",
      primaryGhostHoverBackground: Ue(Le(e["ic-brand-button--primary-bgd"]), 10),
      primaryGhostActiveBackground: "transparent",
      primaryGhostActiveBoxShadow: `${Te} ${Ue(e["ic-brand-button--primary-bgd"], 28)}`
    }
  };
  return {
    ...{
      transform: "none",
      hoverTransform: "none",
      fontFamily: de == null ? void 0 : de.fontFamily,
      fontWeight: de == null ? void 0 : de.fontWeightNormal,
      textTransform: "none",
      letterSpacing: "normal",
      borderRadius: ze == null ? void 0 : ze.radiusMedium,
      borderStyle: ze == null ? void 0 : ze.style,
      borderWidth: ze == null ? void 0 : ze.widthSmall,
      smallHeight: Ge == null ? void 0 : Ge.inputHeightSmall,
      smallFontSize: de == null ? void 0 : de.fontSizeSmall,
      smallPaddingHorizontal: Ie == null ? void 0 : Ie.xSmall,
      smallPaddingTop: "0.375rem",
      smallPaddingBottom: "0.3125rem",
      mediumHeight: Ge == null ? void 0 : Ge.inputHeightMedium,
      mediumFontSize: de == null ? void 0 : de.fontSizeMedium,
      mediumPaddingHorizontal: Ie == null ? void 0 : Ie.small,
      mediumPaddingTop: "0.5625rem",
      mediumPaddingBottom: "0.5625rem",
      largeHeight: Ge == null ? void 0 : Ge.inputHeightLarge,
      largeFontSize: de == null ? void 0 : de.fontSizeLarge,
      largePaddingHorizontal: Ie == null ? void 0 : Ie.medium,
      largePaddingTop: "0.6875rem",
      largePaddingBottom: "0.6875rem",
      lineHeight: de == null ? void 0 : de.lineHeightFit,
      iconSizeSmall: "1rem",
      iconSizeMedium: "1.25rem",
      iconSizeLarge: "1.625rem",
      iconTextGap: Ie.xSmall,
      iconTextGapCondensed: Ie.xxSmall,
      primaryColor: m == null || (t = m.contrasts) === null || t === void 0 ? void 0 : t.white1010,
      primaryBorderColor: m == null || (r = m.contrasts) === null || r === void 0 ? void 0 : r.blue5782,
      primaryBackground: m == null || (i = m.contrasts) === null || i === void 0 ? void 0 : i.blue4570,
      primaryHoverBackground: m == null || (n = m.contrasts) === null || n === void 0 ? void 0 : n.blue5782,
      primaryActiveBackground: m == null || (o = m.contrasts) === null || o === void 0 ? void 0 : o.blue5782,
      primaryActiveBoxShadow: `${Te} ${m == null || (a = m.contrasts) === null || a === void 0 ? void 0 : a.white1010}`,
      primaryGhostColor: m == null || (s = m.contrasts) === null || s === void 0 ? void 0 : s.blue5782,
      primaryGhostBorderColor: m == null || (c = m.contrasts) === null || c === void 0 ? void 0 : c.blue4570,
      primaryGhostBackground: "transparent",
      primaryGhostHoverBackground: m == null || (u = m.contrasts) === null || u === void 0 ? void 0 : u.blue1212,
      primaryGhostActiveBackground: "transparent",
      primaryGhostActiveBoxShadow: `${Te} ${Ue(m == null || (p = m.contrasts) === null || p === void 0 ? void 0 : p.blue1212, 28)}`,
      primaryBoxShadow: "none",
      primaryGhostBoxShadow: "none",
      primaryHoverBoxShadow: "none",
      primaryGhostHoverBoxShadow: "none",
      secondaryColor: m == null || (v = m.contrasts) === null || v === void 0 ? void 0 : v.grey125125,
      secondaryBorderColor: m == null || (d = m.contrasts) === null || d === void 0 ? void 0 : d.grey1424,
      secondaryBackground: m == null || (g = m.contrasts) === null || g === void 0 ? void 0 : g.grey1111,
      secondaryHoverBackground: m == null || (f = m.contrasts) === null || f === void 0 ? void 0 : f.grey1214,
      secondaryActiveBackground: m == null || (h = m.contrasts) === null || h === void 0 ? void 0 : h.grey1214,
      secondaryActiveBoxShadow: `${Te} ${m == null || (y = m.contrasts) === null || y === void 0 ? void 0 : y.white1010}`,
      secondaryGhostColor: m == null || (k = m.contrasts) === null || k === void 0 ? void 0 : k.grey125125,
      secondaryGhostBorderColor: m == null || (A = m.contrasts) === null || A === void 0 ? void 0 : A.grey125125,
      secondaryGhostBackground: "transparent",
      secondaryGhostHoverBackground: m == null || (x = m.contrasts) === null || x === void 0 ? void 0 : x.grey1111,
      secondaryGhostActiveBackground: "transparent",
      secondaryGhostActiveBoxShadow: `${Te} ${Ue(m == null || (w = m.contrasts) === null || w === void 0 ? void 0 : w.grey125125, 28)}`,
      secondaryBoxShadow: "none",
      secondaryGhostBoxShadow: "none",
      secondaryHoverBoxShadow: "none",
      secondaryGhostHoverBoxShadow: "none",
      successColor: m == null || (b = m.contrasts) === null || b === void 0 ? void 0 : b.white1010,
      successBorderColor: m == null || (C = m.contrasts) === null || C === void 0 ? void 0 : C.green5782,
      successBackground: m == null || (S = m.contrasts) === null || S === void 0 ? void 0 : S.green4570,
      successHoverBackground: m == null || (Y = m.contrasts) === null || Y === void 0 ? void 0 : Y.green5782,
      successActiveBackground: m == null || (_ = m.contrasts) === null || _ === void 0 ? void 0 : _.green5782,
      successActiveBoxShadow: `${Te} ${m == null || (D = m.contrasts) === null || D === void 0 ? void 0 : D.white1010}`,
      successGhostColor: m == null || (F = m.contrasts) === null || F === void 0 ? void 0 : F.green4570,
      successGhostBorderColor: m == null || (H = m.contrasts) === null || H === void 0 ? void 0 : H.green4570,
      successGhostBackground: "transparent",
      successGhostHoverBackground: Ue(m == null || (me = m.contrasts) === null || me === void 0 ? void 0 : me.green4570, 10),
      successGhostActiveBackground: "transparent",
      successGhostActiveBoxShadow: `${Te} ${Ue(m == null || (oe = m.contrasts) === null || oe === void 0 ? void 0 : oe.green4570, 28)}`,
      successBoxShadow: "none",
      successGhostBoxShadow: "none",
      successHoverBoxShadow: "none",
      successGhostHoverBoxShadow: "none",
      dangerColor: m == null || (he = m.contrasts) === null || he === void 0 ? void 0 : he.white1010,
      dangerBorderColor: m == null || (le = m.contrasts) === null || le === void 0 ? void 0 : le.red5782,
      dangerBackground: m == null || (pe = m.contrasts) === null || pe === void 0 ? void 0 : pe.red4570,
      dangerHoverBackground: m == null || ($e = m.contrasts) === null || $e === void 0 ? void 0 : $e.red5782,
      dangerActiveBackground: m == null || (V = m.contrasts) === null || V === void 0 ? void 0 : V.red5782,
      dangerActiveBoxShadow: `${Te} ${m == null || (R = m.contrasts) === null || R === void 0 ? void 0 : R.white1010}`,
      dangerGhostColor: m == null || (I = m.contrasts) === null || I === void 0 ? void 0 : I.red4570,
      dangerGhostBorderColor: m == null || (G = m.contrasts) === null || G === void 0 ? void 0 : G.red4570,
      dangerGhostBackground: "transparent",
      dangerGhostHoverBackground: Ue(m == null || (W = m.contrasts) === null || W === void 0 ? void 0 : W.red4570, 10),
      dangerGhostActiveBackground: "transparent",
      dangerGhostActiveBoxShadow: `${Te} ${Ue(m == null || (T = m.contrasts) === null || T === void 0 ? void 0 : T.red4570, 28)}`,
      dangerBoxShadow: "none",
      dangerGhostBoxShadow: "none",
      dangerHoverBoxShadow: "none",
      dangerGhostHoverBoxShadow: "none",
      primaryInverseColor: m == null || (L = m.contrasts) === null || L === void 0 ? void 0 : L.grey125125,
      primaryInverseBorderColor: m == null || (z = m.contrasts) === null || z === void 0 ? void 0 : z.grey1214,
      primaryInverseBackground: m == null || (N = m.contrasts) === null || N === void 0 ? void 0 : N.white1010,
      primaryInverseHoverBackground: m == null || (P = m.contrasts) === null || P === void 0 ? void 0 : P.grey1111,
      primaryInverseActiveBackground: m == null || (K = m.contrasts) === null || K === void 0 ? void 0 : K.white1010,
      primaryInverseActiveBoxShadow: `${Te} ${m == null || (U = m.contrasts) === null || U === void 0 ? void 0 : U.white1010}`,
      primaryInverseGhostColor: m == null || (ge = m.contrasts) === null || ge === void 0 ? void 0 : ge.white1010,
      primaryInverseGhostBorderColor: m == null || (O = m.contrasts) === null || O === void 0 ? void 0 : O.white1010,
      primaryInverseGhostBackground: "transparent",
      primaryInverseGhostHoverBackground: Ue(m == null || (ke = m.contrasts) === null || ke === void 0 ? void 0 : ke.white1010, 10),
      primaryInverseGhostActiveBackground: "transparent",
      primaryInverseGhostActiveBoxShadow: `${Te}  ${Ue(m == null || (We = m.contrasts) === null || We === void 0 ? void 0 : We.white1010, 28)}`,
      primaryInverseBoxShadow: "none",
      primaryInverseGhostBoxShadow: "none",
      primaryInverseHoverBoxShadow: "none",
      primaryInverseGhostHoverBoxShadow: "none",
      aiBackgroundTopGradientColor: m == null || (nt = m.contrasts) === null || nt === void 0 ? void 0 : nt.violet4570,
      aiBackgroundBottomGradientColor: m == null || (jt = m.contrasts) === null || jt === void 0 ? void 0 : jt.sea4570,
      aiBorderTopGradientColor: m == null || (or = m.contrasts) === null || or === void 0 ? void 0 : or.violet5790,
      aiBorderBottomGradientColor: m == null || (ht = m.contrasts) === null || ht === void 0 ? void 0 : ht.sea5790,
      aiActiveBoxShadow: "0px 0px 5px 0px #013451 inset"
    },
    ...hi[mt]
  };
}, Wu = {
  children: l.node,
  type: l.oneOf(["button", "submit", "reset"]),
  size: l.oneOf(["small", "medium", "large"]),
  elementRef: l.func,
  as: l.elementType,
  interaction: l.oneOf(["enabled", "disabled", "readonly"]),
  color: l.oneOf(["primary", "primary-inverse", "secondary", "success", "danger", "ai-primary", "ai-secondary"]),
  focusColor: l.oneOf(["info", "inverse"]),
  display: l.oneOf(["inline-block", "block"]),
  textAlign: l.oneOf(["start", "center"]),
  shape: l.oneOf(["rectangle", "circle"]),
  withBackground: l.bool,
  withBorder: l.bool,
  isCondensed: l.bool,
  margin: l.string,
  cursor: l.string,
  href: l.string,
  onClick: l.func,
  onKeyDown: l.func,
  renderIcon: l.oneOfType([l.node, l.func]),
  tabIndex: l.number,
  withFocusOutline: l.bool
}, Gu = ["as", "children", "color", "cursor", "display", "elementRef", "focusColor", "href", "interaction", "isCondensed", "margin", "onClick", "onKeyDown", "renderIcon", "shape", "size", "tabIndex", "textAlign", "type", "withBackground", "withBorder"], Vu = ["type", "size", "elementRef", "as", "href", "color", "focusColor", "textAlign", "shape", "display", "withBackground", "withBorder", "isCondensed", "margin", "cursor", "onClick", "renderIcon", "tabIndex", "styles", "makeStyles", "withFocusOutline"];
var zo, To, Mr, _t;
let Bn = (zo = fe(Nu, On), To = ft(), zo(Mr = To(Mr = (_t = class pa extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleElementRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.handleClick = (r) => {
      const i = this.props.onClick;
      if (this.interaction !== "enabled") {
        r.preventDefault(), r.stopPropagation();
        return;
      }
      typeof i == "function" && i(r);
    }, this.handleKeyDown = (r) => {
      const i = this.props, n = i.onClick, o = i.onKeyDown, a = i.href, s = this.interaction;
      typeof o == "function" && o(r);
      const c = ha.codes, u = c.space, p = c.enter;
      this.elementType !== "button" && [u, p].includes(r.keyCode) && (r.preventDefault(), r.stopPropagation(), typeof n == "function" && s === "enabled" && n(r), a && this.ref && this.ref.click());
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStylesVariables);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStylesVariables);
  }
  get makeStylesVariables() {
    return {
      isDisabled: this.isDisabled,
      hasOnlyIconVisible: this.hasOnlyIconVisible,
      isEnabled: this.isEnabled
    };
  }
  get hasOnlyIconVisible() {
    const t = this.props, r = t.children;
    return !!(t.renderIcon && !_r(r));
  }
  get elementType() {
    return Gt(pa, this.props);
  }
  get interaction() {
    return li({
      props: this.props
    });
  }
  get isDisabled() {
    return this.interaction === "disabled";
  }
  get isReadOnly() {
    return this.interaction === "readonly";
  }
  get isEnabled() {
    return this.interaction === "enabled";
  }
  get focusColor() {
    const t = this.props, r = t.color, i = t.focusColor, n = t.withBackground;
    return i || (r === "primary-inverse" && n ? "info" : r.includes("inverse") ? "inverse" : "info");
  }
  get focused() {
    return yn(this.ref);
  }
  focus() {
    this.ref && this.ref.focus();
  }
  renderChildren() {
    const t = this.props, r = t.renderIcon, i = t.children, n = t.styles, o = B("span", {
      css: n == null ? void 0 : n.children,
      children: i
    });
    if (!r)
      return o;
    const a = this.hasOnlyIconVisible, s = B("span", {
      css: n == null ? void 0 : n.iconSVG,
      children: Jt(r)
    }), c = a ? Re("span", {
      css: n == null ? void 0 : n.iconOnly,
      children: [s, i]
    }) : [B("span", {
      css: n == null ? void 0 : n.iconWrapper,
      children: s
    }, "icon"), B("span", {
      css: n == null ? void 0 : n.childrenWrapper,
      children: o
    }, "children")];
    return B("span", {
      css: n == null ? void 0 : n.childrenLayout,
      children: c
    });
  }
  render() {
    const t = this.props, r = t.type;
    t.size, t.elementRef;
    const i = t.as, n = t.href;
    t.color, t.focusColor, t.textAlign;
    const o = t.shape, a = t.display;
    t.withBackground, t.withBorder, t.isCondensed;
    const s = t.margin, c = t.cursor, u = t.onClick;
    t.renderIcon;
    const p = t.tabIndex, v = t.styles;
    t.makeStyles;
    const d = t.withFocusOutline, g = Se(t, Vu), f = this.isDisabled, h = this.isReadOnly, y = this.elementType;
    let k = !0;
    typeof y == "string" && (["button", "frame", "iframe", "input", "object", "select", "textarea", "summary"].includes(y) && (k = !1), n && (y === "a" || y === "area") && (k = !1));
    let A = p;
    return (u && i && k || Wl() && i) && (A = p || 0), B(Ae, {
      ...it(g),
      as: y,
      focusColor: this.focusColor,
      position: "relative",
      display: a,
      width: a === "block" ? "100%" : "auto",
      borderRadius: o === "circle" ? "circle" : "medium",
      background: "transparent",
      padding: "none",
      borderWidth: "none",
      margin: s,
      cursor: f ? "not-allowed" : c,
      href: n,
      type: n ? void 0 : r,
      elementRef: this.handleElementRef,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      role: u && i !== "button" ? "button" : void 0,
      tabIndex: A,
      disabled: f || h,
      css: v == null ? void 0 : v.baseButton,
      withFocusOutline: d,
      children: B("span", {
        css: v == null ? void 0 : v.content,
        children: this.renderChildren()
      })
    });
  }
}, _t.displayName = "BaseButton", _t.componentId = "BaseButton", _t.propTypes = Wu, _t.allowedProps = Gu, _t.defaultProps = {
  type: "button",
  size: "medium",
  as: "button",
  // Leave interaction default undefined so that `disabled` and `readOnly` can also be supplied
  interaction: void 0,
  color: "secondary",
  shape: "rectangle",
  display: "inline-block",
  textAlign: "start",
  withBackground: !0,
  withBorder: !0,
  isCondensed: !1,
  margin: "0",
  cursor: "pointer"
}, _t)) || Mr) || Mr);
const ju = {
  children: l.node,
  type: l.oneOf(["button", "submit", "reset"]),
  size: l.oneOf(["small", "medium", "large"]),
  elementRef: l.func,
  as: l.elementType,
  interaction: l.oneOf(["enabled", "disabled", "readonly"]),
  color: l.oneOf(["primary", "primary-inverse", "secondary", "success", "danger", "ai-primary", "ai-secondary"]),
  focusColor: l.oneOf(["info", "inverse"]),
  display: l.oneOf(["inline-block", "block"]),
  textAlign: l.oneOf(["start", "center"]),
  withBackground: l.bool,
  margin: l.string,
  cursor: l.string,
  href: l.string,
  renderIcon: l.oneOfType([l.node, l.func]),
  onClick: l.func
}, Uu = ["as", "children", "color", "cursor", "display", "elementRef", "focusColor", "href", "interaction", "margin", "renderIcon", "size", "textAlign", "type", "withBackground", "onClick"], qu = ["children", "type", "size", "as", "color", "focusColor", "display", "textAlign", "withBackground", "margin", "cursor", "href", "renderIcon"];
var Lo, Ho, Fr, Ct;
let br = (Lo = fe(null, On), Ho = ft(), Lo(Fr = Ho(Fr = (Ct = class extends ae {
  constructor(...t) {
    super(...t), this._buttonComponent = null, this.ref = null, this.handleElementRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.handleButtonRef = (r) => {
      this._buttonComponent = r;
    };
  }
  get focused() {
    return this._buttonComponent && this._buttonComponent.focused;
  }
  focus() {
    this._buttonComponent && this._buttonComponent.focus();
  }
  render() {
    const t = this.props, r = t.children, i = t.type, n = t.size, o = t.as, a = t.color, s = t.focusColor, c = t.display, u = t.textAlign, p = t.withBackground, v = t.margin, d = t.cursor, g = t.href, f = t.renderIcon, h = Se(t, qu), y = li({
      props: h
    }), k = this.props.themeOverride, A = {
      ...it(h),
      type: i,
      size: n,
      elementRef: this.handleElementRef,
      ref: this.handleButtonRef,
      as: o,
      color: a,
      interaction: y,
      focusColor: s,
      display: c,
      textAlign: u,
      withBackground: p,
      margin: v,
      cursor: d,
      href: g,
      renderIcon: f,
      themeOverride: k
    };
    return B(Bn, {
      ...A,
      children: r
    });
  }
}, Ct.displayName = "Button", Ct.componentId = "Button", Ct.propTypes = ju, Ct.allowedProps = Uu, Ct.defaultProps = {
  type: "button",
  size: "medium",
  as: "button",
  // Leave interaction default undefined so that `disabled` and `readOnly` can also be supplied
  interaction: void 0,
  color: "secondary",
  display: "inline-block",
  textAlign: "center",
  withBackground: !0,
  margin: "0",
  cursor: "pointer"
}, Ct)) || Fr) || Fr);
const Yu = (e, t) => {
  const r = t.placement, i = t.offset, n = {
    none: 0,
    "x-small": e.offsetXSmall,
    small: e.offsetSmall,
    medium: e.offsetMedium
  }, o = () => {
    const a = n[i];
    return {
      ...a !== 0 && {
        top: a
      },
      insetInlineStart: r === "start" ? a : "auto",
      insetInlineEnd: r === "end" ? a : "auto"
    };
  };
  return {
    closeButton: {
      label: "closeButton",
      zIndex: e.zIndex,
      display: "inline-block",
      ...r === "static" ? {
        position: "static"
      } : {
        position: "absolute",
        ...o()
      }
    }
  };
}, Xu = (e) => {
  const t = e.spacing, r = e.stacking;
  return {
    ...{
      offsetMedium: t == null ? void 0 : t.medium,
      offsetSmall: t == null ? void 0 : t.small,
      offsetXSmall: t == null ? void 0 : t.xSmall,
      zIndex: r == null ? void 0 : r.above
    }
  };
}, Ku = {
  screenReaderLabel: l.oneOfType([l.string, l.node]).isRequired,
  color: l.oneOf(["primary", "primary-inverse"]),
  interaction: l.oneOf(["enabled", "disabled", "readonly"]),
  elementRef: l.func,
  size: l.oneOf(["small", "medium", "large"]),
  onClick: l.func,
  margin: l.string,
  placement: l.oneOf(["start", "end", "static"]),
  offset: l.oneOf(["none", "x-small", "small", "medium"]),
  type: l.oneOf(["button", "submit", "reset"]),
  as: l.elementType,
  href: l.string,
  cursor: l.string,
  tabIndex: l.number
}, Qu = ["as", "color", "cursor", "elementRef", "href", "interaction", "margin", "offset", "onClick", "placement", "screenReaderLabel", "size", "tabIndex", "type"], Zu = ["screenReaderLabel", "elementRef", "size", "onClick", "margin", "placement", "offset", "type", "as", "href", "cursor", "tabIndex", "styles"];
var No, Wo, zr, $t;
let Ju = (No = fe(Yu, Xu), Wo = ft(), No(zr = Wo(zr = ($t = class extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      typeof i == "function" && i(r);
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  get interaction() {
    return li({
      props: this.props
    });
  }
  get color() {
    const t = this.props.color;
    return t === "primary" ? "secondary" : t;
  }
  render() {
    const t = this.props, r = t.screenReaderLabel;
    t.elementRef;
    const i = t.size, n = t.onClick, o = t.margin;
    t.placement, t.offset;
    const a = t.type, s = t.as, c = t.href, u = t.cursor, p = t.tabIndex, v = t.styles, d = Se(t, Zu);
    return B("span", {
      ...it(d),
      css: v == null ? void 0 : v.closeButton,
      ref: (g) => this.ref = g,
      children: B(Bn, {
        renderIcon: Oa,
        elementRef: this.handleRef,
        interaction: this.interaction,
        type: a,
        color: this.color,
        size: i,
        onClick: n,
        margin: o,
        withBorder: !1,
        withBackground: !1,
        as: s,
        href: c,
        cursor: u,
        tabIndex: p,
        children: B(bt, {
          children: r
        })
      })
    });
  }
}, $t.displayName = "CloseButton", $t.componentId = "CloseButton", $t.propTypes = Ku, $t.allowedProps = Qu, $t.defaultProps = {
  // Leave interaction default undefined so that `disabled` and `readOnly` can also be supplied
  interaction: void 0,
  type: "button",
  placement: "static",
  offset: "x-small",
  size: "small",
  margin: "0",
  as: "button",
  cursor: "pointer"
}, $t)) || zr) || zr);
const ef = {
  children: l.oneOfType([l.node, l.func]),
  renderIcon: l.oneOfType([l.node, l.func]),
  screenReaderLabel: l.string.isRequired,
  type: l.oneOf(["button", "submit", "reset"]),
  size: l.oneOf(["small", "medium", "large"]),
  elementRef: l.func,
  as: l.elementType,
  interaction: l.oneOf(["enabled", "disabled", "readonly"]),
  color: l.oneOf(["primary", "primary-inverse", "secondary", "success", "danger", "ai-primary", "ai-secondary"]),
  focusColor: l.oneOf(["info", "inverse"]),
  shape: l.oneOf(["rectangle", "circle"]),
  withBackground: l.bool,
  withBorder: l.bool,
  margin: l.string,
  cursor: l.string,
  href: l.string,
  onClick: l.func
}, tf = ["as", "children", "color", "cursor", "elementRef", "focusColor", "href", "interaction", "margin", "renderIcon", "screenReaderLabel", "shape", "size", "type", "withBackground", "withBorder", "onClick"], rf = ["children", "renderIcon", "screenReaderLabel", "type", "size", "elementRef", "as", "interaction", "color", "focusColor", "shape", "withBackground", "withBorder", "margin", "cursor", "href"];
var Go, Vo, Tr, Et;
let mr = (Go = fe(null, On), Vo = ft(), Go(Tr = Vo(Tr = (Et = class extends ae {
  constructor(...t) {
    super(...t), this._baseButton = null, this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  get focused() {
    return this._baseButton && this._baseButton.focused;
  }
  focus() {
    this._baseButton && this._baseButton.focus();
  }
  render() {
    const t = this.props, r = t.children, i = t.renderIcon, n = t.screenReaderLabel, o = t.type, a = t.size;
    t.elementRef;
    const s = t.as, c = t.interaction, u = t.color, p = t.focusColor, v = t.shape, d = t.withBackground, g = t.withBorder, f = t.margin, h = t.cursor, y = t.href, k = Se(t, rf), A = this.props.themeOverride;
    return B(Bn, {
      ...it(k),
      type: o,
      size: a,
      elementRef: this.handleRef,
      as: s,
      interaction: c,
      color: u,
      focusColor: p,
      shape: v,
      withBackground: d,
      withBorder: g,
      margin: f,
      cursor: h,
      href: y,
      renderIcon: r || i,
      themeOverride: A,
      ref: (x) => {
        this._baseButton = x;
      },
      children: B(bt, {
        children: n
      })
    });
  }
}, Et.displayName = "IconButton", Et.componentId = "IconButton", Et.propTypes = ef, Et.allowedProps = tf, Et.defaultProps = {
  type: "button",
  size: "medium",
  as: "button",
  // Leave interaction default undefined so that `disabled` and `readOnly` can also be supplied
  interaction: void 0,
  color: "secondary",
  shape: "rectangle",
  withBackground: !0,
  withBorder: !0,
  margin: "0",
  cursor: "pointer"
}, Et)) || Tr) || Tr);
const nf = (e, t) => {
  const r = t.variant, i = {
    hint: {
      color: e.colorHint
    },
    error: {
      color: e.colorError
    },
    newError: {
      color: e.colorError
    },
    success: {
      color: e.colorSuccess
    },
    "screenreader-only": {}
  };
  return {
    errorIcon: {
      fontSize: e.fontSize,
      marginRight: e.errorIconMarginRight,
      lineHeight: 1.25
    },
    formFieldMessage: {
      label: "formFieldMessage",
      fontFamily: e.fontFamily,
      fontWeight: e.fontWeight,
      fontSize: e.fontSize,
      lineHeight: e.lineHeight,
      display: "block",
      ...i[r]
    }
  };
}, of = (e) => {
  var t, r, i;
  const n = e.colors, o = e.typography, a = e.key, s = e.spacing, c = {
    canvas: {
      colorHint: e["ic-brand-font-color-dark"]
    }
  };
  return {
    ...{
      colorHint: n == null || (t = n.contrasts) === null || t === void 0 ? void 0 : t.grey125125,
      colorError: n == null || (r = n.contrasts) === null || r === void 0 ? void 0 : r.red5782,
      colorSuccess: n == null || (i = n.contrasts) === null || i === void 0 ? void 0 : i.green4570,
      fontFamily: o == null ? void 0 : o.fontFamily,
      fontWeight: o == null ? void 0 : o.fontWeightNormal,
      fontSize: o == null ? void 0 : o.fontSizeSmall,
      lineHeight: o == null ? void 0 : o.lineHeight,
      errorIconMarginRight: s.xxSmall
    },
    ...c[a]
  };
}, ga = l.oneOf(["error", "newError", "hint", "success", "screenreader-only"]), va = l.node, Cr = {
  message: l.shape({
    type: ga,
    text: va
  })
}, sf = {
  variant: ga,
  children: va
}, af = ["variant", "children"];
var jo, Uo, Rt, qo;
let lf = (jo = fe(nf, of), jo(Uo = (Rt = class extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      this.ref = r;
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  render() {
    const t = this.props, r = t.children, i = t.styles;
    return this.props.variant !== "screenreader-only" ? Re("span", {
      css: {
        display: "flex"
      },
      children: [this.props.variant === "newError" && this.props.children && B("span", {
        css: i == null ? void 0 : i.errorIcon,
        children: qo || (qo = B(Ba, {
          color: "error"
        }))
      }), B("span", {
        css: i == null ? void 0 : i.formFieldMessage,
        ref: this.handleRef,
        children: r
      })]
    }) : B(bt, {
      elementRef: this.handleRef,
      children: r
    });
  }
}, Rt.displayName = "FormFieldMessage", Rt.componentId = "FormFieldMessage", Rt.propTypes = sf, Rt.allowedProps = af, Rt.defaultProps = {
  variant: "hint"
}, Rt)) || Uo);
const df = (e, t) => ({
  formFieldMessages: {
    label: "formFieldMessages",
    padding: 0,
    display: "block",
    margin: `calc(-${e.topMargin}) 0 0 0`,
    ...t.gridArea && {
      gridArea: t.gridArea
    }
  },
  message: {
    label: "formFieldMessages__message",
    display: "block"
  }
}), cf = (e) => {
  const t = e.spacing;
  return {
    ...{
      topMargin: t == null ? void 0 : t.xxSmall
    }
  };
}, uf = {
  messages: l.arrayOf(Cr.message),
  gridArea: l.string
}, ff = ["messages", "gridArea"];
var Yo, Xo, At;
let hf = (Yo = fe(df, cf), Yo(Xo = (At = class ya extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      this.ref = r;
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  render() {
    const t = this.props, r = t.messages, i = t.styles;
    return r && r.length > 0 ? B("div", {
      css: i == null ? void 0 : i.formFieldMessages,
      ...Ne(this.props, ya.allowedProps),
      ref: this.handleRef,
      children: r.map((n, o) => B("span", {
        css: i == null ? void 0 : i.message,
        children: B(lf, {
          variant: n.type,
          children: n.text
        })
      }, `error${o}`))
    }) : null;
  }
}, At.displayName = "FormFieldMessages", At.componentId = "FormFieldMessages", At.propTypes = uf, At.allowedProps = ff, At.defaultProps = {}, At)) || Xo);
const Ko = (e, t, r, i) => e ? t ? i ? `${r ? ' "label messages"' : ". messages"}
                                      ". controls"` : `${r ? ' "label controls"' : ". controls"}` : `${r ? ' "label controls"' : ". controls"}
              ${i ? ' ". messages"' : ""}` : t ? `${r ? ' "label"' : ""}
            ${i ? ' "messages"' : ""}
            "controls"` : `${r ? ' "label"' : ""}
            "controls"
            ${i ? ' "messages"' : ""}`, pf = (e, t, r) => {
  const i = t.inline, n = t.layout, o = t.vAlign, a = t.labelAlign, s = t.margin, c = t.messages, u = r.hasMessages, p = r.hasVisibleLabel, v = r.hasNewErrorMsgAndIsGroup, d = Lc(s, e.spacing), g = n === "inline", f = c == null ? void 0 : c.reduce((x, w) => x || w.type !== "screenreader-only", !1), h = Ko(g, v, p, u);
  let y = "100%";
  g && (y = "1fr 3fr", i && (y = "auto 3fr"));
  const k = {
    all: "initial",
    display: "block",
    gridArea: "label",
    color: e.color,
    fontFamily: e.fontFamily,
    fontWeight: e.fontWeight,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight,
    ...g && {
      margin: "0",
      // when inline add a small padding between the label and the control
      paddingRight: e.inlinePadding,
      // and use the horizontal alignment prop
      [`@media screen and (width >= ${e.stackedOrInlineBreakpoint})`]: {
        textAlign: a
      }
    }
  };
  let A = "start";
  return o == "top" ? A = "start" : o == "middle" ? A = "center" : o == "bottom" && (A = "end"), {
    formFieldLayout: {
      label: "formFieldLayout",
      all: "initial",
      border: "0",
      padding: "0",
      margin: d,
      minWidth: "0",
      direction: "inherit",
      textAlign: "start",
      opacity: "inherit",
      display: "grid",
      alignItems: A,
      verticalAlign: "middle",
      // removes margin in inline layouts
      gridTemplateColumns: y,
      gridTemplateAreas: h,
      [`@media screen and (width < ${e.stackedOrInlineBreakpoint})`]: {
        // for small screens use the stacked layout
        gridTemplateColumns: "100%",
        gridTemplateAreas: Ko(!1, v, p, u)
      },
      columnGap: "0.375rem",
      rowGap: f ? "0.75rem" : "0",
      width: "100%",
      ...i && {
        display: "inline-grid",
        width: "auto"
      }
    },
    formFieldLabel: {
      label: "formFieldLayout__label",
      ...k,
      // NOTE: needs separate groups for `:is()` and `:-webkit-any()` because of css selector group validation (see https://www.w3.org/TR/selectors-3/#grouping)
      "&:is(label)": k,
      "&:-webkit-any(label)": k,
      paddingBottom: f ? "0" : "0.75rem"
    },
    formFieldChildren: {
      label: "formFieldLayout__children",
      gridArea: "controls",
      // add a small margin between the message and the controls
      ...u && v && {
        marginTop: "0.375rem"
      },
      ...g && i && {
        [`@media screen and (width >= ${e.stackedOrInlineBreakpoint})`]: {
          justifySelf: "start"
        }
      }
    }
  };
}, gf = {
  label: l.node.isRequired,
  id: l.string,
  as: l.elementType,
  messages: l.arrayOf(Cr.message),
  messagesId: l.string,
  children: l.node,
  inline: l.bool,
  layout: l.oneOf(["stacked", "inline"]),
  labelAlign: l.oneOf(["start", "end"]),
  vAlign: l.oneOf(["top", "middle", "bottom"]),
  width: l.string,
  inputContainerRef: l.func,
  elementRef: l.func,
  isGroup: l.bool,
  margin: l.string
}, vf = ["label", "id", "as", "messages", "messagesId", "children", "inline", "layout", "labelAlign", "width", "inputContainerRef", "elementRef", "margin", "vAlign"], yf = (e) => {
  var t;
  const r = e.colors, i = e.typography, n = e.spacing, o = e.breakpoints, a = e.key, s = {
    canvas: {
      color: e["ic-brand-font-color-dark"]
    }
  };
  return {
    ...{
      color: r == null || (t = r.contrasts) === null || t === void 0 ? void 0 : t.grey125125,
      fontFamily: i == null ? void 0 : i.fontFamily,
      fontWeight: i == null ? void 0 : i.fontWeightBold,
      fontSize: i == null ? void 0 : i.fontSizeMedium,
      lineHeight: i == null ? void 0 : i.lineHeightFit,
      inlinePadding: n == null ? void 0 : n.xxSmall,
      stackedOrInlineBreakpoint: o == null ? void 0 : o.medium,
      spacing: e.spacing
    },
    ...s[a]
  };
}, bf = ["makeStyles", "styles", "messages", "isGroup"];
var Qo, Zo, Lr, It;
let ri = (Qo = di(), Zo = fe(pf, yf), Qo(Lr = Zo(Lr = (It = class an extends ae {
  constructor(t) {
    super(t), this._messagesId = void 0, this._labelId = void 0, this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.makeStyleProps = () => {
      var r;
      const i = !!((r = this.props.messages) !== null && r !== void 0 && r.find((n) => n.type === "newError")) && !!this.props.isGroup;
      return {
        hasMessages: this.hasMessages,
        hasVisibleLabel: this.hasVisibleLabel,
        // if true render error message above the controls (and below the label)
        hasNewErrorMsgAndIsGroup: i
      };
    }, this.handleInputContainerRef = (r) => {
      typeof this.props.inputContainerRef == "function" && this.props.inputContainerRef(r);
    }, this._messagesId = t.messagesId || t.deterministicId(), this._labelId = t.deterministicId("FormField-Label");
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStyleProps());
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStyleProps());
  }
  get hasVisibleLabel() {
    return this.props.label ? _r(this.props.label) : !1;
  }
  get hasMessages() {
    if (!this.props.messages || this.props.messages.length == 0)
      return !1;
    for (const t of this.props.messages)
      if (t.text)
        return typeof t.text == "string" ? t.text.length > 0 : !0;
    return !1;
  }
  get elementType() {
    return Gt(an, this.props);
  }
  renderLabel() {
    if (this.hasVisibleLabel) {
      var t;
      if (this.elementType == "fieldset") {
        var r;
        return B("legend", {
          style: {
            display: "contents"
          },
          children: B("span", {
            css: (r = this.props.styles) === null || r === void 0 ? void 0 : r.formFieldLabel,
            children: this.props.label
          })
        });
      }
      return B("span", {
        css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.formFieldLabel,
        children: this.props.label
      });
    } else return this.props.label ? this.elementType == "fieldset" ? B("legend", {
      id: this._labelId,
      style: {
        display: "contents"
      },
      children: this.props.label
    }) : B("div", {
      id: this._labelId,
      style: {
        display: "contents"
      },
      children: this.props.label
    }) : null;
  }
  renderVisibleMessages() {
    return this.hasMessages ? B(hf, {
      id: this._messagesId,
      messages: this.props.messages,
      gridArea: "messages"
    }) : null;
  }
  render() {
    const t = this.elementType, r = this.props;
    r.makeStyles;
    const i = r.styles, n = r.messages, o = r.isGroup, a = Se(r, bf), s = a.width, c = a.children, u = !!(n != null && n.find((p) => p.type === "newError")) && o;
    return Re(t, {
      ...Ne(a, [...an.allowedProps]),
      css: i == null ? void 0 : i.formFieldLayout,
      "aria-describedby": this.hasMessages ? this._messagesId : void 0,
      "aria-errormessage": this.props["aria-invalid"] ? this._messagesId : void 0,
      style: {
        width: s
      },
      ref: this.handleRef,
      children: [this.renderLabel(), u && this.renderVisibleMessages(), B("span", {
        css: i == null ? void 0 : i.formFieldChildren,
        ref: this.handleInputContainerRef,
        children: c
      }), !u && this.renderVisibleMessages()]
    });
  }
}, It.displayName = "FormFieldLayout", It.componentId = "FormFieldLayout", It.propTypes = gf, It.allowedProps = vf, It.defaultProps = {
  inline: !1,
  layout: "stacked",
  as: "label",
  labelAlign: "end"
}, It)) || Lr) || Lr);
const mf = {
  label: l.node.isRequired,
  id: l.string.isRequired,
  messages: l.arrayOf(Cr.message),
  messagesId: l.string,
  children: l.node,
  inline: l.bool,
  layout: l.oneOf(["stacked", "inline"]),
  labelAlign: l.oneOf(["start", "end"]),
  vAlign: l.oneOf(["top", "middle", "bottom"]),
  width: l.string,
  inputContainerRef: l.func,
  elementRef: l.func,
  margin: l.string
}, wf = ["label", "id", "messages", "messagesId", "children", "inline", "layout", "labelAlign", "vAlign", "width", "inputContainerRef", "elementRef", "margin"];
class ut extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  render() {
    return B(ri, {
      ...Ne(this.props, ut.allowedProps),
      ...Vt(this.props, ri.allowedProps),
      label: this.props.label,
      vAlign: this.props.vAlign,
      as: "label",
      htmlFor: this.props.id,
      elementRef: this.handleRef,
      margin: this.props.margin
    });
  }
}
ut.displayName = "FormField";
ut.componentId = "FormField";
ut.propTypes = mf;
ut.allowedProps = wf;
ut.defaultProps = {
  inline: !1,
  layout: "stacked",
  labelAlign: "end",
  vAlign: "middle"
};
const xf = (e, t) => {
  const r = t.children, n = {
    all: "initial",
    display: "block",
    ..._r(r) && {
      color: e.color,
      fontFamily: e.fontFamily,
      fontWeight: e.fontWeight,
      fontSize: e.fontSize,
      lineHeight: e.lineHeight,
      margin: 0,
      textAlign: "inherit"
    }
  };
  return {
    formFieldLabel: {
      label: "formFieldLabel",
      ...n,
      // NOTE: needs separate groups for `:is()` and `:-webkit-any()` because of css selector group validation (see https://www.w3.org/TR/selectors-3/#grouping)
      "&:is(label)": n,
      "&:-webkit-any(label)": n
    }
  };
}, Sf = (e) => {
  var t;
  const r = e.colors, i = e.typography, n = e.key, o = {
    canvas: {
      color: e["ic-brand-font-color-dark"]
    }
  };
  return {
    ...{
      color: r == null || (t = r.contrasts) === null || t === void 0 ? void 0 : t.grey125125,
      fontFamily: i == null ? void 0 : i.fontFamily,
      fontWeight: i == null ? void 0 : i.fontWeightBold,
      fontSize: i == null ? void 0 : i.fontSizeMedium,
      lineHeight: i == null ? void 0 : i.lineHeightFit
    },
    ...o[n]
  };
}, kf = {
  children: l.node.isRequired,
  as: l.elementType
}, _f = ["as", "children"];
var Jo, es, Hr, Ot;
Jo = fe(xf, Sf), es = nl("10", null, "This component will be removed in a future version"), Jo(Hr = es(Hr = (Ot = class ln extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      this.ref = r;
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  render() {
    const t = Gt(ln, this.props), r = this.props, i = r.styles, n = r.children;
    return B(t, {
      ...Ne(this.props, ln.allowedProps),
      css: i == null ? void 0 : i.formFieldLabel,
      ref: this.handleRef,
      children: n
    });
  }
}, Ot.displayName = "FormFieldLabel", Ot.componentId = "FormFieldLabel", Ot.propTypes = kf, Ot.allowedProps = _f, Ot.defaultProps = {
  as: "span"
}, Ot)) || Hr);
const Cf = (e, t) => {
  const r = t.vAlign, i = t.textAlign, n = t.rowSpacing, o = t.colSpacing, a = t.isLastRow, s = t.isLastCol, c = t.startAt, u = t.visualDebug, p = {
    small: {
      marginBottom: e.spacingSmall
    },
    medium: {
      marginBottom: e.spacingMedium
    },
    large: {
      marginBottom: e.spacingLarge
    },
    none: {
      marginBottom: 0
    }
  }, v = () => {
    const b = {
      small: {
        paddingLeft: `calc(${e.spacingSmall} / 2)`,
        paddingRight: `calc(${e.spacingSmall} / 2)`
      },
      medium: {
        paddingLeft: `calc(${e.spacingMedium} / 2)`,
        paddingRight: `calc(${e.spacingMedium} / 2)`
      },
      large: {
        paddingLeft: `calc(${e.spacingLarge} / 2)`,
        paddingRight: `calc(${e.spacingLarge} / 2)`
      },
      none: {}
    }, C = {
      top: {
        alignSelf: "flex-start"
      },
      middle: {
        alignSelf: "center"
      },
      bottom: {
        alignSelf: "flex-end"
      },
      stretch: {
        alignSelf: "stretch"
      }
    }, S = {
      start: {
        textAlign: "start"
      },
      end: {
        textAlign: "end"
      },
      center: {
        textAlign: "center"
      },
      inherit: {
        textAlign: "inherit"
      }
    };
    return {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: "0%",
      marginBottom: 0,
      boxSizing: "border-box",
      ...o && b[o],
      ...r && C[r],
      ...i && S[i]
    };
  }, d = () => {
    const b = ["small", "medium", "large", "x-large", null];
    return b.slice(b.indexOf(c));
  }, g = (b) => d().includes(b), f = (b) => {
    let C = t.width;
    if (C)
      return C && typeof C == "object" && (C = C[b === "x-large" ? "xLarge" : b]), C;
  }, h = (b) => {
    let C = t.offset;
    if (C)
      return C && typeof C == "object" && (C = C[b === "x-large" ? "xLarge" : b]), C;
  }, y = (b = "1") => {
    switch (b) {
      case "auto":
        return {
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: "auto"
        };
      case 12:
        return {
          flex: "0 0 100%"
        };
      default:
        return {
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: `calc(${b} / 12 * 99.999%)`,
          maxWidth: `calc(${b} / 12 * 99.999%)`
        };
    }
  }, k = (b = "1") => {
    switch (b) {
      case "auto":
      case 12:
        return {};
      default:
        return {
          marginInlineStart: `calc(${b} / 12 * 99.999%)`,
          marginInlineEnd: 0
        };
    }
  }, A = (b) => c && c === b ? {
    ...v()
  } : {}, x = (b) => {
    const C = f(b), S = h(b);
    return g(b) ? {
      ...C && y(C),
      ...S && k(S)
    } : {};
  }, w = (b) => ({
    ...A(b),
    ...x(b)
  });
  return {
    gridCol: {
      label: "gridCol",
      display: "block",
      boxSizing: "border-box",
      textAlign: "inherit",
      minWidth: "0.0625rem",
      ...n && p[n],
      ...a && s && {
        marginBottom: 0
      },
      ...w("small"),
      [`@media screen and (${e.mediumMin})`]: {
        ...w("medium")
      },
      [`@media screen and (${e.largeMin})`]: {
        ...w("large")
      },
      [`@media screen and (${e.xLargeMin})`]: {
        ...w("x-large")
      },
      ...u && {
        outline: "0.0625rem dashed red"
      }
    }
  };
}, $f = (e) => {
  const t = e.spacing, r = e.media;
  return {
    ...{
      spacingSmall: t == null ? void 0 : t.small,
      spacingMedium: t == null ? void 0 : t.medium,
      spacingLarge: t == null ? void 0 : t.large,
      ...r
    }
  };
}, Ze = l.oneOfType([l.number, l.oneOf(["auto"])]), Ef = {
  children: l.node,
  colSpacing: l.oneOf(["none", "small", "medium", "large"]),
  rowSpacing: l.oneOf(["none", "small", "medium", "large"]),
  textAlign: l.oneOf(["start", "end", "center", "inherit"]),
  hAlign: l.oneOf(["start", "center", "end", "space-around", "space-between"]),
  vAlign: l.oneOf(["top", "middle", "bottom", "stretch"]),
  startAt: l.oneOf(["small", "medium", "large", "x-large", null]),
  visualDebug: l.bool,
  width: l.oneOfType([Ze, l.shape({
    small: Ze,
    medium: Ze,
    large: Ze,
    xLarge: Ze
  })]),
  offset: l.oneOfType([Ze, l.shape({
    small: Ze,
    medium: Ze,
    large: Ze,
    xLarge: Ze
  })]),
  isLastRow: l.bool,
  isLastCol: l.bool,
  elementRef: l.func
}, Rf = ["children", "colSpacing", "rowSpacing", "textAlign", "hAlign", "vAlign", "startAt", "visualDebug", "width", "offset", "isLastRow", "isLastCol", "elementRef"];
var ts, rs, Bt;
let Pn = (ts = fe(Cf, $f), ts(rs = (Bt = class ba extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  widthCheck() {
    const t = this.props.width;
    let r = !1;
    t && (typeof t == "number" && t <= 0 && (r = !0), typeof t == "object" && Object.keys(t).forEach((i) => {
      typeof t[i] == "number" && t[i] <= 0 && (r = !0);
    })), r && ct(!1, "Col width must be positive!");
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r), this.widthCheck();
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r), this.widthCheck();
  }
  render() {
    const t = this.props, r = t.children, i = t.styles, n = Ne(this.props, ba.allowedProps);
    return B("span", {
      ...n,
      ref: this.handleRef,
      css: i == null ? void 0 : i.gridCol,
      children: r
    });
  }
}, Bt.displayName = "GridCol", Bt.componentId = "Grid.Col", Bt.propTypes = Ef, Bt.allowedProps = Rf, Bt.defaultProps = {
  textAlign: "inherit",
  children: null,
  isLastCol: !1,
  isLastRow: !1
}, Bt)) || rs);
const Af = (e, t) => {
  const r = t.hAlign, i = t.vAlign, n = t.rowSpacing, o = t.colSpacing, a = t.isLastRow, s = t.startAt, c = t.visualDebug, u = () => {
    const v = {
      center: {
        justifyContent: "center"
      },
      start: {
        justifyContent: "flex-start"
      },
      end: {
        justifyContent: "flex-end"
      },
      "space-around": {
        justifyContent: "space-around"
      },
      "space-between": {
        justifyContent: "space-between"
      }
    }, d = {
      top: {
        alignItems: "flex-start"
      },
      middle: {
        alignItems: "center"
      },
      bottom: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    }, g = {
      small: {
        margin: `0 calc(-1 * ${e.spacingSmall} / 2)`
      },
      medium: {
        margin: `0 calc(-1 * ${e.spacingMedium} / 2)`
      },
      large: {
        margin: `0 calc(-1 * ${e.spacingLarge} / 2)`
      },
      none: {}
    }, f = {
      small: {
        marginBottom: e.spacingSmall
      },
      medium: {
        marginBottom: e.spacingMedium
      },
      large: {
        marginBottom: e.spacingLarge
      },
      none: {
        marginBottom: 0
      }
    };
    return {
      display: "flex",
      flexFlow: "row nowrap",
      ...r && v[r],
      ...i && d[i],
      ...o && g[o],
      ...n && f[n],
      ...a && {
        marginBottom: 0
      }
    };
  }, p = (v) => s && s === v ? {
    ...u()
  } : {};
  return {
    gridRow: {
      label: "gridRow",
      display: "block",
      boxSizing: "border-box",
      ...p("small"),
      [`@media screen and (${e.mediumMin})`]: {
        ...p("medium")
      },
      [`@media screen and (${e.largeMin})`]: {
        ...p("large")
      },
      [`@media screen and (${e.xLargeMin})`]: {
        ...p("x-large")
      },
      ...c && {
        outline: "0.0625rem dashed blue"
      }
    }
  };
}, If = (e) => {
  const t = e.spacing, r = e.media;
  return {
    ...{
      spacingSmall: t == null ? void 0 : t.small,
      spacingMedium: t == null ? void 0 : t.medium,
      spacingLarge: t == null ? void 0 : t.large,
      ...r
    }
  };
}, Of = {
  children: ra.oneOf([Pn, bt]),
  rowSpacing: l.oneOf(["none", "small", "medium", "large"]),
  colSpacing: l.oneOf(["none", "small", "medium", "large"]),
  hAlign: l.oneOf(["start", "center", "end", "space-around", "space-between"]),
  vAlign: l.oneOf(["top", "middle", "bottom", "stretch"]),
  startAt: l.oneOf(["small", "medium", "large", "x-large", null]),
  visualDebug: l.bool,
  isLastRow: l.bool
}, Bf = ["children", "rowSpacing", "colSpacing", "hAlign", "vAlign", "startAt", "visualDebug", "isLastRow"], Pf = ["styles", "makeStyles"], Df = ["styles"];
var is, ns, Pt;
let dn = (is = fe(Af, If), is(ns = (Pt = class cn extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      this.ref = r;
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  renderChildren() {
    const t = this.props;
    t.styles, t.makeStyles;
    const r = Se(t, Pf);
    return Be.map(this.props.children, (i, n) => Sr(i, [Pn]) ? Ht(i, {
      ...Vt(r, cn.allowedProps),
      ...i.props,
      isLastRow: r.isLastRow,
      isLastCol: n + 1 === Be.count(this.props.children)
    }) : i);
  }
  render() {
    const t = this.props, r = t.styles, i = Se(t, Df), n = Ne(i, cn.allowedProps);
    return B("span", {
      ...n,
      css: r == null ? void 0 : r.gridRow,
      ref: this.handleRef,
      children: this.renderChildren()
    });
  }
}, Pt.displayName = "GridRow", Pt.componentId = "Grid.Row", Pt.propTypes = Of, Pt.allowedProps = Bf, Pt.defaultProps = {
  children: null,
  isLastRow: !1
}, Pt)) || ns);
const Mf = (e, t) => {
  const r = t.startAt, i = t.visualDebug, n = (o) => r && r === o ? {
    boxSizing: "border-box"
  } : {};
  return {
    grid: {
      label: "grid",
      display: "block",
      ...n("small"),
      [`@media screen and (${e.mediumMin})`]: {
        ...n("medium")
      },
      [`@media screen and (${e.largeMin})`]: {
        ...n("large")
      },
      [`@media screen and (${e.xLargeMin})`]: {
        ...n("x-large")
      },
      ...i && {
        outline: "0.0625rem dashed red"
      }
    }
  };
}, Ff = (e) => {
  const t = e.spacing, r = e.media;
  return {
    ...{
      spacingSmall: t == null ? void 0 : t.small,
      spacingMedium: t == null ? void 0 : t.medium,
      spacingLarge: t == null ? void 0 : t.large,
      ...r
    }
  };
}, zf = {
  children: ra.oneOf([dn, bt]),
  colSpacing: l.oneOf(["none", "small", "medium", "large"]),
  rowSpacing: l.oneOf(["none", "small", "medium", "large"]),
  hAlign: l.oneOf(["start", "center", "end", "space-around", "space-between"]),
  vAlign: l.oneOf(["top", "middle", "bottom", "stretch"]),
  startAt: l.oneOf(["small", "medium", "large", "x-large", null]),
  visualDebug: l.bool
}, Tf = ["children", "colSpacing", "rowSpacing", "hAlign", "vAlign", "startAt", "visualDebug"], Lf = ["styles", "makeStyles"], Hf = ["styles"];
var os, ss, dt;
let Yi = (os = fe(Mf, Ff), os(ss = (dt = class un extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      this.ref = r;
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  renderChildren() {
    const t = this.props;
    t.styles, t.makeStyles;
    const r = Se(t, Lf), i = Be.toArray(this.props.children);
    return i.map((n, o) => Sr(n, [dn]) ? Ht(n, {
      ...Vt(r, un.allowedProps),
      ...n.props,
      isLastRow: o + 1 === i.length
    }) : n);
  }
  render() {
    const t = this.props, r = t.styles, i = Se(t, Hf), n = Ne(i, un.allowedProps);
    return B("span", {
      ...n,
      css: r == null ? void 0 : r.grid,
      ref: this.handleRef,
      children: this.renderChildren()
    });
  }
}, dt.displayName = "Grid", dt.componentId = "Grid", dt.propTypes = zf, dt.allowedProps = Tf, dt.defaultProps = {
  colSpacing: "medium",
  rowSpacing: "medium",
  hAlign: "start",
  startAt: "small",
  vAlign: "top",
  visualDebug: !1,
  children: null
}, dt.Row = dn, dt.Col = Pn, dt)) || ss);
const Nf = (e, t, r) => {
  const i = t.disabled, n = r.invalid;
  return {
    formFieldGroup: {
      label: "formFieldGroup",
      border: `${e.borderWidth} ${e.borderStyle} ${e.borderColor}`,
      borderRadius: e.borderRadius,
      display: "block",
      ...n && {
        borderColor: e.errorBorderColor,
        padding: e.errorFieldsPadding
      },
      ...i && {
        opacity: 0.6,
        cursor: "not-allowed",
        pointerEvents: "none"
      }
    }
  };
}, Wf = (e) => {
  var t;
  const r = e.borders, i = e.colors, n = e.spacing;
  return {
    ...{
      borderWidth: r == null ? void 0 : r.widthSmall,
      borderStyle: r == null ? void 0 : r.style,
      borderColor: "transparent",
      borderRadius: r == null ? void 0 : r.radiusMedium,
      errorBorderColor: i == null || (t = i.contrasts) === null || t === void 0 ? void 0 : t.red4570,
      errorFieldsPadding: n == null ? void 0 : n.xSmall
    }
  };
}, Gf = {
  description: l.node.isRequired,
  as: l.elementType,
  messages: l.arrayOf(Cr.message),
  messagesId: l.string,
  disabled: l.bool,
  children: l.node,
  layout: l.oneOf(["stacked", "columns", "inline"]),
  rowSpacing: l.oneOf(["none", "small", "medium", "large"]),
  colSpacing: l.oneOf(["none", "small", "medium", "large"]),
  vAlign: l.oneOf(["top", "middle", "bottom"]),
  startAt: l.oneOf(["small", "medium", "large", "x-large", null]),
  elementRef: l.func
}, Vf = ["description", "as", "messages", "messagesId", "disabled", "children", "layout", "rowSpacing", "colSpacing", "vAlign", "startAt", "elementRef"], jf = ["styles", "makeStyles", "isGroup"];
var as, ls, Dt;
as = fe(Nf, Wf), as(ls = (Dt = class ma extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStylesVariables);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStylesVariables);
  }
  get makeStylesVariables() {
    return {
      invalid: !!this.props.messages && this.props.messages.findIndex((r) => r.type === "error") >= 0
    };
  }
  get invalid() {
    return !!this.props.messages && this.props.messages.findIndex((t) => t.type === "error" || t.type === "newError") >= 0;
  }
  renderColumns() {
    return Be.map(this.props.children, (t, r) => t ? B(Yi.Col, {
      width: t.props && t.props.width ? "auto" : void 0,
      children: t
    }, r) : null);
  }
  renderChildren() {
    return B(Yi, {
      colSpacing: this.props.colSpacing,
      rowSpacing: this.props.rowSpacing,
      vAlign: this.props.vAlign,
      startAt: this.props.startAt || (this.props.layout === "columns" ? "medium" : null),
      children: B(Yi.Row, {
        children: this.renderColumns()
      })
    });
  }
  renderFields() {
    const t = this.props.styles;
    return B("span", {
      css: t == null ? void 0 : t.formFieldGroup,
      children: this.renderChildren()
    }, "fields");
  }
  render() {
    const t = this.props;
    t.styles, t.makeStyles;
    const r = t.isGroup, i = Se(t, jf);
    let n;
    return this.props.role && this.invalid && ["application", "checkbox", "combobox", "gridcell", "listbox", "radiogroup", "slider", "spinbutton", "textbox", "tree", "columnheader", "rowheader", "searchbox", "switch", "treegrid"].includes(this.props.role) && (n = "true"), B(ri, {
      ...Ne(i, ma.allowedProps),
      ...Vt(i, ri.allowedProps),
      vAlign: i.vAlign,
      layout: i.layout === "inline" ? "inline" : "stacked",
      label: i.description,
      "aria-disabled": i.disabled ? "true" : void 0,
      "aria-invalid": n,
      elementRef: this.handleRef,
      isGroup: r,
      children: this.renderFields()
    });
  }
}, Dt.displayName = "FormFieldGroup", Dt.componentId = "FormFieldGroup", Dt.propTypes = Gf, Dt.allowedProps = Vf, Dt.defaultProps = {
  as: "fieldset",
  disabled: !1,
  rowSpacing: "medium",
  colSpacing: "small",
  vAlign: "middle",
  isGroup: !0
}, Dt));
const Uf = (e, t) => {
  const r = t.disabled, i = t.size, n = {
    small: {
      fontSize: e.smallFontSize
    },
    medium: {
      fontSize: e.mediumFontSize
    },
    large: {
      fontSize: e.largeFontSize
    }
  };
  return {
    requiredInvalid: {
      color: e.requiredInvalidColor
    },
    textArea: {
      label: "textArea",
      all: "initial",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      appearance: "none",
      height: "auto",
      margin: 0,
      width: "100%",
      display: "block",
      boxSizing: "border-box",
      padding: e.padding,
      fontFamily: e.fontFamily,
      fontWeight: e.fontWeight,
      borderWidth: e.borderWidth,
      borderStyle: e.borderStyle,
      borderTopColor: e.borderTopColor,
      borderRightColor: e.borderRightColor,
      borderBottomColor: e.borderBottomColor,
      borderLeftColor: e.borderLeftColor,
      borderRadius: e.borderRadius,
      color: e.color,
      background: e.background,
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
      textAlign: "start",
      ...n[i],
      "&:focus + [class$=-textArea__outline]": {
        transform: "scale(1)",
        opacity: 1
      },
      "&[aria-invalid], &[aria-invalid]:focus, &[aria-invalid]:focus + [class$=-textArea__outline]": {
        borderColor: e.errorBorderColor
      },
      "&::placeholder": {
        color: e.placeholderColor
      },
      ...r && {
        cursor: "not-allowed",
        pointerEvents: "none",
        opacity: 0.5
      }
    },
    textAreaLayout: {
      label: "textArea__layout",
      position: "relative"
    },
    textAreaOutline: {
      label: "textArea__outline",
      pointerEvents: "none",
      position: "absolute",
      display: "block",
      boxSizing: "border-box",
      top: "-0.25rem",
      bottom: "-0.25rem",
      left: "-0.25rem",
      right: "-0.25rem",
      border: `${e.focusOutlineWidth} ${e.focusOutlineStyle} ${e.focusOutlineColor}`,
      borderRadius: `calc(${e.borderRadius} * 1.5)`,
      transition: "all 0.2s",
      // properties to transition on :focus
      opacity: 0,
      transform: "scale(0.95)"
    }
  };
}, qf = (e) => {
  var t, r, i, n, o, a, s, c, u, p, v;
  const d = e.colors, g = e.typography, f = e.borders, h = e.spacing, y = e.forms, k = e.key, A = {
    canvas: {
      color: e["ic-brand-font-color-dark"],
      focusOutlineColor: e["ic-brand-primary"]
    }
  };
  return {
    ...{
      fontFamily: g == null ? void 0 : g.fontFamily,
      fontWeight: g == null ? void 0 : g.fontWeightNormal,
      color: d == null || (t = d.contrasts) === null || t === void 0 ? void 0 : t.grey125125,
      background: d == null || (r = d.contrasts) === null || r === void 0 ? void 0 : r.white1010,
      requiredInvalidColor: d == null || (i = d.contrasts) === null || i === void 0 ? void 0 : i.red5782,
      borderWidth: f == null ? void 0 : f.widthSmall,
      borderStyle: f == null ? void 0 : f.style,
      borderTopColor: d == null || (n = d.contrasts) === null || n === void 0 ? void 0 : n.grey3045,
      borderRightColor: d == null || (o = d.contrasts) === null || o === void 0 ? void 0 : o.grey3045,
      borderBottomColor: d == null || (a = d.contrasts) === null || a === void 0 ? void 0 : a.grey3045,
      borderLeftColor: d == null || (s = d.contrasts) === null || s === void 0 ? void 0 : s.grey3045,
      borderRadius: f == null ? void 0 : f.radiusMedium,
      padding: h == null ? void 0 : h.small,
      focusOutlineColor: d == null || (c = d.contrasts) === null || c === void 0 ? void 0 : c.blue4570,
      focusOutlineWidth: f == null ? void 0 : f.widthMedium,
      focusOutlineStyle: f == null ? void 0 : f.style,
      errorBorderColor: d == null || (u = d.contrasts) === null || u === void 0 ? void 0 : u.red4570,
      errorOutlineColor: d == null || (p = d.contrasts) === null || p === void 0 ? void 0 : p.red4570,
      placeholderColor: d == null || (v = d.contrasts) === null || v === void 0 ? void 0 : v.grey4570,
      smallFontSize: g == null ? void 0 : g.fontSizeSmall,
      smallHeight: y == null ? void 0 : y.inputHeightSmall,
      mediumFontSize: g == null ? void 0 : g.fontSizeMedium,
      mediumHeight: y == null ? void 0 : y.inputHeightMedium,
      largeFontSize: g == null ? void 0 : g.fontSizeLarge,
      largeHeight: y == null ? void 0 : y.inputHeightLarge
    },
    ...A[k]
  };
}, Yf = {
  label: l.node.isRequired,
  id: l.string,
  size: l.oneOf(["small", "medium", "large"]),
  layout: l.oneOf(["stacked", "inline"]),
  autoGrow: l.bool,
  resize: l.oneOf(["none", "both", "horizontal", "vertical"]),
  width: l.string,
  height: l.string,
  maxHeight: l.oneOfType([l.number, l.string]),
  messages: l.arrayOf(Cr.message),
  inline: l.bool,
  placeholder: l.string,
  disabled: l.bool,
  readOnly: l.bool,
  required: l.bool,
  textareaRef: l.func,
  defaultValue: l.string,
  value: ic(l.string),
  onChange: l.func,
  margin: l.string
}, Xf = ["label", "id", "size", "layout", "autoGrow", "resize", "width", "height", "maxHeight", "messages", "inline", "placeholder", "disabled", "readOnly", "required", "textareaRef", "defaultValue", "value", "onChange", "margin"];
var ds, cs, us, Yt, Mt;
let Kf = (ds = di(), cs = fe(Uf, qf), us = ft(), ds(Yt = cs(Yt = us(Yt = (Mt = class wa extends ae {
  constructor(t) {
    super(t), this._listener = void 0, this._request = void 0, this._defaultId = void 0, this._textareaResizeListener = void 0, this._debounced = void 0, this._textarea = null, this._container = null, this._height = void 0, this._manuallyResized = !1, this._highlightRef = null, this.myObserver = null, this.resizeTimeout = void 0, this.ref = null, this._textareaResize = () => {
      const r = this._textarea.style.height;
      r !== "" && r !== this._height && (this._manuallyResized = !0, this._textarea.style.overflowY = "auto", this._container.style.minHeight = r);
    }, this.grow = () => {
      if (!this._textarea || this._manuallyResized)
        return;
      const r = this._textarea.offsetHeight - this._textarea.clientHeight;
      let i = "";
      this._textarea.style.height = "auto", this._textarea.style.overflowY = "hidden", i = this._textarea.scrollHeight + r + "px";
      const n = this.props.maxHeight ? wi(this.props.maxHeight, this._container) : void 0;
      this.props.maxHeight && n !== void 0 && this._textarea.scrollHeight > n ? this._textarea.style.overflowY = "auto" : this.props.height && (this._textarea.value === "" ? i = this.props.height : wi(this.props.height, this._container) > this._textarea.scrollHeight && (this._textarea.style.overflowY = "auto", i = this.props.height)), n !== void 0 && wi(i) > n || (this._container.style.minHeight = i), this._height = i, this._textarea.style.height = i;
    }, this.handleChange = (r) => {
      const i = this.props, n = i.onChange, o = i.value, a = i.disabled, s = i.readOnly;
      if (a || s) {
        r.preventDefault();
        return;
      }
      typeof o > "u" && this.autoGrow(), typeof n == "function" && n(r);
    }, this.handleContainerRef = (r) => {
      this._container = r;
    }, this._defaultId = t.deterministicId(), typeof window > "u" && (global.ResizeObserver = class {
      observe() {
      }
      unobserve() {
      }
      disconnect() {
      }
    });
  }
  componentDidMount() {
    var t, r;
    this.myObserver = new ResizeObserver((i) => {
      for (const n of i)
        if (this._highlightRef) {
          const o = window.getComputedStyle(n.target);
          this._highlightRef.style.transition = "none", this._highlightRef.style.width = `calc(${o.width} + 0.5rem)`, this._highlightRef.style.height = `calc(${o.height} + 0.5rem)`, clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
            this._highlightRef && (this._highlightRef.style.transition = "all 0.2s");
          }, 500);
        }
    }), this.autoGrow(), (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    this.autoGrow(), (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentWillUnmount() {
    this._listener && this._listener.remove(), this._textareaResizeListener && this._textareaResizeListener.disconnect(), this._request && this._request.cancel(), this._debounced && this._debounced.cancel(), this.myObserver && this.myObserver.disconnect();
  }
  autoGrow() {
    if (this.props.autoGrow) {
      if (this._debounced || (this._debounced = ca(this.grow, 200, {
        leading: !1,
        trailing: !0
      })), this._listener || (this._listener = wl(window, "resize", this._debounced)), this._textarea && !this._textareaResizeListener) {
        const t = hr(this._textarea), r = t.height;
        this._textareaResizeListener = new ResizeObserver((i) => {
          for (const n of i) {
            const o = n.contentRect.height;
            r !== o && this._textareaResize();
          }
        }), this._textareaResizeListener.observe(this._textarea);
      }
      this._request = kl(this.grow);
    }
  }
  focus() {
    this._textarea.focus();
  }
  get minHeight() {
    return this._textarea.style.minHeight;
  }
  get invalid() {
    return this.props.messages && this.props.messages.findIndex((t) => t.type === "error" || t.type === "newError") >= 0;
  }
  get id() {
    return this.props.id || this._defaultId;
  }
  get focused() {
    return yn(this._textarea);
  }
  get value() {
    return this._textarea.value;
  }
  render() {
    var t, r, i;
    const n = this.props, o = n.autoGrow, a = n.placeholder, s = n.value, c = n.defaultValue, u = n.disabled, p = n.readOnly, v = n.required, d = n.width, g = n.height, f = n.maxHeight, h = n.textareaRef, y = n.resize, k = n.styles, A = n.margin, x = Ne(this.props, wa.allowedProps), b = B("textarea", {
      ...x,
      value: s,
      defaultValue: c,
      placeholder: a,
      ref: (S) => {
        if (S) {
          var Y;
          (Y = this.myObserver) === null || Y === void 0 || Y.observe(S);
        }
        this._textarea = S, typeof h == "function" && h(S);
      },
      style: {
        width: d,
        resize: y,
        height: o ? void 0 : g,
        maxHeight: f
      },
      id: this.id,
      required: v,
      "aria-required": v,
      "aria-invalid": this.invalid ? "true" : void 0,
      disabled: u || p,
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.textArea,
      onChange: this.handleChange
    }), C = _r(this.props.label) ? Re(Kr, {
      children: [this.props.label, v && Re("span", {
        css: this.invalid ? k == null ? void 0 : k.requiredInvalid : {},
        "aria-hidden": !0,
        children: [" ", "*"]
      })]
    }) : this.props.label;
    return B(ut, {
      ...Vt(this.props, ut.allowedProps),
      label: C,
      vAlign: "top",
      id: this.id,
      elementRef: (S) => {
        this.ref = S;
      },
      margin: A,
      children: Re("div", {
        css: (r = this.props.styles) === null || r === void 0 ? void 0 : r.textAreaLayout,
        style: {
          width: d,
          maxHeight: f
        },
        ref: this.handleContainerRef,
        children: [b, !u && !p ? B("span", {
          css: (i = this.props.styles) === null || i === void 0 ? void 0 : i.textAreaOutline,
          "aria-hidden": "true",
          ref: (S) => this._highlightRef = S
        }) : null]
      })
    });
  }
}, Mt.displayName = "TextArea", Mt.componentId = "TextArea", Mt.allowedProps = Xf, Mt.propTypes = Yf, Mt.defaultProps = {
  size: "medium",
  autoGrow: !0,
  resize: "none",
  inline: !1,
  messages: [],
  disabled: !1,
  readOnly: !1,
  layout: "stacked",
  required: !1
}, Mt)) || Yt) || Yt) || Yt);
const Qf = "_container_xig5o_1", Zf = "_inputWrapper_xig5o_8", Jf = "_footer_xig5o_12", Xi = {
  container: Qf,
  inputWrapper: Zf,
  footer: Jf
}, eh = ({
  onSend: e,
  onStop: t,
  disabled: r = !1,
  isLoading: i = !1,
  label: n,
  buttonLabel: o
}) => {
  const a = Wt(), [s, c] = we(""), u = Qt(null), p = Qt(null), v = s.trim().length > 0 && !r && !i;
  tr(() => {
    var f, h, y;
    i ? (f = u.current) == null || f.focus() : (y = (h = p.current) == null ? void 0 : h.querySelector("textarea")) == null || y.focus();
  }, [i]);
  const d = () => {
    v && (e(s), c(""));
  }, g = (f) => {
    f.key === "Enter" && !f.shiftKey && (f.preventDefault(), d());
  };
  return /* @__PURE__ */ be("div", { className: Xi.container, children: [
    /* @__PURE__ */ E("div", { ref: p, className: Xi.inputWrapper, children: /* @__PURE__ */ E(
      Kf,
      {
        label: /* @__PURE__ */ E(bt, { children: n }),
        value: s,
        onChange: (f) => c(f.target.value),
        onKeyDown: g,
        placeholder: n,
        disabled: i,
        maxHeight: "24rem",
        resize: "none",
        themeOverride: {
          background: "transparent",
          borderTopColor: "transparent",
          borderRightColor: "transparent",
          borderBottomColor: "transparent",
          borderLeftColor: "transparent",
          focusOutlineColor: "transparent"
        }
      }
    ) }),
    /* @__PURE__ */ E("div", { className: Xi.footer, children: /* @__PURE__ */ E(ue, { justifyItems: "end", children: /* @__PURE__ */ E(ue.Item, { children: i ? /* @__PURE__ */ E(
      br,
      {
        renderIcon: /* @__PURE__ */ E(Pa, {}),
        onClick: t,
        elementRef: (f) => {
          u.current = f;
        },
        children: a.stop()
      }
    ) : /* @__PURE__ */ E(
      mr,
      {
        screenReaderLabel: o ?? a.sendMessage(),
        interaction: v ? "enabled" : "disabled",
        onClick: d,
        children: /* @__PURE__ */ E(Da, {})
      }
    ) }) }) })
  ] });
}, th = (e, t, r) => {
  const i = t.isWithinText, n = t.renderIcon, o = t.iconPlacement, a = t.color, s = t.variant, c = r.containsTruncateText, u = r.hasVisibleChildren, p = a === "link-inverse", v = {
    inline: {
      fontSize: e.fontSize,
      lineHeight: e.lineHeight,
      textDecoration: "underline"
    },
    "inline-small": {
      fontSize: e.fontSizeSmall,
      lineHeight: "1.3125rem",
      textDecoration: "underline"
    },
    standalone: {
      fontSize: e.fontSize,
      lineHeight: e.lineHeight,
      textDecoration: "none"
    },
    "standalone-small": {
      fontSize: e.fontSizeSmall,
      lineHeight: e.lineHeight,
      textDecoration: "none"
    }
  }, d = {
    boxSizing: "border-box",
    fontFamily: e.fontFamily,
    fontWeight: e.fontWeight,
    transition: "outline-color 0.2s",
    verticalAlign: "baseline",
    // set up focus styles
    outlineColor: "transparent",
    outlineOffset: "0.25rem",
    textUnderlineOffset: e.textUnderlineOffset,
    // If TruncateText is used in Link with icon, align the icon and the text vertically
    ...n && c && u && {
      alignItems: "center"
    },
    "&&&&&&:focus": {
      outlineWidth: e.focusOutlineWidth,
      outlineStyle: e.focusOutlineStyle,
      borderRadius: e.focusOutlineBorderRadius,
      outlineColor: e.focusOutlineColor
    },
    "&[aria-disabled]": {
      cursor: "not-allowed",
      pointerEvents: "none",
      opacity: "0.5"
    },
    "&::-moz-focus-inner": {
      border: 0
      // removes default dotted focus outline in Firefox
    }
  }, g = {
    ...d,
    cursor: "pointer",
    color: e.color,
    // This needs stronger specificity than `View`
    "&&&&&:focus": {
      color: e.color,
      outlineColor: e.focusOutlineColor
    },
    "&:hover, &:active": {
      color: e.hoverColor,
      textDecoration: i ? e.hoverTextDecorationWithinText : e.hoverTextDecorationOutsideText
    },
    ...s ? v[s] : {
      textDecoration: i ? e.textDecorationWithinText : e.textDecorationOutsideText
    }
  }, f = {
    appearance: "none",
    userSelect: "text",
    background: "none",
    border: "none",
    cursor: "pointer",
    margin: 0,
    padding: 0,
    textAlign: "inherit",
    ...s ? v[s] : {
      fontSize: "1em"
    }
  }, h = {
    color: e.colorInverse,
    "&&&&&:focus": {
      outlineColor: e.focusInverseOutlineColor
    },
    ...n && {
      "&&&&&:focus": {
        outlineColor: e.focusInverseIconOutlineColor
      }
    },
    "&:hover, &&&&&:focus, &:active": {
      color: e.colorInverse
    }
  }, y = {
    inline: {
      paddingInlineStart: o === "start" ? 0 : e.iconPlusTextMargin,
      paddingInlineEnd: o === "start" ? e.iconPlusTextMargin : 0
    },
    "inline-small": {
      paddingInlineStart: o === "start" ? 0 : e.iconPlusTextMarginSmall,
      paddingInlineEnd: o === "start" ? e.iconPlusTextMarginSmall : 0
    },
    standalone: {
      paddingInlineStart: o === "start" ? 0 : e.iconPlusTextMargin,
      paddingInlineEnd: o === "start" ? e.iconPlusTextMargin : 0
    },
    "standalone-small": {
      paddingInlineStart: o === "start" ? 0 : e.iconPlusTextMarginSmall,
      paddingInlineEnd: o === "start" ? e.iconPlusTextMarginSmall : 0
    }
  };
  return {
    link: {
      label: "link",
      ...d,
      // NOTE: needs separate groups for `:is()` and `:-webkit-any()` because of css selector group validation (see https://www.w3.org/TR/selectors-3/#grouping)
      "&:is(a), &:is(button)": g,
      "&:-webkit-any(a), &:-webkit-any(button)": g,
      "&:is(button)": f,
      "&:-webkit-any(button)": f,
      ...p && {
        ...h,
        "&:is(a):link, &:is(a):visited, &:is(button)": h,
        "&:-webkit-any(a):link, &:-webkit-any(a):visited, &:-webkit-any(button)": h
      }
    },
    icon: {
      label: "icon",
      ...n && {
        fontSize: e.iconSize,
        boxSizing: "border-box",
        ...s ? y[s] : {
          paddingInlineStart: o === "start" ? 0 : e.iconPlusTextMargin,
          paddingInlineEnd: o === "start" ? e.iconPlusTextMargin : 0
        }
      }
    }
  };
}, rh = (e) => {
  var t, r, i, n, o, a;
  const s = e.colors, c = e.borders, u = e.typography, p = e.spacing, v = e.key, d = {
    canvas: {
      color: e["ic-link-color"],
      focusOutlineColor: e["ic-brand-primary"],
      hoverColor: Le(e["ic-link-color"], 10)
    },
    "canvas-high-contrast": {
      textDecorationOutsideText: "underline",
      hoverTextDecorationOutsideText: "none"
    }
  };
  return {
    ...{
      fontFamily: u == null ? void 0 : u.fontFamily,
      fontWeight: u == null ? void 0 : u.fontWeightNormal,
      fontSize: u == null ? void 0 : u.content,
      lineHeight: u == null ? void 0 : u.lineHeight150,
      fontSizeSmall: u == null ? void 0 : u.contentSmall,
      color: s == null || (t = s.contrasts) === null || t === void 0 ? void 0 : t.blue5782,
      textDecorationWithinText: "underline",
      hoverTextDecorationWithinText: "none",
      textDecorationOutsideText: "none",
      hoverTextDecorationOutsideText: "underline",
      focusOutlineWidth: c == null ? void 0 : c.widthMedium,
      focusOutlineColor: s == null || (r = s.contrasts) === null || r === void 0 ? void 0 : r.blue4570,
      focusOutlineStyle: c == null ? void 0 : c.style,
      focusOutlineBorderRadius: c == null ? void 0 : c.radiusSmall,
      hoverColor: Le(s == null || (i = s.contrasts) === null || i === void 0 ? void 0 : i.blue5782, 10),
      colorInverse: s == null || (n = s.contrasts) === null || n === void 0 ? void 0 : n.grey1111,
      focusInverseOutlineColor: s == null || (o = s.contrasts) === null || o === void 0 ? void 0 : o.white1010,
      focusInverseIconOutlineColor: s == null || (a = s.contrasts) === null || a === void 0 ? void 0 : a.white1010,
      iconSize: "1.125em",
      // make icon slightly larger than inherited font-size,
      iconPlusTextMargin: p.space4,
      iconPlusTextMarginSmall: p.space2,
      textUnderlineOffset: "auto"
    },
    ...d[v]
  };
}, ih = {
  children: l.node.isRequired,
  href: l.string,
  color: l.oneOf(["link", "link-inverse"]),
  elementRef: l.func,
  as: l.elementType,
  role: l.string,
  forceButtonRole: l.bool,
  interaction: l.oneOf(["enabled", "disabled"]),
  margin: l.string,
  renderIcon: l.oneOfType([l.func, l.node]),
  iconPlacement: l.oneOf(["start", "end"]),
  display: l.oneOf(["auto", "block", "inline-block", "flex", "inline-flex"]),
  isWithinText: l.bool,
  onBlur: l.func,
  onClick: l.func,
  onFocus: l.func,
  onMouseEnter: l.func,
  variant: l.oneOf(["inline", "inline-small", "standalone", "standalone-small"])
}, nh = ["children", "href", "color", "elementRef", "as", "role", "forceButtonRole", "interaction", "margin", "renderIcon", "iconPlacement", "display", "isWithinText", "onBlur", "onClick", "onFocus", "onMouseEnter", "variant"], oh = ["children", "onClick", "onMouseEnter", "color", "href", "margin", "renderIcon", "iconPlacement", "isWithinText"];
var fs, hs, Nr, Ft;
let sh = (fs = fe(th, rh), hs = ft(), fs(Nr = hs(Nr = (Ft = class xa extends ae {
  constructor(...t) {
    super(...t), this.state = {
      hasFocus: !1
    }, this.ref = null, this.makeStyleProps = () => ({
      containsTruncateText: this.containsTruncateText,
      hasVisibleChildren: this.hasVisibleChildren
    }), this.handleElementRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.handleClick = (r) => {
      const i = this.props.onClick;
      this.interaction === "disabled" ? (r.preventDefault(), r.stopPropagation()) : typeof i == "function" && i(r);
    }, this.handleFocus = (r) => {
      this.setState({
        hasFocus: !0
      }), typeof this.props.onFocus == "function" && this.props.onFocus(r);
    }, this.handleBlur = (r) => {
      this.setState({
        hasFocus: !1
      }), typeof this.props.onBlur == "function" && this.props.onBlur(r);
    };
  }
  get _link() {
    return this.ref;
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStyleProps());
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r, this.makeStyleProps());
  }
  get containsTruncateText() {
    let t = !1;
    return Be.forEach(this.props.children, (r) => {
      r && Sr(r, ["TruncateText"]) && (t = !0);
    }), ct(
      // if display prop is used, warn about icon or TruncateText
      !t || this.props.display === void 0,
      "[Link] Using the display property with TruncateText may cause layout issues."
    ), t;
  }
  get display() {
    if (this.props.display)
      return this.props.display;
    const t = this.containsTruncateText;
    return this.props.renderIcon ? t ? "inline-flex" : "inline-block" : t ? "block" : "auto";
  }
  get interaction() {
    return li({
      props: this.props,
      interactionTypes: ["disabled"]
    });
  }
  get element() {
    return Gt(xa, this.props);
  }
  get focused() {
    return yn(this.ref);
  }
  get focusable() {
    return Rl(this.ref);
  }
  get hasVisibleChildren() {
    return _r(this.props.children);
  }
  get role() {
    const t = this.props, r = t.role, i = t.forceButtonRole, n = t.onClick;
    return i && n && this.element !== "button" ? "button" : r;
  }
  focus() {
    this.ref && this.ref.focus();
  }
  renderIcon() {
    var t;
    return ct(
      // if display prop is used, warn about icon or TruncateText
      this.props.display === void 0,
      "[Link] Using the display property with an icon may cause layout issues."
    ), B("span", {
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.icon,
      children: Jt(this.props.renderIcon)
    });
  }
  render() {
    var t;
    const r = this.props, i = r.children;
    r.onClick;
    const n = r.onMouseEnter;
    r.color;
    const o = r.href, a = r.margin, s = r.renderIcon, c = r.iconPlacement;
    r.isWithinText;
    const u = Se(r, oh), v = this.interaction === "disabled", d = this.element === "button" || this.element === "input" ? "button" : void 0, g = this.role === "button" && !v ? 0 : void 0;
    return Re(Ae, {
      ...it(u),
      elementRef: this.handleElementRef,
      as: this.element,
      display: this.display,
      margin: a,
      href: o,
      onMouseEnter: n,
      onClick: this.handleClick,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      "aria-disabled": v ? "true" : void 0,
      role: this.role,
      type: d,
      tabIndex: g,
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.link,
      children: [s && c === "start" ? this.renderIcon() : null, i, s && c === "end" ? this.renderIcon() : null]
    });
  }
}, Ft.displayName = "Link", Ft.componentId = "Link", Ft.propTypes = ih, Ft.allowedProps = nh, Ft.defaultProps = {
  // Leave interaction default undefined so that `disabled` can also be supplied
  interaction: void 0,
  color: "link",
  iconPlacement: "start",
  isWithinText: !0,
  forceButtonRole: !0
}, Ft)) || Nr) || Nr);
const ah = (e, t) => {
  const r = t.size, i = t.wrap, n = t.weight, o = t.fontStyle, a = t.transform, s = t.lineHeight, c = t.letterSpacing, u = t.color, p = t.variant, v = {
    descriptionPage: {
      fontStyle: "normal",
      fontWeight: e.weightRegular,
      fontSize: e.descriptionPage,
      lineHeight: e.lineHeight150
    },
    descriptionSection: {
      fontStyle: "normal",
      fontWeight: e.weightRegular,
      fontSize: e.descriptionSection,
      lineHeight: e.lineHeight150
    },
    content: {
      fontStyle: "normal",
      fontWeight: e.weightRegular,
      fontSize: e.content,
      lineHeight: e.lineHeight150
    },
    contentImportant: {
      fontStyle: "normal",
      fontWeight: e.weightImportant,
      fontSize: e.content,
      lineHeight: e.lineHeight150
    },
    contentQuote: {
      fontStyle: "italic",
      fontWeight: e.weightRegular,
      fontSize: e.content,
      lineHeight: e.lineHeight150
    },
    contentSmall: {
      fontStyle: "normal",
      fontWeight: e.weightRegular,
      fontSize: e.contentSmall,
      lineHeight: e.lineHeight150
    },
    legend: {
      fontStyle: "normal",
      fontWeight: e.weightRegular,
      fontSize: e.legend,
      lineHeight: e.lineHeight150
    }
  }, d = {
    primary: {
      color: e.primaryColor
    },
    secondary: {
      color: e.secondaryColor
    },
    "primary-inverse": {
      color: e.primaryInverseColor
    },
    "secondary-inverse": {
      color: e.secondaryInverseColor
    },
    success: {
      color: e.successColor
    },
    brand: {
      color: e.brandColor
    },
    danger: {
      color: e.dangerColor
    },
    alert: {
      color: e.alertColor
    },
    warning: {
      color: e.warningColor
    },
    "ai-highlight": {
      color: e.aiColor,
      background: e.aiBackgroundColor
    }
  }, g = {
    overflowWrap: "break-word",
    wordBreak: "break-word",
    hyphens: "auto"
  }, f = {
    normal: {
      fontWeight: e.fontWeightNormal
    },
    light: {
      fontWeight: e.fontWeightLight
    },
    bold: {
      fontWeight: e.fontWeightBold
    },
    weightRegular: {
      fontWeight: e.weightRegular
    },
    weightImportant: {
      fontWeight: e.weightImportant
    }
  }, h = {
    "x-small": e.fontSizeXSmall,
    small: e.fontSizeSmall,
    medium: e.fontSizeMedium,
    large: e.fontSizeLarge,
    "x-large": e.fontSizeXLarge,
    "xx-large": e.fontSizeXXLarge,
    descriptionPage: e.descriptionPage,
    descriptionSection: e.descriptionSection,
    content: e.content,
    contentSmall: e.contentSmall,
    legend: e.legend
  }, y = {
    default: {
      lineHeight: e.lineHeight
    },
    fit: {
      lineHeight: e.lineHeightFit
    },
    condensed: {
      lineHeight: e.lineHeightCondensed
    },
    double: {
      lineHeight: e.lineHeightDouble
    },
    lineHeight100: {
      lineHeight: e.lineHeight100
    },
    lineHeight125: {
      lineHeight: e.lineHeight125
    },
    lineHeight150: {
      lineHeight: e.lineHeight150
    }
  }, k = {
    normal: e.letterSpacingNormal,
    condensed: e.letterSpacingCondensed,
    expanded: e.letterSpacingExpanded
  }, A = () => p ? v[p] : {
    ...n ? f[n] : {},
    ...o ? {
      fontStyle: o
    } : {},
    fontSize: h[r],
    ...s ? y[s] : {}
  }, x = {
    "&:focus": {
      outline: "none"
    },
    ...u ? d[u] : {},
    ...i === "break-word" ? g : {},
    letterSpacing: k[c],
    ...a ? {
      textTransform: a
    } : {},
    ...A()
  }, w = {
    ...x,
    outline: 0,
    appearance: "none",
    boxSizing: "border-box",
    background: "none",
    border: "none",
    borderRadius: 0,
    padding: 0,
    margin: 0,
    color: "inherit",
    height: "auto",
    width: "100%",
    lineHeight: "inherit",
    textAlign: "start",
    boxShadow: "none",
    display: "block"
  };
  return {
    text: {
      label: "text",
      fontFamily: e.fontFamily,
      ...x,
      // NOTE: needs separate groups for `:is()` and `:-webkit-any()` because of css selector group validation (see https://www.w3.org/TR/selectors-3/#grouping)
      "&:is(input)[type]": w,
      "&:-webkit-any(input)[type]": w,
      "sub, sup": {
        fontSize: "75%",
        lineHeight: 0,
        position: "relative",
        verticalAlign: "baseline"
      },
      sup: {
        top: "-0.4em"
      },
      sub: {
        bottom: "-0.4em"
      },
      "pre, code": {
        all: "initial",
        fontFamily: e.fontFamilyMonospace
      },
      "i, em": {
        fontStyle: "italic"
      },
      "b, strong": {
        fontWeight: e.fontWeightBold
      },
      p: {
        display: "block",
        padding: 0,
        margin: e.paragraphMargin
      }
    }
  };
}, lh = (e) => {
  var t, r, i, n, o, a, s, c, u, p, v;
  const d = e.colors, g = e.typography, f = e.spacing, h = e.key, y = {
    canvas: {
      primaryColor: e["ic-brand-font-color-dark"],
      brandColor: e["ic-brand-primary"]
    }
  };
  return {
    ...{
      ...g,
      primaryInverseColor: d == null || (t = d.contrasts) === null || t === void 0 ? void 0 : t.white1010,
      primaryColor: d == null || (r = d.contrasts) === null || r === void 0 ? void 0 : r.grey125125,
      secondaryColor: d == null || (i = d.contrasts) === null || i === void 0 ? void 0 : i.grey5782,
      secondaryInverseColor: d == null || (n = d.contrasts) === null || n === void 0 ? void 0 : n.grey1111,
      brandColor: d == null || (o = d.contrasts) === null || o === void 0 ? void 0 : o.blue5782,
      dangerColor: d == null || (a = d.contrasts) === null || a === void 0 ? void 0 : a.red5782,
      successColor: d == null || (s = d.contrasts) === null || s === void 0 ? void 0 : s.green5782,
      alertColor: d == null || (c = d.contrasts) === null || c === void 0 ? void 0 : c.blue5782,
      warningColor: d == null || (u = d.contrasts) === null || u === void 0 ? void 0 : u.orange5782,
      aiColor: d == null || (p = d.contrasts) === null || p === void 0 ? void 0 : p.violet5790,
      aiBackgroundColor: d == null || (v = d.contrasts) === null || v === void 0 ? void 0 : v.violet1212,
      paragraphMargin: `${f.medium} 0`
    },
    ...y[h]
  };
}, dh = {
  as: l.elementType,
  children: l.node,
  color: l.oneOf(["primary", "secondary", "brand", "success", "danger", "warning", "alert", "primary-inverse", "secondary-inverse", "ai-highlight"]),
  elementRef: l.func,
  fontStyle: l.oneOf(["italic", "normal"]),
  letterSpacing: l.oneOf(["normal", "condensed", "expanded"]),
  lineHeight: l.oneOf(["default", "fit", "condensed", "double", "lineHeight100", "lineHeight125", "lineHeight150"]),
  size: l.oneOf(["x-small", "small", "medium", "large", "x-large", "xx-large", "descriptionPage", "descriptionSection", "content", "contentSmall", "legend"]),
  transform: l.oneOf(["none", "capitalize", "uppercase", "lowercase"]),
  variant: l.oneOf(["descriptionPage", "descriptionSection", "content", "contentImportant", "contentQuote", "contentSmall", "legend"]),
  weight: l.oneOf(["normal", "light", "bold", "weightRegular", "weightImportant"]),
  wrap: l.oneOf(["normal", "break-word"])
}, ch = ["as", "children", "color", "elementRef", "fontStyle", "letterSpacing", "lineHeight", "size", "transform", "variant", "weight", "wrap"];
var ps, gs, zt;
let qe = (ps = fe(ah, lh), ps(gs = (zt = class Sa extends ae {
  checkProps() {
    const t = this.props;
    t.variant, t.lineHeight, t.weight, t.fontStyle;
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r), this.checkProps();
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r), this.checkProps();
  }
  render() {
    var t;
    const r = this.props.children, i = Gt(Sa, this.props);
    return B(i, {
      ...it(this.props),
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.text,
      ref: this.props.elementRef,
      children: r
    });
  }
}, zt.displayName = "Text", zt.componentId = "Text", zt.allowedProps = ch, zt.propTypes = dh, zt.defaultProps = {
  as: "span",
  wrap: "normal",
  size: "medium",
  letterSpacing: "normal",
  children: null
}, zt)) || gs);
const uh = (e) => ({
  truncateText: {
    label: "truncateText",
    display: "block",
    overflow: "hidden",
    wordWrap: "break-word",
    whiteSpace: "normal",
    fontFamily: e.fontFamily
  },
  auto: {
    label: "truncateText__auto",
    height: "100%"
  },
  spacer: {
    label: "truncateText__spacer",
    visibility: "hidden",
    maxHeight: "0",
    display: "block"
  },
  lineHeight: e.lineHeight
}), fh = (e) => {
  const t = e.typography;
  return {
    ...{
      fontFamily: t == null ? void 0 : t.fontFamily,
      lineHeight: t == null ? void 0 : t.lineHeight
    }
  };
};
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */
var Ki, vs;
function hh() {
  if (vs) return Ki;
  vs = 1;
  var e = /["'&<>]/;
  Ki = t;
  function t(r) {
    var i = "" + r, n = e.exec(i);
    if (!n)
      return i;
    var o, a = "", s = 0, c = 0;
    for (s = n.index; s < i.length; s++) {
      switch (i.charCodeAt(s)) {
        case 34:
          o = "&quot;";
          break;
        case 38:
          o = "&amp;";
          break;
        case 39:
          o = "&#39;";
          break;
        case 60:
          o = "&lt;";
          break;
        case 62:
          o = "&gt;";
          break;
        default:
          continue;
      }
      c !== s && (a += i.substring(c, s)), c = s + 1, a += o;
    }
    return c !== s ? a + i.substring(c, s) : a;
  }
  return Ki;
}
var ph = hh();
const gh = /* @__PURE__ */ ir(ph);
function vh(e, t) {
  let r = 0;
  for (let i = 0; i < e.length; i++) {
    const n = e[i];
    r += yh(n.textContent, n.nodeType === 1 ? n : t);
  }
  return r;
}
function yh(e, t) {
  const r = yt(t), i = document.createElement("canvas");
  document.createDocumentFragment().appendChild(i);
  const n = i.getContext("2d");
  if (!n || !e)
    return 0;
  let o = e, a = 0, s = 0;
  return n.font = [r.fontWeight, r.fontStyle, r.fontSize, r.fontFamily].join(" "), r.textTransform === "uppercase" ? o = e.toUpperCase() : r.textTransform === "lowercase" ? o = e.toLowerCase() : r.textTransform === "capitalize" && (o = e.replace(/\b\w/g, (c) => c.toUpperCase())), r.letterSpacing !== "normal" && (a = o.length * parseInt(r.letterSpacing)), s = n.measureText(o).width + a, s;
}
function Xr(e, t, r = !0, i = !0, n = !1) {
  let o = e;
  const a = o.charAt(0), s = o.slice(-1);
  return r && t.indexOf(a) !== -1 && (o = o.slice(1)), i && t.indexOf(s) !== -1 && (o = o.slice(0, -1)), n && (o = Xr(o, t, r, i, !1)), o;
}
function ka(e, t, r = !1) {
  const i = t.truncate, n = t.ignore, o = t.ellipsis;
  let a = ur(e), s = -1, c = -1;
  const u = () => {
    for (let p = 0; p < a.length; p++) {
      const v = a[p];
      v.indexOf(o) !== -1 && (s = p, c = v.indexOf(o));
    }
  };
  if (i === "character") {
    u();
    let p = a[s];
    if (p) {
      const v = p[c - 1];
      if (v && n.indexOf(v) !== -1 && a[s].splice(c - 1, 1), !v) {
        let d = null, g = s - 1;
        for (; g >= 0 && (d = a[g], !(d.length > 0)); )
          g--;
        if (d) {
          const f = String(d.slice(-1));
          n.indexOf(f) !== -1 && (a[g].length -= 1);
        }
      }
    }
    if (u(), p = a[s], p) {
      const v = p[c + 1];
      if (v && n.indexOf(v) !== -1 && a[s].splice(c + 1, 1), !v) {
        let d = null, g = s + 1;
        for (; g < a.length && (d = a[g], !(d.length > 0)); )
          g++;
        if (d) {
          const f = String(d[0]);
          n.indexOf(f) !== -1 && a[g].shift();
        }
      }
    }
  } else {
    u();
    const p = a[s];
    if (p) {
      const v = p[c - 1];
      if (v && n.indexOf(v.slice(-1)) !== -1 && (v.length === 1 ? a[s].splice(c - 1, 1) : a[s][c - 1] = v.slice(0, -1)), !v) {
        let d = null, g = s - 1;
        for (; g >= 0 && (d = a[g], !(d.length > 0)); )
          g--;
        if (d) {
          const f = String(d.slice(-1)).slice(-1);
          if (n.indexOf(f) !== -1) {
            const h = d.length - 1;
            a[g][h] = d[h].slice(0, -1);
          }
        }
      }
    }
  }
  return r && (a = ka(a, t, !1)), a;
}
function bh(e, t) {
  const r = new mh(e, t);
  if (r)
    return r.truncate();
}
class mh {
  constructor(t, r = {}) {
    this._options = void 0, this._stage = void 0, this._parent = void 0, this._nodeMap = void 0, this._defaultStringData = void 0, this._nodeDataIndexes = void 0, this._maxHeight = void 0, this._maxWidth = void 0, this._maxLines = void 0;
    const i = t != null && t.parentElement ? t == null ? void 0 : t.parentElement : void 0;
    if (this._options = {
      parent: r.parent || i,
      maxLines: r.maxLines || 1,
      position: r.position || "end",
      truncate: r.truncate || "character",
      ellipsis: r.ellipsis || "…",
      ignore: r.ignore || [" ", ".", ","],
      lineHeight: r.lineHeight || 1.2,
      shouldTruncateWhenInvisible: !!r.shouldTruncateWhenInvisible
    }, !t) {
      Xe(!1, "[Truncator] No element to truncate.");
      return;
    }
    if (this._stage = t, r.parent)
      this._parent = this._options.parent;
    else {
      const n = this._stage.parentElement ? this._stage.parentElement : void 0;
      this._parent = this._options.maxLines === "auto" ? n : this._stage;
    }
    this.setup();
  }
  setup() {
    if (!this._stage)
      return;
    const t = this._options, r = t.maxLines, i = t.truncate, n = t.lineHeight, o = yt(this._parent), a = o.lineHeight === "normal" ? n * parseFloat(o.fontSize) : parseFloat(o.lineHeight), s = this._stage.firstChild.children ? this._stage.firstChild : this._stage, c = [], u = [];
    this._nodeMap = this.getNodeMap(s);
    for (let p = 0; p < this._nodeMap.length; p++) {
      const v = this._nodeMap[p];
      i === "word" && v.data[v.data.length - 1] === " " && (v.data.length -= 1), u[p] = v.data;
      for (let d = 0; d < v.data.length; d++)
        c.push(p);
    }
    this._defaultStringData = ur(u), this._nodeDataIndexes = ur(c), this._maxHeight = r === "auto" ? hr(this._parent).height : r * a, this._maxWidth = vh(this._nodeMap.map((p) => p.node), this._parent), this._maxLines = r === "auto" ? Math.round(this._maxHeight / a) : r;
  }
  getNodeMap(t) {
    const r = this._options, i = r.shouldTruncateWhenInvisible, n = r.truncate, o = Array.from(t.childNodes), a = [];
    return o.forEach((s) => {
      if (s.nodeType === 1 || s.nodeType === 3) {
        const c = i ? !0 : Zi(s, !1), u = s.textContent + " ";
        a.push({
          node: s,
          data: n === "word" ? c ? (
            // eslint-disable-next-line no-useless-escape
            u.match(/.*?[\.\s\/]+?/g)
          ) : [""] : c ? s.textContent.split("") : []
        });
      }
    }), a;
  }
  getNodeIndexes(t) {
    const r = [];
    for (let i = 0; i < t.length; i++)
      for (let n = 0; n < t[i].length; n++)
        r.push([i, n]);
    return r;
  }
  domString(t) {
    let r = "";
    for (let i = 0; i < t.length; i++) {
      const n = this._nodeMap[i], o = t[i].join(""), a = gh(o);
      if (n.node.nodeType === Node.ELEMENT_NODE) {
        const s = n.node.nodeName, c = n.node.attributes;
        let u = "";
        for (let p = 0; p < c.length; p++) {
          const v = c[p];
          u += ` ${v.nodeName}="${v.nodeValue}"`;
        }
        r += `<${s}${u}>${a}</${s}>`;
      } else n.node.nodeType === 3 && (r += a);
    }
    return r;
  }
  checkFit(t) {
    const r = this.domString(t), i = this._options.maxLines === "auto" ? this._stage : this._parent;
    let n = !0;
    return this._stage.innerHTML = r, hr(i).height - this._maxHeight > 0.5 && (n = !1), n;
  }
  truncate() {
    const t = this._options, r = t.ellipsis, i = t.ignore, o = t.position === "middle";
    let a = !1, s = "", c = null;
    if (!this._stage)
      return;
    const u = (f, h, y, k, A = null) => {
      let x = f, w = h, b = A;
      for (; x <= w; ) {
        const C = Math.floor((x + w) / 2);
        y(C, k) ? (w = C - 1, b = C) : x = C + 1;
      }
      return b;
    }, p = (f, h, y, k) => {
      let A = !1;
      const x = ur(h);
      switch (f) {
        case 0:
          break;
        case y.length:
          A = !0;
          for (let w = 0; w < x.length; w++)
            x[w] = [];
          x[0].push(r);
          break;
        default:
          if (A = !0, k) {
            const w = Array(2);
            w[0] = Math.floor((y.length - f - 1) / 2), w[1] = w[0] + f + 1;
            const b = w.map((S) => y[S]), C = Array(2);
            C[0] = w[0] + 1, C[1] = y.length - f - C[0];
            for (let S = 0; S <= b[0]; S++)
              switch (!0) {
                case S < b[0]:
                  C[0] -= x[S].length;
                  break;
                case S === b[0]:
                  x[S] = h[S].slice(0, C[0]), x[S].push(r);
                  break;
              }
            for (let S = h.length - 1; S >= b[1]; S--)
              switch (!0) {
                case S > b[1]:
                  C[1] -= h[S].length;
                  break;
                case S === b[1]:
                  b[1] > b[0] && (x[S] = h[S].slice(-C[1])), b[1] === b[0] && (x[S] = x[S].concat(h[S].slice(-C[1])));
                  break;
              }
            for (let S = b[0] + 1; S < b[1]; S++)
              x[S] = [];
          } else {
            const w = y.length - f - 1, b = y[w];
            let C = w + 1;
            for (let S = 0; S < h.length; S++)
              switch (!0) {
                case S < b:
                  C -= x[S].length;
                  break;
                case S === b:
                  x[S] = x[S].slice(0, C), x[S].push(r);
                  break;
                case S > b:
                  x[S] = [];
                  break;
              }
          }
          break;
      }
      return {
        truncated: A,
        truncatedArray: x
      };
    }, v = (f, h) => {
      const y = p(f, this._defaultStringData, this._nodeDataIndexes, h), k = y.truncatedArray;
      return this.checkFit(k);
    }, d = u(0, this._nodeDataIndexes.length, v, o, this._nodeDataIndexes.length);
    var g = p(d, this._defaultStringData, this._nodeDataIndexes, o);
    a = g.truncated, c = g.truncatedArray, c = ka(c, this._options, !0);
    for (let f = 0; f < c.length; f++) {
      const h = c[f];
      s += h.join("");
    }
    if (a && !o)
      s = Xr(s.split(r)[0], i, !1, !0, !0), s += r;
    else if (a && o) {
      const f = s.split(r);
      s = Xr(f[0], i, !1, !0, !0) + r + Xr(f[1], i, !0, !1, !0);
    }
    return {
      isTruncated: a,
      text: s,
      data: c,
      constraints: {
        width: this._maxWidth,
        height: this._maxHeight,
        lines: this._maxLines
      }
    };
  }
}
const wh = {
  children: l.node.isRequired,
  maxLines: l.oneOfType([l.string, l.number]),
  position: l.oneOf(["end", "middle"]),
  truncate: l.oneOf(["character", "word"]),
  ellipsis: l.string,
  ignore: l.arrayOf(l.string),
  debounce: l.number,
  onUpdate: l.func,
  shouldTruncateWhenInvisible: l.bool
}, xh = ["children", "maxLines", "position", "truncate", "ellipsis", "ignore", "debounce", "onUpdate", "shouldTruncateWhenInvisible"];
var ys, bs, ms, Xt, Tt;
let fn = (ys = fe(uh, fh), bs = ft(), ms = Md(["shouldTruncateWhenInvisible"]), ys(Xt = bs(Xt = ms(Xt = (Tt = class extends ae {
  constructor(t) {
    super(t), this.ref = null, this._text = void 0, this._debounced = void 0, this._stage = null, this._wasTruncated = void 0, this._resizeListener = void 0, this._prevWidth = null, this.update = () => {
      this.ref && this.setState(this.initialState);
    }, this.state = this.initialState;
  }
  get _ref() {
    return this.ref;
  }
  get initialState() {
    return {
      isTruncated: !1,
      needsSecondRender: !0,
      truncatedElement: void 0,
      truncatedText: void 0
    };
  }
  componentDidMount() {
    const t = this.props, r = t.children, i = t.makeStyles;
    if (i == null || i(), r) {
      var n;
      this.checkChildren();
      const o = dr(r);
      this._text = o || void 0, this.truncate(), this._debounced = ca(this.update, this.props.debounce, {
        leading: !0,
        trailing: !0
      }), this._prevWidth = (n = hr(this.ref)) === null || n === void 0 ? void 0 : n.width, this._resizeListener = new ResizeObserver((a) => {
        requestAnimationFrame(() => {
          for (const s of a) {
            const c = s.contentRect.width;
            this._prevWidth !== c && (this._prevWidth = c, this.props.debounce === 0 ? this.update() : this._debounced());
          }
        });
      }), this._resizeListener.observe(this.ref);
    }
  }
  componentWillUnmount() {
    this._resizeListener && this._resizeListener.disconnect(), this._debounced && this._debounced.cancel();
  }
  componentDidUpdate(t) {
    const r = this.props, i = r.children, n = r.onUpdate, o = r.makeStyles;
    o == null || o();
    const a = this.state, s = a.isTruncated, c = a.needsSecondRender, u = a.truncatedText;
    if (i) {
      if (t !== this.props) {
        if (t.children !== this.props.children) {
          this.checkChildren();
          const p = dr(i);
          this._text = p || void 0;
        }
        this.setState(this.initialState);
        return;
      }
      !c && (s || this._wasTruncated) ? (n == null || n(s, u), this._wasTruncated = s) : this.truncate();
    }
  }
  checkChildren() {
    Xe(!(() => {
      let t = !1;
      const r = dr(this.props.children);
      return Be.forEach(r.props.children, (i) => {
        i.props && Be.forEach(i.props.children, (n) => {
          n.props && (t = !0);
        });
      }), t;
    })(), "[TruncateText] Some children are too deep in the node tree and will not render.");
  }
  truncate() {
    if (this.state.needsSecondRender)
      if (rt) {
        var t;
        const n = bh(this._stage, {
          ...this.props,
          parent: this.ref ? this.ref : void 0,
          lineHeight: (t = this.props.styles) === null || t === void 0 ? void 0 : t.lineHeight
        });
        if (n) {
          const o = this.renderChildren(n.isTruncated, n.data, n.constraints.width);
          this.setState({
            needsSecondRender: !1,
            isTruncated: n.isTruncated,
            truncatedElement: o,
            truncatedText: n.text
          });
        }
      } else {
        var r, i;
        const n = (r = this.ref) !== null && r !== void 0 && r.textContent ? (i = this.ref) === null || i === void 0 ? void 0 : i.textContent : void 0;
        this.setState({
          needsSecondRender: !1,
          isTruncated: !1,
          truncatedElement: this._text,
          truncatedText: n
        });
      }
  }
  renderChildren(t, r, i) {
    var n;
    if (!t)
      return this._text;
    const o = [];
    for (let s = 0; s < r.length; s++) {
      const c = r[s], u = this._text.props.children[s], p = c.join("");
      u && u.props ? o.push(Ht(u, u.props, p)) : o.push(p);
    }
    o.push(B("span", {
      css: (n = this.props.styles) === null || n === void 0 ? void 0 : n.spacer,
      style: {
        width: i || void 0
      }
    }));
    const a = Be.map(o, (s) => s);
    return this._text.props ? Ht(this._text, this._text.props, a) : a;
  }
  render() {
    var t;
    const r = this.state.truncatedElement, i = this.props.children;
    return Re("span", {
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.truncateText,
      ref: (n) => {
        this.ref = n;
      },
      children: [i && (r ? null : B("span", {
        ref: (n) => {
          this._stage = n;
        },
        children: dr(i)
      })), r]
    });
  }
}, Tt.displayName = "TruncateText", Tt.componentId = "TruncateText", Tt.allowedProps = xh, Tt.propTypes = wh, Tt.defaultProps = {
  maxLines: 1,
  ellipsis: "…",
  truncate: "character",
  position: "end",
  ignore: [" ", ".", ","],
  debounce: 0
}, Tt)) || Xt) || Xt) || Xt);
const Sh = (e) => {
  switch (e) {
    case "Assignment":
      return /* @__PURE__ */ E(La, {});
    case "Discussion":
      return /* @__PURE__ */ E(Ta, {});
    case "Quiz":
      return /* @__PURE__ */ E(za, {});
    case "ExternalUrl":
    case "ExternalTool":
      return /* @__PURE__ */ E(Fa, {});
    default:
      return /* @__PURE__ */ E(Ma, {});
  }
}, kh = ({
  chat: e,
  prompt: t,
  renderMessage: r,
  renderRichContent: i,
  onAnalyticsEvent: n,
  textColor: o
}) => {
  const a = (e == null ? void 0 : e.actor) === He.User, s = !e && !!t, c = o ? { primaryColor: o } : void 0;
  return /* @__PURE__ */ E(Ae, { as: "div", margin: "0 0 small 0", textAlign: a ? "end" : "start", children: /* @__PURE__ */ be(
    Ae,
    {
      as: "div",
      display: s ? "block" : "inline-block",
      background: a ? "primary" : s ? "secondary" : "transparent",
      borderRadius: "medium",
      padding: s || a ? "small" : "none",
      maxWidth: a ? "80%" : "100%",
      children: [
        /* @__PURE__ */ E(Ae, { as: "div", margin: "xx-small 0", children: e != null && e.htmlMessage ? i ? i(e.htmlMessage) : /* @__PURE__ */ E(qe, { color: "primary", themeOverride: c, children: e.htmlMessage }) : r && ((e == null ? void 0 : e.message) ?? (t == null ? void 0 : t.longMessage)) ? r((e == null ? void 0 : e.message) ?? (t == null ? void 0 : t.longMessage) ?? "") : /* @__PURE__ */ E(qe, { color: "primary", themeOverride: c, children: (e == null ? void 0 : e.message) ?? (t == null ? void 0 : t.longMessage) }) }),
        (e == null ? void 0 : e.citations) && e.citations.length > 0 && /* @__PURE__ */ E(Ae, { as: "div", children: e.citations.map((u) => {
          const p = /* @__PURE__ */ be(ue, { as: "span", gap: "xx-small", alignItems: "center", display: "inline-flex", children: [
            u.objectType !== "Syllabus" && /* @__PURE__ */ E(ue.Item, { children: Sh(u.objectType) }),
            /* @__PURE__ */ E(ue.Item, { children: /* @__PURE__ */ E(fn, { children: /* @__PURE__ */ E(
              qe,
              {
                size: "small",
                fontStyle: "italic",
                color: "primary",
                themeOverride: c,
                children: u.objectName
              }
            ) }) })
          ] });
          return /* @__PURE__ */ E(
            Ae,
            {
              as: "div",
              margin: "xx-small 0 0 0",
              children: u.link ? /* @__PURE__ */ E(
                sh,
                {
                  href: u.link,
                  target: "_blank",
                  isWithinText: !1,
                  onClick: () => n == null ? void 0 : n(`citation-link-${u.objectType.toLowerCase()}`),
                  children: p
                }
              ) : p
            },
            `${u.objectType}_${u.objectId}`
          );
        }) })
      ]
    }
  ) });
}, ws = ({
  prompt: e,
  onClick: t,
  withBackground: r = !1,
  color: i = "primary-inverse",
  isFullWidth: n = !1
}) => /* @__PURE__ */ E(
  br,
  {
    onClick: t,
    color: i,
    withBackground: r,
    display: n ? "block" : "inline-block",
    themeOverride: n ? { mediumPaddingTop: "0.75rem", mediumPaddingBottom: "0.75rem" } : void 0,
    children: n ? /* @__PURE__ */ E(Ae, { as: "div", textAlign: "start", children: /* @__PURE__ */ E(fn, { maxLines: 1, children: e.shortMessage }) }) : /* @__PURE__ */ E(fn, { maxLines: 1, children: e.shortMessage })
  }
), _a = ({
  onAnalyticsEvent: e,
  color: t = "primary-inverse"
}) => {
  const r = Wt(), [i, n] = we(null), o = () => {
    const s = i === !0 ? null : !0;
    n(s), s === !0 && (e == null || e("chat-good-response"));
  }, a = () => {
    const s = i === !1 ? null : !1;
    n(s), s === !1 && (e == null || e("chat-bad-response"));
  };
  return /* @__PURE__ */ be(ue, { as: "div", gap: "small", margin: "x-small", children: [
    /* @__PURE__ */ E(
      mr,
      {
        screenReaderLabel: r.goodResponse(),
        withBorder: !0,
        withBackground: !1,
        color: t,
        size: "small",
        "aria-pressed": i === !0,
        onClick: o,
        children: i === !0 ? /* @__PURE__ */ E(Tn, {}) : /* @__PURE__ */ E(Ln, {})
      }
    ),
    /* @__PURE__ */ E(
      mr,
      {
        screenReaderLabel: r.badResponse(),
        withBorder: !0,
        withBackground: !1,
        color: t,
        size: "small",
        "aria-pressed": i === !1,
        onClick: a,
        children: /* @__PURE__ */ E("span", { style: { display: "inline-block", transform: "rotate(180deg)" }, children: i === !1 ? /* @__PURE__ */ E(Tn, {}) : /* @__PURE__ */ E(Ln, {}) })
      }
    )
  ] });
}, _h = ({
  chatEnabled: e = !0,
  showLargePrompts: t,
  showSmallPrompts: r,
  assistPrompts: i,
  handlePromptInteraction: n,
  chats: o,
  isLoading: a,
  onSubmit: s,
  onAnalyticsEvent: c,
  inputLabel: u,
  inputButtonLabel: p,
  thumbsColor: v,
  renderMessage: d,
  renderRichContent: g,
  promptButtonWithBackground: f,
  textColor: h = "white"
}) => {
  var w;
  const y = Wt(), k = Qt(null), A = o.some((b) => b.actor === He.User), x = e ? o : a ? [] : o.filter((b, C) => b.actor !== He.Assistant ? !1 : A ? o.slice(0, C).some((S) => S.actor === He.User) : !0);
  return tr(() => {
    var b;
    o.length !== 0 && ((b = k.current) == null || b.scrollIntoView({ behavior: "smooth" }));
  }, [o]), /* @__PURE__ */ be(ue, { as: "div", direction: "column", height: "100%", justifyItems: "space-between", gap: "small", children: [
    /* @__PURE__ */ be(Ae, { as: "div", height: "100%", overflowY: "auto", padding: "0 xx-small", children: [
      /* @__PURE__ */ E(
        ue,
        {
          as: "div",
          direction: "column",
          justifyItems: t ? "center" : "start",
          "aria-live": "off",
          "aria-label": y.chatHistory(),
          children: /* @__PURE__ */ be(ue.Item, { children: [
            x.map((b) => /* @__PURE__ */ be(Kr, { children: [
              /* @__PURE__ */ E(
                kh,
                {
                  chat: b,
                  renderMessage: d,
                  renderRichContent: g,
                  onAnalyticsEvent: c,
                  textColor: h
                }
              ),
              b.actor === He.Assistant && o.slice(
                0,
                o.findIndex((C) => C.id === b.id)
              ).some((C) => C.actor === He.User) && /* @__PURE__ */ E(ue, { justifyItems: "end", children: /* @__PURE__ */ E(_a, { onAnalyticsEvent: c, color: v }) })
            ] }, b.id)),
            t && !a && /* @__PURE__ */ E(ue, { as: "div", direction: "column", gap: "small", children: i.map((b) => /* @__PURE__ */ E(ue.Item, { children: /* @__PURE__ */ E(
              ws,
              {
                prompt: b,
                onClick: () => {
                  n(b), c == null || c(
                    `prompt-${b.shortMessage.toLowerCase().replace(/\s+/g, "-")}`
                  );
                },
                withBackground: f,
                isFullWidth: !0
              }
            ) }, b.id)) }),
            a && /* @__PURE__ */ E(Ae, { as: "div", margin: "small 0", textAlign: "center", children: /* @__PURE__ */ E(In, { renderTitle: y.loading(), size: "small" }) })
          ] })
        }
      ),
      r && !a && /* @__PURE__ */ E(ue.Item, { overflowX: "auto", role: "group", "aria-label": (w = o[o.length - 1]) == null ? void 0 : w.message, children: /* @__PURE__ */ E(ue, { as: "div", margin: "xx-small 0", gap: "small", wrap: "wrap", children: i.map((b) => /* @__PURE__ */ E(ue.Item, { children: /* @__PURE__ */ E(
        ws,
        {
          prompt: b,
          onClick: () => {
            n(b), c == null || c(
              `prompt-${b.shortMessage.toLowerCase().replace(/\s+/g, "-")}`
            );
          },
          withBackground: f
        }
      ) }, b.id)) }) }),
      /* @__PURE__ */ E("div", { ref: k, style: { paddingBottom: "1rem" } })
    ] }),
    e && /* @__PURE__ */ E(
      eh,
      {
        onSend: s,
        disabled: a,
        isLoading: a,
        label: u ?? y.askAQuestion(),
        buttonLabel: p
      }
    )
  ] });
}, Ch = (e) => ({
  transitioning: `transition--${e}-transitioning`,
  exited: `transition--${e}-exited`,
  exiting: `transition--${e}-exiting`,
  entered: `transition--${e}-entered`,
  entering: `transition--${e}-entering`
}), $h = (e, t) => {
  const r = t.type, i = `opacity ${e.duration} ${e.timing}, transform ${e.duration} ${e.timing} !important`, n = {
    ".transition--fade-transitioning": {
      transition: i
    },
    ".transition--fade-exiting,\n      .transition--fade-exited": {
      opacity: 0.01
    },
    ".transition--fade-entering,\n      .transition--fade-entered": {
      opacity: 1
    }
  }, o = {
    ".transition--scale-transitioning": {
      transition: i
    },
    ".transition--scale-exiting,\n      .transition--scale-exited": {
      transform: "scale(0.01) translate3d(0, 0, 0)",
      opacity: 0.01
    },
    ".transition--scale-entering,\n      .transition--scale-entered": {
      transform: "scale(1) translate3d(0, 0, 0)",
      opacity: 1
    }
  }, a = {
    ".transition--slide-right-transitioning,\n      .transition--slide-left-transitioning,\n      .transition--slide-up-transitioning,\n      .transition--slide-down-transitioning": {
      transition: i
    },
    ".transition--slide-right-exited,\n      .transition--slide-left-exited,\n      .transition--slide-up-exited,\n      .transition--slide-down-exited": {
      opacity: 0.01
    },
    ".transition--slide-right-exiting,\n      .transition--slide-right-exited": {
      transform: "translate3d(100%, 0, 0)"
    },
    ".transition--slide-left-exiting,\n      .transition--slide-left-exited": {
      transform: "translate3d(-100%, 0, 0)"
    },
    ".transition--slide-up-exiting,\n      .transition--slide-up-exited": {
      transform: "translate3d(0, -100%, 0)"
    },
    ".transition--slide-down-exiting,\n      .transition--slide-down-exited": {
      transform: "translate3d(0, 100%, 0)"
    },
    ".transition--slide-left-entering,\n      .transition--slide-right-entering,\n      .transition--slide-up-entering,\n      .transition--slide-down-entering,\n      .transition--slide-left-entered,\n      .transition--slide-right-entered,\n      .transition--slide-up-entered,\n      .transition--slide-down-entered": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  };
  return {
    duration: e.duration,
    classNames: Ch(r),
    globalStyles: {
      ...n,
      ...o,
      ...a
    }
  };
}, Eh = (e) => {
  const t = e.transitions;
  return {
    ...{
      duration: t == null ? void 0 : t.duration,
      timing: t == null ? void 0 : t.timing
    }
  };
}, Ca = {
  in: l.bool,
  unmountOnExit: l.bool,
  transitionOnMount: l.bool,
  transitionEnter: l.bool,
  transitionExit: l.bool,
  onTransition: l.func,
  onEnter: l.func,
  onEntering: l.func,
  onEntered: l.func,
  onExit: l.func,
  onExiting: l.func,
  onExited: l.func,
  children: l.node,
  elementRef: l.func
}, Rh = {
  ...Ca,
  enterDelay: l.number,
  exitDelay: l.number,
  transitionClassName: l.string.isRequired,
  exitedClassName: l.string.isRequired,
  exitingClassName: l.string.isRequired,
  enteredClassName: l.string.isRequired,
  enteringClassName: l.string.isRequired,
  className: l.string
}, Ah = ["in", "unmountOnExit", "transitionOnMount", "transitionEnter", "transitionExit", "enterDelay", "exitDelay", "transitionClassName", "exitedClassName", "exitingClassName", "enteredClassName", "enteringClassName", "onTransition", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "children", "className", "elementRef"], ve = {
  EXITED: -2,
  EXITING: -1,
  ENTERING: 1,
  ENTERED: 2
};
class Nt extends ae {
  constructor(...t) {
    super(...t), this._timeouts = [], this._unmounted = !1, this.state = {
      transitioning: !1
    }, this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.startTransition = (r, i) => {
      const n = this.props, o = n.transitionEnter, a = n.transitionExit;
      r ? this.enter(o && i ? ve.EXITED : null) : this.exit(a && i ? ve.ENTERED : null);
    }, this.transition = (r, i, n, o = 0) => {
      if (this._unmounted) return;
      const a = this.props.onTransition, s = jn(this.ref), c = this.getTransitionClassName(r), u = this.getTransitionClassName(i), p = this.props.transitionClassName;
      i && o && this.transitionEnabled(r) ? p && s.add(p) : p && s.remove(p), u && s.remove(u), c && s.add(c), r && i && typeof a == "function" && a(r, i), this._timeouts.push(setTimeout(() => {
        this._unmounted || typeof n == "function" && n();
      }, o));
    }, this.enter = (r) => {
      if (this.state.transitioning || this._unmounted) return;
      const i = this.props;
      typeof i.onEnter == "function" && i.onEnter(), i.transitionEnter ? this.setState({
        transitioning: !0
      }, () => {
        const n = () => {
          typeof i.onEntering == "function" && i.onEntering(), this.transition(ve.ENTERED, ve.ENTERING, () => {
            this.setState({
              transitioning: !1
            }, () => {
              typeof i.onEntered == "function" && i.onEntered();
            });
          });
        };
        r ? this.transition(r, null, () => {
          this.transition(ve.ENTERING, r, n, i.enterDelay);
        }) : n();
      }) : this.setState({
        transitioning: !1
      }, () => {
        this.transition(ve.ENTERED, ve.EXITED), typeof i.onEntered == "function" && i.onEntered();
      });
    }, this.exit = (r) => {
      if (this.state.transitioning) return;
      const i = this.props;
      typeof i.onExit == "function" && i.onExit(), i.transitionExit ? this.setState({
        transitioning: !0
      }, () => {
        const n = () => {
          typeof i.onExiting == "function" && i.onExiting(), this.transition(ve.EXITED, ve.EXITING, () => {
            this.setState({
              transitioning: !1
            }, () => {
              typeof i.onExited == "function" && i.onExited();
            });
          });
        };
        r ? this.transition(r, null, () => {
          this.transition(ve.EXITING, r, n, i.exitDelay);
        }) : n();
      }) : this.setState({
        transitioning: !1
      }, () => {
        this.transition(ve.EXITED, ve.ENTERED), typeof i.onExited == "function" && i.onExited();
      });
    };
  }
  componentDidMount() {
    this.startTransition(this.props.in, this.props.transitionOnMount), this._unmounted = !1;
  }
  getSnapshotBeforeUpdate(t, r) {
    return this.props.in !== t.in && r.transitioning ? !0 : null;
  }
  componentDidUpdate(t, r, i) {
    i && this.clearTransition(t.transitionClassName), this.props.transitionClassName !== t.transitionClassName && this.clearTransition(t.transitionClassName), t.in !== this.props.in && (r.transitioning ? (this.clearTransition(t.transitionClassName), clearTimeout(this._timeouts.pop()), this.setState({
      transitioning: !1
    }, () => this.startTransition(this.props.in, !0))) : this.startTransition(this.props.in, !0));
  }
  componentWillUnmount() {
    this._timeouts.forEach((t) => {
      clearTimeout(t);
    }), this._unmounted = !0;
  }
  clearTransition(t) {
    this._unmounted || this.setState({
      transitioning: !1
    }, () => {
      if (this._unmounted) return;
      const r = jn(this.ref);
      Object.values(ve).forEach((i) => {
        const n = this.getTransitionClassName(i);
        n && r.remove(n);
      }), r.remove(t);
    });
  }
  transitionEnabled(t) {
    const r = this.props;
    switch (t) {
      case ve.EXITED:
      case ve.EXITING:
        return r.transitionExit;
      case ve.ENTERED:
      case ve.ENTERING:
        return r.transitionEnter;
      default:
        return !1;
    }
  }
  getTransitionClassName(t) {
    const r = this.props;
    switch (t) {
      case ve.EXITED:
        return r.exitedClassName;
      case ve.ENTERING:
        return r.enteringClassName;
      case ve.ENTERED:
        return r.enteredClassName;
      case ve.EXITING:
        return r.exitingClassName;
      default:
        return;
    }
  }
  renderChildren() {
    return this.props.children ? Ht(dr(this.props.children), {
      "aria-hidden": this.props.in ? void 0 : !0,
      ref: (t) => {
        const r = Pe(t) || null;
        this.handleRef(r);
      }
    }) : null;
  }
  render() {
    return !this.props.in && this.props.unmountOnExit && !this.state.transitioning ? null : this.renderChildren();
  }
}
Nt.displayName = "BaseTransition";
Nt.propTypes = Rh;
Nt.allowedProps = Ah;
Nt.defaultProps = {
  in: !1,
  unmountOnExit: !1,
  transitionOnMount: !1,
  transitionEnter: !0,
  transitionExit: !0,
  enterDelay: 300,
  exitDelay: 300
};
Nt.states = ve;
const Ih = ["fade", "scale", "slide-down", "slide-up", "slide-left", "slide-right"], Oh = l.oneOf(Ih), Bh = {
  type: Oh,
  ...Ca
}, Ph = ["type", "children", "in", "unmountOnExit", "transitionOnMount", "transitionEnter", "transitionExit", "onTransition", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "elementRef"], Dh = ["type", "children", "styles"];
var xs, Ss, Wr, vt;
let Mh = (xs = fe($h, Eh), Ss = ft(), xs(Wr = Ss(Wr = (vt = class extends ae {
  constructor(...t) {
    super(...t), this.ref = null, this.handleRef = (r) => {
      const i = this.props.elementRef;
      this.ref = r, typeof i == "function" && i(r);
    }, this.handleExited = () => {
      typeof this.props.onExited == "function" && this.props.onExited(this.props.type);
    }, this.handleEntered = () => {
      typeof this.props.onEntered == "function" && this.props.onEntered(this.props.type);
    }, this.renderTransitionHelper = () => {
      const r = this.props.styles;
      return B(Vd, {
        styles: r == null ? void 0 : r.globalStyles
      });
    };
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  componentDidUpdate() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
  }
  render() {
    const t = this.props;
    t.type;
    const r = t.children, i = t.styles, n = Se(t, Dh), o = yl(i.duration);
    return Re(Dd, {
      children: [this.renderTransitionHelper(), B(Nt, {
        ...n,
        enterDelay: o,
        exitDelay: o,
        transitionClassName: i.classNames.transitioning,
        exitedClassName: i.classNames.exited,
        exitingClassName: i.classNames.exiting,
        enteredClassName: i.classNames.entered,
        enteringClassName: i.classNames.entering,
        onEntered: this.handleEntered,
        onExited: this.handleExited,
        elementRef: this.handleRef,
        children: r
      })]
    });
  }
}, vt.displayName = "Transition", vt.componentId = "Transition", vt.allowedProps = Ph, vt.propTypes = Bh, vt.defaultProps = {
  type: "fade",
  in: !1,
  unmountOnExit: !1,
  transitionOnMount: !1,
  transitionEnter: !0,
  transitionExit: !0
}, vt.states = Nt.states, vt)) || Wr) || Wr);
const Fh = (e, t) => {
  const r = t.variant, i = t.hasShadow, n = {
    error: {
      alert: {
        borderColor: e.dangerBorderColor
      },
      icon: {
        background: e.dangerIconBackground,
        borderRightColor: e.dangerIconBackground
      }
    },
    info: {
      alert: {
        borderColor: e.infoBorderColor
      },
      icon: {
        background: e.infoIconBackground,
        borderRightColor: e.infoIconBackground
      }
    },
    success: {
      alert: {
        borderColor: e.successBorderColor
      },
      icon: {
        backgroundColor: e.successIconBackground,
        borderRightColor: e.successIconBackground
      }
    },
    warning: {
      alert: {
        borderColor: e.warningBorderColor
      },
      icon: {
        background: e.warningIconBackground,
        borderRightColor: e.warningIconBackground
      }
    }
  };
  return {
    alert: {
      label: "alert",
      color: e.color,
      background: e.background,
      boxSizing: "border-box",
      display: "flex",
      minWidth: "12rem",
      borderWidth: e.borderWidth,
      borderStyle: e.borderStyle,
      borderRadius: e.borderRadius,
      ...n[r].alert,
      ...i && {
        boxShadow: e.boxShadow
      }
    },
    icon: {
      color: e.iconColor,
      boxSizing: "border-box",
      flex: "0 0 2.5rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.125rem",
      borderRight: `${e.borderWidth} ${e.borderStyle}`,
      margin: -1,
      borderStartStartRadius: e.borderRadius,
      borderEndStartRadius: e.borderRadius,
      ...n[r].icon
    },
    closeButton: {
      boxSizing: "border-box",
      display: "flex",
      alignItems: "flex-start",
      order: 1,
      marginTop: e.closeButtonMarginTop,
      marginRight: e.closeButtonMarginRight
    },
    content: {
      boxSizing: "border-box",
      flex: 1,
      minWidth: "0.0625rem",
      fontSize: e.contentFontSize,
      fontFamily: e.contentFontFamily,
      fontWeight: e.contentFontWeight,
      lineHeight: e.contentLineHeight,
      padding: e.contentPadding
    },
    variantScreenReaderLabel: {
      position: "absolute",
      height: "1px",
      width: "1px",
      overflow: "hidden",
      margin: "-1px"
    }
  };
}, zh = (e) => {
  var t, r, i, n, o, a, s, c, u, p, v;
  const d = e.colors, g = e.spacing, f = e.borders, h = e.typography, y = e.shadows, k = e.key, A = {
    canvas: {
      color: e["ic-brand-font-color-dark"]
    }
  };
  return {
    ...{
      background: d == null || (t = d.contrasts) === null || t === void 0 ? void 0 : t.white1010,
      color: d == null || (r = d.contrasts) === null || r === void 0 ? void 0 : r.grey125125,
      marginTop: g == null ? void 0 : g.small,
      borderRadius: f == null ? void 0 : f.radiusMedium,
      borderWidth: f == null ? void 0 : f.widthMedium,
      borderStyle: f == null ? void 0 : f.style,
      contentPadding: `${g == null ? void 0 : g.small} ${g == null ? void 0 : g.medium}`,
      contentFontSize: h == null ? void 0 : h.fontSizeMedium,
      contentFontFamily: h == null ? void 0 : h.fontFamily,
      contentFontWeight: h == null ? void 0 : h.fontWeightNormal,
      contentLineHeight: h == null ? void 0 : h.lineHeightCondensed,
      closeButtonMarginTop: g == null ? void 0 : g.xSmall,
      closeButtonMarginRight: g == null ? void 0 : g.xxSmall,
      iconColor: d == null || (i = d.contrasts) === null || i === void 0 ? void 0 : i.white1010,
      successBorderColor: d == null || (n = d.contrasts) === null || n === void 0 ? void 0 : n.green4570,
      successIconBackground: d == null || (o = d.contrasts) === null || o === void 0 ? void 0 : o.green4570,
      infoBorderColor: d == null || (a = d.contrasts) === null || a === void 0 ? void 0 : a.blue4570,
      infoIconBackground: d == null || (s = d.contrasts) === null || s === void 0 ? void 0 : s.blue4570,
      warningBorderColor: d == null || (c = d.contrasts) === null || c === void 0 ? void 0 : c.orange4570,
      warningIconBackground: d == null || (u = d.contrasts) === null || u === void 0 ? void 0 : u.orange4570,
      dangerBorderColor: d == null || (p = d.contrasts) === null || p === void 0 ? void 0 : p.red4570,
      dangerIconBackground: d == null || (v = d.contrasts) === null || v === void 0 ? void 0 : v.red4570,
      boxShadow: y == null ? void 0 : y.depth2
    },
    ...A[k]
  };
}, Th = {
  children: l.node,
  variant: l.oneOf(["info", "success", "warning", "error"]),
  margin: l.string,
  liveRegion: l.oneOfType([l.func, l.element]),
  liveRegionPoliteness: l.oneOf(["polite", "assertive"]),
  isLiveRegionAtomic: l.bool,
  screenReaderOnly: l.bool,
  timeout: l.number,
  renderCloseButtonLabel: l.oneOfType([l.func, l.node]),
  onDismiss: l.func,
  transition: l.oneOf(["none", "fade"]),
  open: l.bool,
  hasShadow: l.bool,
  variantScreenReaderLabel: l.string,
  renderCustomIcon: l.oneOfType([l.node, l.func])
}, Lh = ["children", "variant", "margin", "liveRegion", "liveRegionPoliteness", "isLiveRegionAtomic", "screenReaderOnly", "timeout", "renderCloseButtonLabel", "onDismiss", "transition", "open", "hasShadow", "renderCustomIcon"], Hh = ["margin", "styles", "children", "onDismiss", "variantScreenReaderLabel"];
var ks, _s, Gr, Lt;
let $a = (ks = di(), _s = fe(Fh, zh), ks(Gr = _s(Gr = (Lt = class extends ae {
  constructor(t) {
    super(t), this._timeouts = [], this.srid = void 0, this.variantUI = {
      error: Ga,
      info: Wa,
      success: Na,
      warning: Ha
    }, this.ref = null, this.handleRef = (r) => {
      this.ref = r;
    }, this.handleTimeout = () => {
      this.props.timeout > 0 && this._timeouts.push(setTimeout(() => {
        this.close();
      }, this.props.timeout));
    }, this.onExitTransition = () => {
      this.props.onDismiss && this.props.onDismiss();
    }, this.close = () => {
      this.clearTimeouts(), this.removeScreenreaderAlert(), this.setState({
        open: !1
      }, () => {
        this.props.onDismiss && (this.props.transition === "none" || this.props.screenReaderOnly) && this.props.onDismiss();
      });
    }, this.handleKeyUp = (r) => {
      this.props.renderCloseButtonLabel && r.keyCode === ha.codes.esc && this.close();
    }, this.srid = this.props.deterministicId(), this.state = {
      open: !0
    };
  }
  clearTimeouts() {
    this._timeouts.forEach((t) => clearTimeout(t)), this._timeouts = [];
  }
  // duck type for a dom node
  isDOMNode(t) {
    return t && typeof t == "object" && t.nodeType === 1;
  }
  getLiveRegion() {
    const t = typeof this.props.liveRegion == "function" ? this.props.liveRegion() : this.props.liveRegion;
    return this.isDOMNode(t) ? t : null;
  }
  initLiveRegion(t) {
    Xe(t.getAttribute("role") === "alert", "[Alert] live region must have role='alert' set on page load in order to announce content"), t && (t.setAttribute("aria-live", this.props.liveRegionPoliteness), t.setAttribute("aria-relevant", "additions text"), t.setAttribute("aria-atomic", `${this.props.isLiveRegionAtomic}`));
  }
  createScreenreaderContentNode() {
    return Re(bt, {
      children: [this.props.variantScreenReaderLabel || "", " ", this.props.children]
    });
  }
  createScreenreaderAlert() {
    const t = this.getLiveRegion();
    if (t) {
      const r = document.createElement("div");
      r.setAttribute("id", this.srid), t.appendChild(r);
    }
  }
  removeScreenreaderAlert() {
    const t = this.getLiveRegion();
    t && document.getElementById(this.srid) && (t.removeAttribute("aria-live"), t.removeAttribute("aria-relevant"), t.removeAttribute("aria-atomic"), this.initLiveRegion(t));
  }
  componentDidMount() {
    var t, r;
    (t = (r = this.props).makeStyles) === null || t === void 0 || t.call(r);
    const i = this.getLiveRegion();
    i && this.initLiveRegion(i), this.handleTimeout();
  }
  componentWillUnmount() {
    this.clearTimeouts();
  }
  componentDidUpdate(t) {
    var r, i;
    (r = (i = this.props).makeStyles) === null || r === void 0 || r.call(i), !this.props.open && !!this.props.open != !!t.open && this.close();
  }
  renderIcon() {
    const t = this.props, r = t.renderCustomIcon, i = t.variant, n = t.styles, o = this.variantUI[i];
    return B("div", {
      css: n == null ? void 0 : n.icon,
      children: r ? Jt(r) : B(o, {})
    });
  }
  renderCloseButton() {
    var t;
    const r = this.props.renderCloseButtonLabel && Jt(this.props.renderCloseButtonLabel);
    return r ? B("div", {
      css: (t = this.props.styles) === null || t === void 0 ? void 0 : t.closeButton,
      children: B(Ju, {
        onClick: this.close,
        size: "small",
        screenReaderLabel: r
      })
    }, "closeButton") : null;
  }
  renderAlert() {
    const t = this.props, r = t.margin, i = t.styles, n = t.children;
    t.onDismiss;
    const o = t.variantScreenReaderLabel, a = Se(t, Hh);
    return Re(Ae, {
      ...it({
        ...a
      }),
      as: "div",
      margin: r,
      css: i == null ? void 0 : i.alert,
      onKeyUp: this.handleKeyUp,
      elementRef: this.handleRef,
      children: [this.renderIcon(), Re("div", {
        css: i == null ? void 0 : i.content,
        children: [o && B("span", {
          css: i == null ? void 0 : i.variantScreenReaderLabel,
          children: o
        }), n]
      }), this.renderCloseButton()]
    });
  }
  createScreenReaderPortal(t) {
    return this.state.open ? /* @__PURE__ */ Is.createPortal(B("div", {
      id: this.srid,
      children: this.createScreenreaderContentNode()
    }), t) : null;
  }
  render() {
    const t = this.getLiveRegion(), r = t ? this.createScreenReaderPortal(t) : null;
    return this.props.screenReaderOnly ? (Xe(!!this.getLiveRegion(), "[Alert] The 'screenReaderOnly' prop must be used in conjunction with 'liveRegion'."), r) : this.props.transition === "none" ? this.state.open ? Re(Kr, {
      children: [r, this.renderAlert()]
    }) : null : Re(Kr, {
      children: [r, B(Mh, {
        type: this.props.transition,
        transitionOnMount: !0,
        in: this.state.open,
        unmountOnExit: !0,
        onExited: this.onExitTransition,
        children: this.renderAlert()
      })]
    });
  }
}, Lt.displayName = "Alert", Lt.componentId = "Alert", Lt.propTypes = Th, Lt.allowedProps = Lh, Lt.defaultProps = {
  variant: "info",
  margin: "x-small 0",
  timeout: 0,
  transition: "fade",
  open: !0,
  screenReaderOnly: !1,
  liveRegionPoliteness: "assertive",
  isLiveRegionAtomic: !1,
  children: null,
  hasShadow: !0
}, Lt)) || Gr) || Gr);
const Cs = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  padding: "24px",
  borderRadius: "inherit",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  backfaceVisibility: "hidden",
  WebkitBackfaceVisibility: "hidden"
}, $s = {
  width: "100%",
  borderRadius: "inherit",
  wordBreak: "break-word"
}, Nh = (e, t) => ({
  position: "relative",
  width: "100%",
  height: "100%",
  cursor: "pointer",
  borderRadius: e,
  transformStyle: "preserve-3d",
  transition: "transform 0.45s ease",
  transform: t ? "perspective(1000px) rotateY(180deg)" : "perspective(1000px) rotateY(0deg)"
}), Wh = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  alignItems: "center",
  gap: "2rem"
}, Gh = (e, t) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "center",
  height: e,
  maxWidth: t
}), Vh = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.75rem",
  width: "100%"
}, jh = {
  gap: "24px",
  width: "100%",
  height: "44px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center"
}, Uh = {
  color: "white"
}, Ea = (e) => ({
  opacity: 0,
  boxShadow: "none",
  pointerEvents: "none",
  visibility: "hidden",
  background: "transparent",
  display: "block",
  transition: "transform 0.24s ease, opacity 0.12s linear",
  zIndex: 5,
  width: "0px",
  ...e
}), Es = Ea({ right: "unset" }), Rs = Ea({ left: "unset" }), qh = {
  zIndex: 6,
  boxShadow: "none",
  background: "transparent",
  display: "block",
  transformStyle: "preserve-3d",
  transition: "transform 0.24s ease, opacity 0.12s linear"
};
function As({
  frontHTML: e,
  frontCardStyle: t,
  frontContentStyle: r,
  backHTML: i,
  backCardStyle: n,
  backContentStyle: o,
  className: a = "",
  style: s,
  borderRadius: c = "1rem",
  width: u
}) {
  const [p, v] = we(!1);
  return /* @__PURE__ */ E(
    "div",
    {
      "data-flashcard": "true",
      className: a,
      style: { position: "relative", width: u ?? "100%", height: "100%", ...s },
      children: /* @__PURE__ */ be(
        "div",
        {
          role: "button",
          tabIndex: 0,
          style: Nh(c, p),
          onClick: () => v(!p),
          onKeyDown: (d) => {
            (d.key === "Enter" || d.key === " ") && (d.preventDefault(), v(!p));
          },
          children: [
            /* @__PURE__ */ E("div", { style: { ...Cs, ...t }, "aria-hidden": p, children: /* @__PURE__ */ E("div", { style: { ...$s, ...r }, children: e }) }),
            /* @__PURE__ */ E(
              "div",
              {
                style: {
                  ...Cs,
                  ...n,
                  transform: "rotateY(-180deg)"
                },
                "aria-hidden": !p,
                children: /* @__PURE__ */ E("div", { style: { ...$s, ...o }, children: i })
              }
            )
          ]
        }
      )
    }
  );
}
function Yh({
  cards: e,
  controls: t = !0,
  showCount: r = !0,
  frontCardStyle: i = {},
  frontContentStyle: n = {},
  backCardStyle: o = {},
  backContentStyle: a = {},
  FlashcardArrayStyle: s = {},
  cycle: c = !1,
  cardIndex: u = 0,
  onCardChange: p,
  footer: v,
  cardHeight: d = 300,
  cardMaxWidth: g = "100%"
}) {
  const f = Wt(), [h, y] = we(
    c ? [e.length - 1, 0, 1] : [-1, 0, 1]
  ), k = e.length > 0 ? e.length - 1 : 0, A = ye(
    (_, D, F) => {
      const H = e[_];
      return H ? /* @__PURE__ */ E(
        As,
        {
          id: H.id,
          frontHTML: H.frontHTML,
          backHTML: H.backHTML,
          frontCardStyle: { ...H.frontCardStyle, ...i },
          frontContentStyle: { ...H.frontContentStyle, ...n },
          backCardStyle: { ...H.backCardStyle, ...o },
          backContentStyle: { ...H.backContentStyle, ...a },
          className: H.className,
          width: H.width || "100%",
          style: { ...H.style, ...F }
        },
        D
      ) : null;
    },
    [e, i, n, o, a]
  );
  tr(() => {
    if (!c)
      y(u === 0 ? [-1, 0, 1] : u === k ? [k - 1, k, -1] : [u - 1, u, u + 1]);
    else {
      const _ = u - 1 >= 0 ? u - 1 : e.length - 1, D = u + 1 < e.length ? u + 1 : 0;
      y([_, u, D]);
    }
  }, [u, c, e.length, k]);
  const x = ye(
    (_) => {
      p == null || p(_);
    },
    [p]
  ), w = (_, D) => /* @__PURE__ */ E(As, { id: "filler", backHTML: "", frontHTML: "", style: D }, _), b = ye(() => {
    const _ = u + 1 < k ? u + 1 : k;
    if (c) {
      const D = h[1] + 1 < e.length ? h[1] + 1 : 0;
      x(D), y((F) => [
        F[0] + 1 < e.length ? F[0] + 1 : 0,
        F[1] + 1 < e.length ? F[1] + 1 : 0,
        F[2] + 1 < e.length ? F[2] + 1 : 0
      ]);
    } else
      x(_), y(
        _ < k ? [_ - 1, _, _ + 1] : [k - 1, k, -1]
      );
  }, [u, c, k, e, h, x]), C = ye(() => {
    const _ = u - 1 >= 0 ? u - 1 : 0;
    if (c) {
      const D = h[1] - 1 >= 0 ? h[1] - 1 : e.length - 1;
      x(D), y((F) => {
        const H = F[1] - 1 < 0 ? e.length - 1 : F[1] - 1;
        return [
          H - 1 < 0 ? e.length - 1 : H - 1,
          H,
          H + 1 < e.length ? H + 1 : 0
        ];
      });
    } else
      x(_), y(
        _ === 0 ? [-1, 0, 1] : [_ - 1, _, _ + 1]
      );
  }, [u, c, e, h, x]), S = !c && u === 0, Y = !c && u === k;
  return /* @__PURE__ */ be("div", { style: { ...Wh, ...s }, children: [
    /* @__PURE__ */ be("div", { style: Gh(d, g), children: [
      h[0] !== -1 ? A(h[0], "slot-prev", Es) : w("slot-filler-prev", Es),
      A(h[1], "slot-current", qh),
      h[2] !== -1 ? A(h[2], "slot-next", Rs) : w("slot-filler-next", Rs)
    ] }),
    /* @__PURE__ */ be("div", { style: { ...Vh, maxWidth: g }, children: [
      (t || r) && /* @__PURE__ */ be("div", { style: jh, children: [
        t && /* @__PURE__ */ E(
          mr,
          {
            screenReaderLabel: f.previousCard(),
            size: "small",
            onClick: C,
            interaction: S ? "disabled" : "enabled",
            withBackground: !0,
            withBorder: !1,
            color: "primary-inverse",
            children: /* @__PURE__ */ E(Va, {})
          }
        ),
        r && /* @__PURE__ */ be("span", { style: Uh, children: [
          u + 1,
          " of ",
          e.length
        ] }),
        t && /* @__PURE__ */ E(
          mr,
          {
            screenReaderLabel: f.nextCard(),
            size: "small",
            onClick: b,
            interaction: Y ? "disabled" : "enabled",
            withBackground: !0,
            withBorder: !1,
            color: "primary-inverse",
            children: /* @__PURE__ */ E(ja, {})
          }
        )
      ] }),
      v
    ] })
  ] });
}
const Qi = 5, Vr = {
  surfaceAssistBackground: "linear-gradient(135deg, #8c6fb4 0%, #6b8fb4 60%, #5aa2ae 100%)",
  surfaceCardPrimary: "white",
  textSurfaceColored: "white",
  textSurfaceBack: "var(--color-text-primary, #2d3b45)"
};
function Xh({
  cardData: e,
  isFetching: t,
  isError: r,
  getFlashCards: i,
  renderFlashCards: n,
  isDesktop: o = !0,
  announceForScreenReader: a,
  cardTheme: s,
  cardHeight: c,
  cardMaxWidth: u,
  onAnalyticsEvent: p,
  thumbsColor: v
}) {
  const d = Wt(), [g, f] = we(0), [h, y] = we(0), [k, A] = we(0);
  tr(() => {
    f(0), y(0);
  }, [e]);
  const x = zn(() => {
    try {
      const D = o ? d.clickToFlip() : d.tapToFlip();
      return e.filter((F) => {
        const H = typeof F == "object" && F !== null && typeof F.question == "string" && typeof F.answer == "string";
        return H || console.error("Invalid card structure", F), H;
      }).map((F) => ({
        id: Qr(),
        frontCardStyle: {
          background: (s == null ? void 0 : s.surfaceAssistBackground) ?? Vr.surfaceAssistBackground,
          color: (s == null ? void 0 : s.textSurfaceColored) ?? Vr.textSurfaceColored
        },
        frontHTML: /* @__PURE__ */ be(Er, { children: [
          /* @__PURE__ */ E(qe, { size: "medium", style: { color: "inherit" }, children: d.question() }),
          /* @__PURE__ */ E(qe, { size: "large", weight: "bold", style: { color: "inherit" }, children: F.question }),
          /* @__PURE__ */ E(qe, { size: "small", style: { color: "inherit" }, children: D })
        ] }),
        frontContentStyle: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%"
        },
        backHTML: /* @__PURE__ */ be(Er, { children: [
          /* @__PURE__ */ E(qe, { size: "medium", style: { color: "inherit" }, children: d.answer() }),
          /* @__PURE__ */ E(qe, { size: "large", weight: "bold", style: { color: "inherit" }, children: F.answer }),
          /* @__PURE__ */ E(qe, { size: "small", style: { color: "inherit" }, children: D })
        ] }),
        backContentStyle: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%"
        },
        backCardStyle: {
          background: (s == null ? void 0 : s.surfaceCardPrimary) ?? Vr.surfaceCardPrimary,
          color: (s == null ? void 0 : s.textSurfaceBack) ?? (s == null ? void 0 : s.textSurfaceColored) ?? Vr.textSurfaceBack
        }
      })) ?? [];
    } catch (D) {
      const F = D instanceof Error ? D.message : "Unknown error";
      return [
        {
          id: Qr(),
          frontHTML: /* @__PURE__ */ E(Er, { children: F }),
          frontContentStyle: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            color: s == null ? void 0 : s.textSurfaceColored
          },
          backHTML: /* @__PURE__ */ E(Er, {})
        }
      ];
    }
  }, [e, o, s, d]), w = zn(() => {
    const D = g * Qi, F = D + Qi;
    return x.slice(D, F);
  }, [x, g]), C = !((g + 1) * Qi < x.length), S = ye(() => {
    C ? (i(), A((D) => D + 1)) : f((D) => D + 1), y(0), a == null || a(
      d.flashcardsRegenerated(void 0, { count: w.length })
    );
  }, [C, i, a, d, w.length]);
  if (t)
    return /* @__PURE__ */ E(ue, { as: "div", justifyItems: "center", children: /* @__PURE__ */ E(In, { renderTitle: d.loading(), size: "small" }) });
  if (r)
    return /* @__PURE__ */ E(Ae, { as: "div", children: /* @__PURE__ */ E($a, { variant: "error", margin: "small 0", children: d.failedToLoadFlashcards() }) });
  const Y = x.length > 0 ? /* @__PURE__ */ be(ue, { as: "div", direction: "column", justifyItems: "center", width: "100%", children: [
    /* @__PURE__ */ E(ue, { justifyItems: "end", children: /* @__PURE__ */ E(
      _a,
      {
        onAnalyticsEvent: p,
        color: v
      },
      `${g}-${k}`
    ) }),
    /* @__PURE__ */ E(
      br,
      {
        color: "primary-inverse",
        size: "large",
        onClick: S,
        interaction: t ? "disabled" : "enabled",
        children: /* @__PURE__ */ E(qe, { size: "medium", weight: "bold", children: d.regenerateFlashcards() })
      }
    )
  ] }) : void 0;
  return /* @__PURE__ */ E(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        padding: "0 0 1rem 0"
      },
      children: n ? n({
        cards: w,
        cycle: !0,
        controls: !0,
        cardIndex: h,
        onCardChange: y,
        footer: Y
      }) : /* @__PURE__ */ E(
        Yh,
        {
          cards: w,
          cycle: !0,
          controls: !0,
          cardIndex: h,
          onCardChange: y,
          footer: Y,
          cardHeight: c,
          cardMaxWidth: u
        }
      )
    }
  );
}
const Ra = {
  position: "absolute",
  width: "1px",
  height: "1px",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  whiteSpace: "nowrap"
}, Kh = {
  border: "none",
  margin: 0,
  padding: 0
}, Qh = { ...Ra }, Zh = {
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  outline: "none"
}, Jh = { ...Ra }, ep = {
  width: "24px",
  height: "24px",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, tp = {
  width: "24px",
  height: "24px",
  display: "inline-block"
}, rp = {
  pending: {
    background: "transparent",
    color: "var(--color-white, #ffffff)",
    borderColor: "var(--color-white, #ffffff)"
  },
  selected: {
    background: "var(--color-white, #ffffff)",
    color: "var(--color-text-primary, #2d3b45)",
    borderColor: "var(--color-white, #ffffff)"
  },
  correct: {
    background: "var(--color-white, #ffffff)",
    color: "var(--color-text-success, #127a1b)",
    borderColor: "var(--color-white, #ffffff)"
  },
  incorrect: {
    background: "var(--color-white, #ffffff)",
    color: "var(--color-text-danger, #c01b1b)",
    borderColor: "var(--color-white, #ffffff)"
  }
}, ip = (e, t, r) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "1px solid",
  cursor: t ? "default" : "pointer",
  borderRadius: "16px",
  padding: "16px",
  transition: "all 0.2s ease-in-out",
  ...rp[e],
  ...r ? { outline: "2px solid var(--color-white, #ffffff)", outlineOffset: "2px" } : {}
}), np = {
  pending: null,
  selected: "check",
  correct: "circle-check",
  incorrect: "circle-x"
}, op = (e, t, r, i) => {
  const n = t === e, o = e === r;
  return i ? t === r ? n || o ? "correct" : "pending" : n ? "incorrect" : o ? "correct" : "pending" : n ? "selected" : "pending";
};
function sp({ status: e }) {
  const t = np[e];
  return t ? t === "check" ? /* @__PURE__ */ E(Ua, {}) : t === "circle-check" ? /* @__PURE__ */ E(qa, {}) : /* @__PURE__ */ E(Ya, {}) : /* @__PURE__ */ E("span", { style: tp });
}
function ap({
  question: e,
  options: t,
  result: r,
  onRegenerate: i
}) {
  const n = Wt(), [o, a] = we(-1), [s, c] = we(!1), [u, p] = we(""), [v, d] = we(-1), g = Ia(), f = ye((w) => {
    a(Number(w.target.value)), c(!1);
  }, []), h = ye((w) => {
    w.key === "Enter" && (a(Number(w.currentTarget.value)), c(!1));
  }, []), y = ye((w) => {
    w.target.matches(":focus-visible") && d(Number(w.currentTarget.dataset.index));
  }, []), k = ye(() => {
    d(-1);
  }, []), A = ye(() => {
    var w;
    if (c(!0), o === r)
      p(n.correctAnswer());
    else {
      const b = ((w = t[r]) == null ? void 0 : w.label) ?? "";
      p(n.incorrectAnswer(void 0, { correctLabel: b }));
    }
  }, [o, r, t, n]), x = ye(() => {
    c(!1), a(-1), p(n.questionRegenerated()), i();
  }, [i, n]);
  return /* @__PURE__ */ be(ue, { direction: "column", justifyItems: "space-between", height: "100%", children: [
    /* @__PURE__ */ be("fieldset", { style: Kh, disabled: s, children: [
      /* @__PURE__ */ E("legend", { style: Qh, children: e }),
      /* @__PURE__ */ E(ue, { direction: "column", gap: "x-small", children: t.map((w, b) => {
        const C = op(b, o, r, s);
        return /* @__PURE__ */ be(
          "label",
          {
            style: ip(C, s, v === b),
            children: [
              /* @__PURE__ */ E(
                "input",
                {
                  type: "radio",
                  name: g,
                  value: w.value,
                  checked: o === w.value,
                  "data-index": b,
                  onChange: f,
                  onKeyDown: h,
                  onFocus: y,
                  onBlur: k,
                  style: Zh
                }
              ),
              /* @__PURE__ */ E("span", { children: w.label }),
              /* @__PURE__ */ E("span", { style: ep, "aria-hidden": "true", children: /* @__PURE__ */ E(sp, { status: C }) })
            ]
          },
          w.value
        );
      }) })
    ] }),
    /* @__PURE__ */ E("div", { "aria-live": "polite", style: Jh, children: u }),
    /* @__PURE__ */ be(ue, { direction: "column", gap: "x-small", margin: "medium 0 0 0", children: [
      !s && /* @__PURE__ */ E(
        br,
        {
          color: "primary-inverse",
          focusColor: "inverse",
          display: "block",
          onClick: A,
          interaction: o === -1 ? "disabled" : "enabled",
          children: n.checkAnswer()
        }
      ),
      /* @__PURE__ */ E(
        br,
        {
          color: "primary-inverse",
          focusColor: "inverse",
          display: "block",
          withBackground: s,
          onClick: x,
          children: n.regenerate()
        }
      )
    ] })
  ] });
}
function lp({
  quiz: e,
  isFetching: t,
  isError: r,
  getQuiz: i,
  textColor: n
}) {
  const o = Wt(), [a, s] = we(0), c = ye(() => {
    a >= e.length - 1 ? i() : s((v) => v + 1);
  }, [a, e, i]);
  if (t)
    return /* @__PURE__ */ E(ue, { as: "div", justifyItems: "center", children: /* @__PURE__ */ E(In, { renderTitle: o.loading(), size: "small" }) });
  if (r)
    return /* @__PURE__ */ E($a, { variant: "error", margin: "small 0", children: o.failedToLoadQuiz() });
  const u = e[a];
  return u ? /* @__PURE__ */ E("div", { style: n ? { color: n } : void 0, children: /* @__PURE__ */ be(ue, { direction: "column", gap: "small", height: "100%", children: [
    /* @__PURE__ */ E(qe, { color: "primary", themeOverride: n ? { primaryColor: n } : void 0, children: u.question }),
    /* @__PURE__ */ E(
      ap,
      {
        question: u.question,
        options: u.answers.map((v, d) => ({ value: d, label: v })),
        result: u.correctAnswerIndex,
        onRegenerate: c
      }
    )
  ] }) }) : null;
}
const _p = ({
  chatEnabled: e = !0,
  showLargePrompts: t,
  onAnalyticsEvent: r,
  inputLabel: i,
  inputButtonLabel: n,
  thumbsColor: o,
  renderMessage: a,
  renderRichContent: s,
  renderFlashCards: c,
  allowedPrompts: u,
  promptButtonWithBackground: p,
  textColor: v = "white"
}) => {
  const {
    chats: d,
    quiz: g,
    flashCards: f,
    isLoading: h,
    assistPrompts: y,
    announce: k,
    handlePromptInteraction: A,
    handleSubmitInteraction: x,
    getFlashCards: w,
    getQuiz: b,
    activateAssist: C
  } = tl();
  tr(() => C(), [C]);
  const S = g.length > 0, Y = f.length > 0, _ = d.some((he) => he.actor === He.User), D = d.some((he) => he.actor === He.Assistant), F = (t ?? !e) && !_, H = (e || D) && _, me = Array.isArray(u) ? y.filter((he) => u.includes(he.shortMessage)) : y;
  let oe;
  return S ? oe = /* @__PURE__ */ E(
    lp,
    {
      quiz: g,
      isFetching: h,
      isError: !1,
      getQuiz: b,
      textColor: v
    }
  ) : Y ? oe = c ? c(f, h, !1, w) : /* @__PURE__ */ E(
    Xh,
    {
      cardData: f,
      isFetching: h,
      isError: !1,
      getFlashCards: w,
      announceForScreenReader: k,
      onAnalyticsEvent: r,
      thumbsColor: o
    }
  ) : oe = /* @__PURE__ */ E(
    _h,
    {
      chatEnabled: e,
      showLargePrompts: F,
      showSmallPrompts: H,
      assistPrompts: me,
      handlePromptInteraction: A,
      chats: d,
      isLoading: h,
      onSubmit: x,
      onAnalyticsEvent: r,
      inputLabel: i,
      inputButtonLabel: n,
      thumbsColor: o,
      renderMessage: a,
      renderRichContent: s,
      promptButtonWithBackground: p,
      textColor: v
    }
  ), oe;
};
export {
  _p as AssistContent,
  Xh as AssistFlashCardsInteraction,
  hp as AssistProvider,
  As as Flashcard,
  Yh as FlashcardArray,
  Os as defaultTranslations,
  tl as useAssistContext
};
